window.vehiclesData = {
  "1974": {
    "Audi": [
      "Fox"
    ],
    "Volkswagen": [
      "Dasher"
    ]
  },
  "1975": {
    "Audi": [
      "Fox"
    ],
    "Volkswagen": [
      "Dasher"
    ]
  },
  "1976": {
    "Audi": [
      "Fox"
    ],
    "Volkswagen": [
      "Dasher"
    ]
  },
  "1977": {
    "Audi": [
      "Fox"
    ],
    "Volkswagen": [
      "Dasher"
    ]
  },
  "1978": {
    "Audi": [
      "Fox"
    ],
    "Volkswagen": [
      "Dasher"
    ]
  },
  "1979": {
    "Audi": [
      "Fox"
    ],
    "Volkswagen": [
      "Dasher"
    ]
  },
  "1980": {
    "Audi": [
      "4000",
      "5000"
    ],
    "BMW": [
      "320i",
      "528i",
      "633CSi",
      "733i"
    ],
    "Buick": [
      "Century",
      "LeSabre",
      "Regal",
      "Riviera",
      "Skyhawk",
      "Skylark"
    ],
    "Cadillac": [
      "DeVille",
      "Eldorado",
      "Fleetwood",
      "Seville"
    ],
    "Chevrolet": [
      "C10",
      "C10 Suburban",
      "C20",
      "C20 Suburban",
      "C30",
      "C70",
      "Camaro",
      "Caprice",
      "Chevette",
      "Citation",
      "Corvette",
      "El Camino",
      "G10",
      "G20",
      "G30",
      "Impala",
      "K10",
      "K10 Suburban",
      "K20",
      "K20 Suburban",
      "K30",
      "Malibu",
      "Monte Carlo",
      "Monza",
      "P10",
      "P20",
      "P30"
    ],
    "Chrysler": [
      "Cordoba",
      "LeBaron",
      "New Yorker",
      "Newport"
    ],
    "Dodge": [
      "Aspen",
      "B100",
      "B200",
      "B300",
      "CB300",
      "Challenger",
      "D150",
      "D200",
      "D300",
      "D50",
      "Diplomat",
      "Mirada",
      "Omni",
      "Ramcharger",
      "W150",
      "W200",
      "W300"
    ],
    "Fiat": [
      "124"
    ],
    "Ford": [
      "Bronco",
      "E-100 Econoline",
      "E-150 Econoline",
      "E-250 Econoline",
      "E-350 Econoline",
      "F-100",
      "F-150",
      "F-250",
      "F-350",
      "Fairmont",
      "Fiesta",
      "Granada",
      "LTD",
      "Mustang",
      "Pinto",
      "Thunderbird"
    ],
    "GMC": [
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "Caballero",
      "G1500",
      "G2500",
      "G3500",
      "Jimmy",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "P1500",
      "P2500",
      "P3500"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "Prelude"
    ],
    "Jaguar": [
      "XJ6",
      "XJS"
    ],
    "Jeep": [
      "Cherokee",
      "CJ5",
      "CJ7",
      "J10",
      "J20",
      "Wagoneer"
    ],
    "Lincoln": [
      "Continental",
      "Mark VI",
      "Versailles"
    ],
    "Mazda": [
      "626",
      "GLC",
      "RX-7"
    ],
    "Mercedes-Benz": [
      "240D",
      "300CD",
      "300D",
      "300SD",
      "300TD",
      "450SL",
      "450SLC"
    ],
    "Mercury": [
      "Bobcat",
      "Capri",
      "Cougar",
      "Grand Marquis",
      "Marquis",
      "Monarch",
      "Zephyr"
    ],
    "Nissan": [
      "200SX",
      "210",
      "280ZX",
      "510",
      "720"
    ],
    "Oldsmobile": [
      "98",
      "Custom Cruiser",
      "Cutlass",
      "Cutlass Calais",
      "Cutlass Cruiser",
      "Cutlass Salon",
      "Cutlass Supreme",
      "Delta 88",
      "Omega",
      "Toronado"
    ],
    "Plymouth": [
      "Arrow",
      "Caravelle",
      "Champ",
      "Gran Fury",
      "Horizon",
      "PB200",
      "Sapporo",
      "Volare"
    ],
    "Pontiac": [
      "Acadian",
      "Bonneville",
      "Catalina",
      "Firebird",
      "Grand LeMans",
      "Grand Prix",
      "Laurentian",
      "LeMans",
      "Phoenix",
      "Sunbird"
    ],
    "Porsche": [
      "911",
      "924",
      "928"
    ],
    "Saab": [
      "900",
      "99"
    ],
    "Toyota": [
      "Celica",
      "Corolla",
      "Corona",
      "Cressida",
      "Pickup",
      "Tercel"
    ],
    "Volkswagen": [
      "Dasher",
      "Jetta",
      "Rabbit",
      "Scirocco",
      "Vanagon"
    ],
    "Volvo": [
      "242",
      "244",
      "245",
      "262",
      "264",
      "265"
    ]
  },
  "1981": {
    "Alfa Romeo": [
      "GTV-6"
    ],
    "Audi": [
      "4000",
      "5000"
    ],
    "BMW": [
      "320i",
      "528i",
      "633CSi",
      "733i"
    ],
    "Buick": [
      "Century",
      "Electra",
      "Estate Wagon",
      "LeSabre",
      "Regal",
      "Riviera",
      "Skyhawk",
      "Skylark"
    ],
    "Cadillac": [
      "DeVille",
      "Eldorado",
      "Fleetwood",
      "Seville"
    ],
    "Chevrolet": [
      "C10",
      "C10 Suburban",
      "C20",
      "C20 Suburban",
      "C30",
      "C60",
      "C70",
      "Camaro",
      "Caprice",
      "Chevette",
      "Citation",
      "Corvette",
      "El Camino",
      "G10",
      "G20",
      "G30",
      "Impala",
      "K10",
      "K10 Suburban",
      "K20",
      "K20 Suburban",
      "K30",
      "K5 Blazer",
      "Malibu",
      "Monte Carlo",
      "P20",
      "P30"
    ],
    "Chrysler": [
      "Cordoba",
      "Imperial",
      "LeBaron",
      "New Yorker",
      "Newport"
    ],
    "Dodge": [
      "Aries",
      "B150",
      "B250",
      "B350",
      "Challenger",
      "Colt",
      "D150",
      "D250",
      "D350",
      "D50",
      "Diplomat",
      "Mirada",
      "Omni",
      "Ramcharger",
      "W150",
      "W250",
      "W350"
    ],
    "Ferrari": [
      "30",
      "308 GTBi",
      "308 GTSi"
    ],
    "Fiat": [
      "124"
    ],
    "Ford": [
      "Bronco",
      "E-100 Econoline",
      "E-100 Econoline Club Wagon",
      "E-150 Econoline",
      "E-150 Econoline Club Wagon",
      "E-250 Econoline",
      "E-250 Econoline Club Wagon",
      "E-350 Econoline",
      "E-350 Econoline Club Wagon",
      "Escort",
      "F-100",
      "F-150",
      "F-250",
      "F-350",
      "Fairmont",
      "Granada",
      "LTD",
      "Mustang",
      "Thunderbird"
    ],
    "GMC": [
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "C6000",
      "C7000",
      "Caballero",
      "G1500",
      "G2500",
      "G3500",
      "Jimmy",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "P2500",
      "P3500"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "Prelude"
    ],
    "Jaguar": [
      "XJ12",
      "XJ6",
      "XJS"
    ],
    "Jeep": [
      "Cherokee",
      "CJ5",
      "CJ7",
      "J10",
      "J20",
      "Scrambler",
      "Wagoneer"
    ],
    "Lincoln": [
      "Mark VI",
      "Town Car"
    ],
    "Mazda": [
      "626",
      "GLC",
      "RX-7"
    ],
    "Mercedes-Benz": [
      "240D",
      "300CD",
      "300D",
      "300SD",
      "300TD",
      "380SEL",
      "380SL",
      "380SLC"
    ],
    "Mercury": [
      "Capri",
      "Cougar",
      "Grand Marquis",
      "Lynx",
      "Marquis",
      "Zephyr"
    ],
    "Nissan": [
      "200SX",
      "210",
      "280ZX",
      "310",
      "510",
      "720"
    ],
    "Oldsmobile": [
      "98",
      "Custom Cruiser",
      "Cutlass",
      "Cutlass Calais",
      "Cutlass Cruiser",
      "Cutlass Salon",
      "Cutlass Supreme",
      "Delta 88",
      "Omega",
      "Toronado"
    ],
    "Plymouth": [
      "Caravelle",
      "Champ",
      "Gran Fury",
      "Horizon",
      "Reliant",
      "Sapporo",
      "Trailduster"
    ],
    "Pontiac": [
      "Acadian",
      "Bonneville",
      "Catalina",
      "Firebird",
      "Grand LeMans",
      "Grand Prix",
      "Laurentian",
      "LeMans",
      "Phoenix",
      "Sunbird",
      "T1000"
    ],
    "Porsche": [
      "911",
      "924",
      "928"
    ],
    "Rolls-Royce": [
      "Corniche",
      "Silver Spirit",
      "Silver Spur"
    ],
    "Saab": [
      "900"
    ],
    "Suzuki": [
      "LJ81"
    ],
    "Toyota": [
      "Celica",
      "Corolla",
      "Corona",
      "Cressida",
      "Land Cruiser",
      "Pickup",
      "Starlet",
      "Tercel"
    ],
    "Volkswagen": [
      "Dasher",
      "Jetta",
      "Rabbit",
      "Rabbit Convertible",
      "Scirocco",
      "Vanagon"
    ],
    "Volvo": [
      "242",
      "244",
      "245",
      "262",
      "264",
      "265"
    ]
  },
  "1982": {
    "Alfa Romeo": [
      "GTV-6"
    ],
    "Audi": [
      "4000",
      "5000",
      "Coupe"
    ],
    "BMW": [
      "320i",
      "528e",
      "633CSi",
      "733i"
    ],
    "Buick": [
      "Century",
      "Electra",
      "Estate Wagon",
      "LeSabre",
      "Regal",
      "Riviera",
      "Skyhawk",
      "Skylark"
    ],
    "Cadillac": [
      "Cimarron",
      "DeVille",
      "Eldorado",
      "Fleetwood",
      "Seville"
    ],
    "Chevrolet": [
      "C10",
      "C10 Suburban",
      "C20",
      "C20 Suburban",
      "C30",
      "C60",
      "C70",
      "Camaro",
      "Caprice",
      "Cavalier",
      "Celebrity",
      "Chevette",
      "Citation",
      "Corvette",
      "El Camino",
      "G10",
      "G20",
      "G30",
      "Impala",
      "K10",
      "K10 Suburban",
      "K20",
      "K20 Suburban",
      "K30",
      "K5 Blazer",
      "Malibu",
      "Monte Carlo",
      "P20",
      "P30",
      "S10"
    ],
    "Chrysler": [
      "Cordoba",
      "Imperial",
      "LeBaron",
      "New Yorker",
      "Town & Country"
    ],
    "Dodge": [
      "400",
      "Aries",
      "B150",
      "B250",
      "B350",
      "Challenger",
      "Colt",
      "D150",
      "D250",
      "D350",
      "D50",
      "Diplomat",
      "Mirada",
      "Omni",
      "Ramcharger",
      "Rampage",
      "W150",
      "W250",
      "W350"
    ],
    "Ferrari": [
      "30",
      "308 GTBi",
      "308 GTSi"
    ],
    "Fiat": [
      "124"
    ],
    "Ford": [
      "Bronco",
      "E-100 Econoline",
      "E-150 Econoline",
      "E-150 Econoline Club Wagon",
      "E-250 Econoline",
      "E-250 Econoline Club Wagon",
      "E-350 Econoline",
      "E-350 Econoline Club Wagon",
      "Escort",
      "EXP",
      "F-100",
      "F-150",
      "F-250",
      "F-350",
      "Fairmont",
      "Granada",
      "LTD",
      "Mustang",
      "Thunderbird"
    ],
    "GMC": [
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "C6000",
      "C7000",
      "Caballero",
      "G1500",
      "G2500",
      "G3500",
      "Jimmy",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "P2500",
      "P3500",
      "S15"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "Prelude"
    ],
    "Jaguar": [
      "Vanden Plas",
      "XJ12",
      "XJ6",
      "XJS"
    ],
    "Jeep": [
      "Cherokee",
      "CJ5",
      "CJ7",
      "J10",
      "J20",
      "Scrambler",
      "Wagoneer"
    ],
    "Lincoln": [
      "Continental",
      "Mark VI",
      "Town Car"
    ],
    "Mazda": [
      "626",
      "GLC",
      "RX-7"
    ],
    "Mercedes-Benz": [
      "240D",
      "300CD",
      "300D",
      "300SD",
      "300TD",
      "380SEC",
      "380SEL",
      "380SL"
    ],
    "Mercury": [
      "Capri",
      "Cougar",
      "Grand Marquis",
      "LN7",
      "Lynx",
      "Marquis",
      "Zephyr"
    ],
    "Nissan": [
      "200SX",
      "210",
      "280ZX",
      "310",
      "720",
      "Maxima",
      "Stanza"
    ],
    "Oldsmobile": [
      "98",
      "Custom Cruiser",
      "Cutlass Calais",
      "Cutlass Ciera",
      "Cutlass Cruiser",
      "Cutlass Salon",
      "Cutlass Supreme",
      "Delta 88",
      "Firenza",
      "Omega",
      "Toronado"
    ],
    "Plymouth": [
      "Caravelle",
      "Champ",
      "Gran Fury",
      "Horizon",
      "Reliant",
      "Sapporo"
    ],
    "Pontiac": [
      "6000",
      "Acadian",
      "Bonneville",
      "Firebird",
      "Grand LeMans",
      "Grand Prix",
      "J2000",
      "LeMans",
      "Phoenix",
      "Sunbird",
      "T1000"
    ],
    "Porsche": [
      "911",
      "924",
      "928"
    ],
    "Rolls-Royce": [
      "Corniche",
      "Silver Spirit",
      "Silver Spur"
    ],
    "Saab": [
      "900"
    ],
    "Toyota": [
      "Celica",
      "Corolla",
      "Corona",
      "Cressida",
      "Land Cruiser",
      "Pickup",
      "Starlet",
      "Tercel"
    ],
    "Volkswagen": [
      "Jetta",
      "Quantum",
      "Rabbit",
      "Rabbit Convertible",
      "Scirocco",
      "Vanagon"
    ],
    "Volvo": [
      "242",
      "244",
      "245",
      "264"
    ]
  },
  "1983": {
    "Alfa Romeo": [
      "GTV-6"
    ],
    "Audi": [
      "4000",
      "5000",
      "Coupe",
      "Quattro"
    ],
    "BMW": [
      "320i",
      "528e",
      "533i",
      "733i"
    ],
    "Buick": [
      "Century",
      "Electra",
      "Estate Wagon",
      "LeSabre",
      "Regal",
      "Riviera",
      "Skyhawk",
      "Skylark"
    ],
    "Cadillac": [
      "Cimarron",
      "DeVille",
      "Eldorado",
      "Fleetwood",
      "Seville"
    ],
    "Chevrolet": [
      "B60",
      "C10",
      "C10 Suburban",
      "C20",
      "C20 Suburban",
      "C30",
      "C60",
      "C70",
      "Camaro",
      "Caprice",
      "Cavalier",
      "Celebrity",
      "Chevette",
      "Citation",
      "El Camino",
      "G10",
      "G20",
      "G30",
      "Impala",
      "K10",
      "K10 Suburban",
      "K20",
      "K20 Suburban",
      "K30",
      "K5 Blazer",
      "Malibu",
      "Monte Carlo",
      "P20",
      "P30",
      "S10",
      "S10 Blazer"
    ],
    "Chrysler": [
      "Cordoba",
      "E Class",
      "Fifth Avenue",
      "Imperial",
      "LeBaron",
      "New Yorker",
      "Town & Country"
    ],
    "Dodge": [
      "400",
      "600",
      "Aries",
      "B150",
      "B250",
      "B350",
      "Challenger",
      "Charger",
      "Colt",
      "D150",
      "D250",
      "D350",
      "Diplomat",
      "Mirada",
      "Omni",
      "Ram 50",
      "Ramcharger",
      "Rampage",
      "W150",
      "W250",
      "W350"
    ],
    "Ferrari": [
      "308 GTS"
    ],
    "Fiat": [
      "124"
    ],
    "Ford": [
      "Bronco",
      "E-100 Econoline",
      "E-150 Econoline",
      "E-150 Econoline Club Wagon",
      "E-250 Econoline",
      "E-250 Econoline Club Wagon",
      "E-350 Econoline",
      "E-350 Econoline Club Wagon",
      "Escort",
      "EXP",
      "F-100",
      "F-150",
      "F-250",
      "F-350",
      "Fairmont",
      "LTD",
      "Mustang",
      "Ranger",
      "Thunderbird"
    ],
    "GMC": [
      "B6000",
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "C6000",
      "C7000",
      "Caballero",
      "G1500",
      "G2500",
      "G3500",
      "Jimmy",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "P2500",
      "P3500",
      "S15",
      "S15 Jimmy"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "Prelude"
    ],
    "Hyundai": [
      "Pony"
    ],
    "Jaguar": [
      "Vanden Plas",
      "XJ12",
      "XJ6",
      "XJS"
    ],
    "Jeep": [
      "Cherokee",
      "CJ5",
      "CJ7",
      "J10",
      "J20",
      "Scrambler",
      "Wagoneer"
    ],
    "Lincoln": [
      "Continental",
      "Mark VI",
      "Town Car"
    ],
    "Lotus": [
      "Esprit"
    ],
    "Mazda": [
      "626",
      "GLC",
      "RX-7"
    ],
    "Mercedes-Benz": [
      "240D",
      "300CD",
      "300D",
      "300SD",
      "300TD",
      "380SEC",
      "380SEL",
      "380SL"
    ],
    "Mercury": [
      "Capri",
      "Cougar",
      "Grand Marquis",
      "LN7",
      "Lynx",
      "Marquis",
      "Zephyr"
    ],
    "Mitsubishi": [
      "Starion"
    ],
    "Nissan": [
      "200SX",
      "280ZX",
      "720",
      "Maxima",
      "Pulsar NX",
      "Sentra",
      "Stanza"
    ],
    "Oldsmobile": [
      "98",
      "Custom Cruiser",
      "Cutlass Calais",
      "Cutlass Ciera",
      "Cutlass Cruiser",
      "Cutlass Salon",
      "Cutlass Supreme",
      "Delta 88",
      "Firenza",
      "Omega",
      "Toronado"
    ],
    "Plymouth": [
      "Caravelle",
      "Colt",
      "Gran Fury",
      "Horizon",
      "Reliant",
      "Sapporo",
      "Scamp"
    ],
    "Pontiac": [
      "6000",
      "Acadian",
      "Bonneville",
      "Firebird",
      "Grand Prix",
      "J2000",
      "LeMans",
      "Parisienne",
      "Phoenix",
      "Sunbird",
      "T1000"
    ],
    "Porsche": [
      "911",
      "924",
      "928",
      "944"
    ],
    "Rolls-Royce": [
      "Corniche",
      "Silver Spirit",
      "Silver Spur"
    ],
    "Saab": [
      "900"
    ],
    "Toyota": [
      "Camry",
      "Celica",
      "Corolla",
      "Cressida",
      "Land Cruiser",
      "Pickup",
      "Starlet",
      "Tercel"
    ],
    "Volkswagen": [
      "Jetta",
      "Quantum",
      "Rabbit",
      "Rabbit Convertible",
      "Rabbit Pickup",
      "Scirocco",
      "Vanagon"
    ],
    "Volvo": [
      "242",
      "244",
      "245",
      "760"
    ]
  },
  "1984": {
    "Alfa Romeo": [
      "GTV-6"
    ],
    "Audi": [
      "4000",
      "4000 Quattro",
      "5000",
      "Coupe",
      "Quattro"
    ],
    "Bentley": [
      "Mulsanne"
    ],
    "BMW": [
      "528e",
      "533i",
      "733i"
    ],
    "Buick": [
      "Century",
      "Electra",
      "LeSabre",
      "Regal",
      "Riviera",
      "Skyhawk",
      "Skylark"
    ],
    "Cadillac": [
      "Cimarron",
      "DeVille",
      "Eldorado",
      "Fleetwood",
      "Seville"
    ],
    "Chevrolet": [
      "B60",
      "C10",
      "C10 Suburban",
      "C20",
      "C20 Suburban",
      "C30",
      "C60",
      "C70",
      "Camaro",
      "Caprice",
      "Cavalier",
      "Celebrity",
      "Chevette",
      "Citation II",
      "Corvette",
      "El Camino",
      "G10",
      "G20",
      "G30",
      "Impala",
      "K10",
      "K10 Suburban",
      "K20",
      "K20 Suburban",
      "K30",
      "K5 Blazer",
      "Monte Carlo",
      "P20",
      "P30",
      "S10",
      "S10 Blazer"
    ],
    "Chrysler": [
      "Daytona",
      "E Class",
      "Executive Sedan",
      "Fifth Avenue",
      "Laser",
      "LeBaron",
      "New Yorker",
      "Town & Country"
    ],
    "Dodge": [
      "600",
      "Aries",
      "B150",
      "B250",
      "B350",
      "Caravan",
      "Charger",
      "Colt",
      "D150",
      "D250",
      "D350",
      "Daytona",
      "Diplomat",
      "Mini Ram",
      "Omni",
      "Ram 50",
      "Ramcharger",
      "Rampage",
      "W150",
      "W250",
      "W350"
    ],
    "Ferrari": [
      "308 GTS"
    ],
    "Ford": [
      "Bronco",
      "Bronco II",
      "E-150 Econoline",
      "E-150 Econoline Club Wagon",
      "E-250 Econoline",
      "E-250 Econoline Club Wagon",
      "E-350 Econoline",
      "E-350 Econoline Club Wagon",
      "Escort",
      "EXP",
      "F-150",
      "F-250",
      "F-350",
      "LTD",
      "Mustang",
      "Ranger",
      "Tempo",
      "Thunderbird"
    ],
    "GMC": [
      "B6000",
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "C6000",
      "C7000",
      "Caballero",
      "G1500",
      "G2500",
      "G3500",
      "Jimmy",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "P2500",
      "P3500",
      "S15",
      "S15 Jimmy"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "Prelude"
    ],
    "Hyundai": [
      "Pony"
    ],
    "Jaguar": [
      "Vanden Plas",
      "XJ12",
      "XJ6",
      "XJS"
    ],
    "Jeep": [
      "Cherokee",
      "CJ7",
      "Grand Wagoneer",
      "J10",
      "J20",
      "Scrambler",
      "Wagoneer"
    ],
    "Lincoln": [
      "Continental",
      "Mark VII",
      "Town Car"
    ],
    "Lotus": [
      "Esprit"
    ],
    "Maserati": [
      "Biturbo"
    ],
    "Mazda": [
      "626",
      "GLC"
    ],
    "Mercedes-Benz": [
      "190D",
      "190E",
      "300CD",
      "300D",
      "300SD",
      "300TD",
      "380SE",
      "380SL",
      "500SEC",
      "500SEL"
    ],
    "Mercury": [
      "Capri",
      "Cougar",
      "Grand Marquis",
      "Lynx",
      "Marquis",
      "Topaz"
    ],
    "Mitsubishi": [
      "Mighty Max",
      "Starion"
    ],
    "Nissan": [
      "200SX",
      "300ZX",
      "720",
      "Maxima",
      "Pulsar NX",
      "Sentra",
      "Stanza"
    ],
    "Oldsmobile": [
      "98",
      "Custom Cruiser",
      "Cutlass Calais",
      "Cutlass Ciera",
      "Cutlass Salon",
      "Cutlass Supreme",
      "Delta 88",
      "Firenza",
      "Omega",
      "Toronado"
    ],
    "Plymouth": [
      "Caravelle",
      "Colt",
      "Gran Fury",
      "Horizon",
      "Reliant",
      "Voyager"
    ],
    "Pontiac": [
      "6000",
      "Acadian",
      "Bonneville",
      "Fiero",
      "Firebird",
      "Grand Prix",
      "J2000 Sunbird",
      "LeMans",
      "Parisienne",
      "Phoenix",
      "Sunbird",
      "T1000"
    ],
    "Porsche": [
      "911",
      "924",
      "928",
      "944"
    ],
    "Rolls-Royce": [
      "Corniche",
      "Silver Spirit",
      "Silver Spur"
    ],
    "Saab": [
      "900"
    ],
    "Toyota": [
      "4Runner",
      "Camry",
      "Celica",
      "Corolla",
      "Cressida",
      "Land Cruiser",
      "Pickup",
      "Tercel",
      "Van"
    ],
    "Volkswagen": [
      "Jetta",
      "Quantum",
      "Rabbit",
      "Rabbit Convertible",
      "Scirocco",
      "Vanagon"
    ],
    "Volvo": [
      "242",
      "244",
      "245",
      "760"
    ]
  },
  "1985": {
    "Alfa Romeo": [
      "GTV-6"
    ],
    "Audi": [
      "4000",
      "4000 Quattro",
      "5000",
      "Coupe",
      "Quattro"
    ],
    "Bentley": [
      "Mulsanne"
    ],
    "BMW": [
      "524td",
      "528e",
      "535i",
      "735i"
    ],
    "Buick": [
      "Century",
      "Electra",
      "LeSabre",
      "Regal",
      "Riviera",
      "Skyhawk",
      "Skylark",
      "Somerset Regal"
    ],
    "Cadillac": [
      "Cimarron",
      "DeVille",
      "Eldorado",
      "Fleetwood",
      "Seville"
    ],
    "Chevrolet": [
      "Astro",
      "C10",
      "C10 Suburban",
      "C20",
      "C20 Suburban",
      "C30",
      "C60",
      "Camaro",
      "Caprice",
      "Cavalier",
      "Celebrity",
      "Chevette",
      "Citation II",
      "Corvette",
      "El Camino",
      "G10",
      "G20",
      "G30",
      "Impala",
      "K10",
      "K10 Suburban",
      "K20",
      "K20 Suburban",
      "K30",
      "K5 Blazer",
      "Monte Carlo",
      "P20",
      "P30",
      "S10",
      "S10 Blazer",
      "Spectrum",
      "Sprint"
    ],
    "Chrysler": [
      "Daytona",
      "Executive Limousine",
      "Fifth Avenue",
      "Laser",
      "LeBaron",
      "New Yorker",
      "Town & Country"
    ],
    "Dodge": [
      "600",
      "Aries",
      "B150",
      "B250",
      "B350",
      "Caravan",
      "Charger",
      "Colt",
      "D150",
      "D250",
      "D350",
      "Daytona",
      "Diplomat",
      "Lancer",
      "Mini Ram",
      "Omni",
      "Ram 50",
      "Ramcharger",
      "W150",
      "W250",
      "W350"
    ],
    "Ferrari": [
      "308 GTS",
      "Testarossa"
    ],
    "Ford": [
      "Bronco",
      "Bronco II",
      "E-150 Econoline",
      "E-150 Econoline Club Wagon",
      "E-250 Econoline",
      "E-250 Econoline Club Wagon",
      "E-350 Econoline",
      "E-350 Econoline Club Wagon",
      "Escort",
      "EXP",
      "F-150",
      "F-250",
      "F-350",
      "LTD",
      "Mustang",
      "Ranger",
      "Tempo",
      "Thunderbird"
    ],
    "GMC": [
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "C7000",
      "Caballero",
      "G1500",
      "G2500",
      "G3500",
      "Jimmy",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "P2500",
      "P3500",
      "S15",
      "S15 Jimmy",
      "Safari"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "Prelude"
    ],
    "Hyundai": [
      "Pony",
      "Stellar"
    ],
    "Jaguar": [
      "Vanden Plas",
      "XJ12",
      "XJ6",
      "XJS"
    ],
    "Jeep": [
      "Cherokee",
      "CJ7",
      "Grand Wagoneer",
      "J10",
      "J20",
      "Scrambler",
      "Wagoneer"
    ],
    "Lincoln": [
      "Continental",
      "Mark VII",
      "Town Car"
    ],
    "Lotus": [
      "Esprit"
    ],
    "Maserati": [
      "Biturbo",
      "Quattrop"
    ],
    "Mazda": [
      "626",
      "GLC"
    ],
    "Mercedes-Benz": [
      "190D",
      "190E",
      "300CD",
      "300D",
      "300SD",
      "300TD",
      "380SE",
      "380SL",
      "500SEC",
      "500SEL"
    ],
    "Mercury": [
      "Capri",
      "Cougar",
      "Grand Marquis",
      "Lynx",
      "Marquis",
      "Topaz"
    ],
    "Mitsubishi": [
      "Mighty Max",
      "Mirage",
      "Starion"
    ],
    "Nissan": [
      "200SX",
      "300ZX",
      "720",
      "Maxima",
      "Micra",
      "Pulsar NX",
      "Sentra",
      "Stanza"
    ],
    "Oldsmobile": [
      "98",
      "Calais",
      "Custom Cruiser",
      "Cutlass Ciera",
      "Cutlass Salon",
      "Cutlass Supreme",
      "Delta 88",
      "Firenza",
      "Toronado"
    ],
    "Plymouth": [
      "Caravelle",
      "Colt",
      "Gran Fury",
      "Horizon",
      "Reliant",
      "Voyager"
    ],
    "Pontiac": [
      "6000",
      "Acadian",
      "Bonneville",
      "Fiero",
      "Firebird",
      "Firefly",
      "Grand Am",
      "Grand Prix",
      "J2000 Sunbird",
      "LeMans",
      "Parisienne",
      "Sunbird",
      "Sunburst",
      "T1000"
    ],
    "Porsche": [
      "911",
      "924",
      "928",
      "944"
    ],
    "Rolls-Royce": [
      "Corniche",
      "Silver Spirit",
      "Silver Spur"
    ],
    "Saab": [
      "900"
    ],
    "Suzuki": [
      "Samurai"
    ],
    "Toyota": [
      "4Runner",
      "Camry",
      "Celica",
      "Corolla",
      "Cressida",
      "Land Cruiser",
      "MR2",
      "Pickup",
      "Tercel",
      "Van"
    ],
    "Volkswagen": [
      "Cabriolet",
      "Golf",
      "Jetta",
      "Quantum",
      "Scirocco",
      "Vanagon"
    ],
    "Volvo": [
      "244",
      "245",
      "740",
      "745",
      "760"
    ]
  },
  "1986": {
    "Acura": [
      "Legend"
    ],
    "Alfa Romeo": [
      "GTV-6"
    ],
    "Audi": [
      "4000",
      "4000 Quattro",
      "5000",
      "Coupe",
      "Quattro"
    ],
    "Bentley": [
      "Mulsanne"
    ],
    "BMW": [
      "524td",
      "528e",
      "535i",
      "735i",
      "L7"
    ],
    "Buick": [
      "Century",
      "Electra",
      "LeSabre",
      "Regal",
      "Riviera",
      "Skyhawk",
      "Skylark",
      "Somerset"
    ],
    "Cadillac": [
      "Cimarron",
      "DeVille",
      "Eldorado",
      "Fleetwood",
      "Seville"
    ],
    "Chevrolet": [
      "Astro",
      "C10",
      "C10 Suburban",
      "C20",
      "C20 Suburban",
      "C30",
      "C60",
      "Camaro",
      "Caprice",
      "Cavalier",
      "Celebrity",
      "Chevette",
      "Corvette",
      "El Camino",
      "G10",
      "G20",
      "G30",
      "Impala",
      "K10",
      "K10 Suburban",
      "K20",
      "K20 Suburban",
      "K30",
      "K5 Blazer",
      "Monte Carlo",
      "Nova",
      "P20",
      "P30",
      "S10",
      "S10 Blazer",
      "Spectrum",
      "Sprint"
    ],
    "Chrysler": [
      "Daytona",
      "Fifth Avenue",
      "Laser",
      "LeBaron",
      "New Yorker",
      "Town & Country"
    ],
    "Dodge": [
      "600",
      "Aries",
      "B150",
      "B250",
      "B350",
      "Caravan",
      "Charger",
      "Colt",
      "Conquest",
      "D100",
      "D150",
      "D250",
      "D350",
      "Daytona",
      "Diplomat",
      "Lancer",
      "Mini Ram",
      "Omni",
      "Ram 50",
      "Ramcharger",
      "W100",
      "W150",
      "W250",
      "W350"
    ],
    "Ferrari": [
      "328 GTB",
      "328 GTS",
      "Testarossa"
    ],
    "Ford": [
      "Aerostar",
      "Bronco",
      "Bronco II",
      "E-150 Econoline",
      "E-150 Econoline Club Wagon",
      "E-250 Econoline",
      "E-250 Econoline Club Wagon",
      "E-350 Econoline",
      "E-350 Econoline Club Wagon",
      "Escort",
      "EXP",
      "F-150",
      "F-250",
      "F-350",
      "LTD",
      "Mustang",
      "Ranger",
      "Taurus",
      "Tempo",
      "Thunderbird"
    ],
    "GMC": [
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "Caballero",
      "G1500",
      "G2500",
      "G3500",
      "Jimmy",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "P2500",
      "P3500",
      "S15",
      "S15 Jimmy",
      "Safari"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "Prelude",
      "Wagovan"
    ],
    "Hyundai": [
      "Excel",
      "Pony",
      "Stellar"
    ],
    "Jaguar": [
      "Vanden Plas",
      "XJ12",
      "XJ6",
      "XJS"
    ],
    "Jeep": [
      "Cherokee",
      "CJ7",
      "Comanche",
      "Grand Wagoneer",
      "J10",
      "J20",
      "Wagoneer"
    ],
    "Lincoln": [
      "Continental",
      "Mark VII",
      "Town Car"
    ],
    "Lotus": [
      "Esprit"
    ],
    "Maserati": [
      "Biturbo",
      "Quattrop",
      "Spyder"
    ],
    "Mazda": [
      "323",
      "626",
      "B2000",
      "RX-7"
    ],
    "Mercedes-Benz": [
      "190D",
      "190E",
      "300E",
      "300SDL",
      "420SEL",
      "560SEC",
      "560SEL",
      "560SL"
    ],
    "Mercury": [
      "Capri",
      "Cougar",
      "Grand Marquis",
      "Lynx",
      "Marquis",
      "Sable",
      "Topaz"
    ],
    "Mitsubishi": [
      "Mighty Max",
      "Mirage",
      "Starion"
    ],
    "Nissan": [
      "200SX",
      "300ZX",
      "720",
      "D21",
      "Maxima",
      "Micra",
      "Multi",
      "Pulsar NX",
      "Sentra",
      "Stanza"
    ],
    "Oldsmobile": [
      "98",
      "Calais",
      "Custom Cruiser",
      "Cutlass Ciera",
      "Cutlass Salon",
      "Cutlass Supreme",
      "Delta 88",
      "Firenza",
      "Toronado"
    ],
    "Plymouth": [
      "Caravelle",
      "Colt",
      "Gran Fury",
      "Horizon",
      "Reliant",
      "Voyager"
    ],
    "Pontiac": [
      "6000",
      "Acadian",
      "Bonneville",
      "Fiero",
      "Firebird",
      "Firefly",
      "Grand Am",
      "Grand Prix",
      "LeMans",
      "Parisienne",
      "Sunbird",
      "Sunburst",
      "T1000"
    ],
    "Porsche": [
      "911",
      "924",
      "928",
      "944"
    ],
    "Rolls-Royce": [
      "Corniche II",
      "Silver Spirit",
      "Silver Spur"
    ],
    "Saab": [
      "900",
      "9000"
    ],
    "Suzuki": [
      "Forsa",
      "Samurai"
    ],
    "Toyota": [
      "4Runner",
      "Camry",
      "Celica",
      "Corolla",
      "Cressida",
      "Land Cruiser",
      "MR2",
      "Pickup",
      "Supra",
      "Tercel",
      "Van"
    ],
    "Volkswagen": [
      "Cabriolet",
      "Golf",
      "Jetta",
      "Quantum",
      "Scirocco",
      "Vanagon"
    ],
    "Volvo": [
      "244",
      "245",
      "740",
      "760"
    ]
  },
  "1987": {
    "Acura": [
      "Legend"
    ],
    "Alfa Romeo": [
      "Milano"
    ],
    "Audi": [
      "4000",
      "4000 Quattro",
      "5000",
      "5000 Quattro",
      "Coupe"
    ],
    "Bentley": [
      "Eight",
      "Mulsanne"
    ],
    "BMW": [
      "325",
      "325e",
      "325i",
      "325is",
      "528e",
      "535i",
      "L7"
    ],
    "Buick": [
      "Century",
      "Electra",
      "LeSabre",
      "Regal",
      "Riviera",
      "Skyhawk",
      "Skylark",
      "Somerset"
    ],
    "Cadillac": [
      "Allante",
      "Brougham",
      "Cimarron",
      "DeVille",
      "Eldorado",
      "Fleetwood",
      "Seville"
    ],
    "Chevrolet": [
      "Astro",
      "Beretta",
      "Blazer",
      "C60",
      "Camaro",
      "Caprice",
      "Cavalier",
      "Celebrity",
      "Chevette",
      "Corsica",
      "Corvette",
      "El Camino",
      "G10",
      "G20",
      "G30",
      "Impala",
      "Monte Carlo",
      "Nova",
      "P20",
      "P30",
      "R10",
      "R10 Suburban",
      "R20",
      "R20 Suburban",
      "R30",
      "S10",
      "S10 Blazer",
      "Spectrum",
      "Sprint",
      "V10",
      "V10 Suburban",
      "V20",
      "V20 Suburban",
      "V30"
    ],
    "Chrysler": [
      "Conquest",
      "Daytona",
      "Fifth Avenue",
      "LeBaron",
      "New Yorker",
      "Town & Country"
    ],
    "Dodge": [
      "600",
      "Aries",
      "B150",
      "B250",
      "B350",
      "Caravan",
      "Charger",
      "Colt",
      "D100",
      "D150",
      "D250",
      "D350",
      "Dakota",
      "Daytona",
      "Diplomat",
      "Lancer",
      "Mini Ram",
      "Omni",
      "Ram 50",
      "Ramcharger",
      "Shadow",
      "W100",
      "W150",
      "W250",
      "W350"
    ],
    "Ferrari": [
      "328 GTB",
      "328 GTS",
      "Mondial 3.2",
      "Testarossa"
    ],
    "Ford": [
      "Aerostar",
      "Bronco",
      "Bronco II",
      "Country Squire",
      "E-150 Econoline",
      "E-150 Econoline Club Wagon",
      "E-250 Econoline",
      "E-250 Econoline Club Wagon",
      "E-350 Econoline",
      "E-350 Econoline Club Wagon",
      "Escort",
      "EXP",
      "F-150",
      "F-250",
      "F-350",
      "LTD Crown Victoria",
      "Mustang",
      "Ranger",
      "Taurus",
      "Tempo",
      "Thunderbird"
    ],
    "GMC": [
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "Caballero",
      "G1500",
      "G2500",
      "G3500",
      "Jimmy",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "P2500",
      "P3500",
      "R1500",
      "R1500 Suburban",
      "R2500",
      "R2500 Suburban",
      "R3500",
      "S15",
      "S15 Jimmy",
      "Safari",
      "V1500",
      "V1500 Suburban",
      "V2500",
      "V2500 Suburban",
      "V3500"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "Prelude",
      "Wagovan"
    ],
    "Hyundai": [
      "Excel",
      "Stellar"
    ],
    "Jaguar": [
      "Vanden Plas",
      "XJ12",
      "XJ6",
      "XJS"
    ],
    "Jeep": [
      "Cherokee",
      "Comanche",
      "Grand Wagoneer",
      "J10",
      "J20",
      "Wagoneer",
      "Wrangler"
    ],
    "Land Rover": [
      "Range Rover"
    ],
    "Lincoln": [
      "Continental",
      "Mark VII",
      "Town Car"
    ],
    "Lotus": [
      "Esprit"
    ],
    "Maserati": [
      "Biturbo",
      "Spyder"
    ],
    "Mazda": [
      "323",
      "626",
      "B2000",
      "B2200",
      "B2600",
      "RX-7"
    ],
    "Mercedes-Benz": [
      "190D",
      "190E",
      "260E",
      "300D",
      "300E",
      "300SDL",
      "300TD",
      "420SEL",
      "560SEC",
      "560SEL",
      "560SL"
    ],
    "Mercury": [
      "Colony Park",
      "Cougar",
      "Grand Marquis",
      "Sable",
      "Topaz",
      "Tracer"
    ],
    "Mitsubishi": [
      "Mirage",
      "Starion"
    ],
    "Nissan": [
      "200SX",
      "300ZX",
      "D21",
      "Maxima",
      "Micra",
      "Pathfinder",
      "Pulsar NX",
      "Sentra",
      "Stanza",
      "Van"
    ],
    "Oldsmobile": [
      "98",
      "Calais",
      "Custom Cruiser",
      "Cutlass Ciera",
      "Cutlass Cruiser",
      "Cutlass Salon",
      "Cutlass Supreme",
      "Delta 88",
      "Firenza",
      "Toronado"
    ],
    "Plymouth": [
      "Caravelle",
      "Colt",
      "Gran Fury",
      "Grand Voyager",
      "Horizon",
      "Reliant",
      "Sundance",
      "Voyager"
    ],
    "Pontiac": [
      "6000",
      "Acadian",
      "Bonneville",
      "Fiero",
      "Firebird",
      "Firefly",
      "Grand Am",
      "Grand Prix",
      "LeMans",
      "Safari",
      "Sunbird",
      "Sunburst",
      "Tempest"
    ],
    "Porsche": [
      "911",
      "924",
      "928",
      "944"
    ],
    "Rolls-Royce": [
      "Corniche II",
      "Silver Spirit",
      "Silver Spur"
    ],
    "Saab": [
      "900",
      "9000"
    ],
    "Suzuki": [
      "Forsa",
      "Samurai"
    ],
    "Toyota": [
      "4Runner",
      "Camry",
      "Celica",
      "Corolla",
      "Cressida",
      "Land Cruiser",
      "MR2",
      "Pickup",
      "Supra",
      "Tercel",
      "Van"
    ],
    "Volkswagen": [
      "Cabriolet",
      "Fox",
      "Golf",
      "Jetta",
      "Quantum",
      "Scirocco",
      "Vanagon"
    ],
    "Volvo": [
      "244",
      "245",
      "740",
      "760",
      "780"
    ]
  },
  "1988": {
    "Acura": [
      "Legend"
    ],
    "Alfa Romeo": [
      "Milano"
    ],
    "Audi": [
      "5000",
      "5000 Quattro",
      "80",
      "80 Quattro",
      "90",
      "90 Quattro"
    ],
    "Bentley": [
      "Continental",
      "Eight",
      "Mulsanne"
    ],
    "BMW": [
      "325",
      "325i",
      "325is",
      "325iX",
      "528e",
      "535i",
      "535is",
      "M3",
      "M5"
    ],
    "Buick": [
      "Century",
      "Electra",
      "LeSabre",
      "Reatta",
      "Regal",
      "Riviera",
      "Skyhawk",
      "Skylark"
    ],
    "Cadillac": [
      "Allante",
      "Brougham",
      "Cimarron",
      "DeVille",
      "Eldorado",
      "Fleetwood",
      "Seville"
    ],
    "Chevrolet": [
      "Astro",
      "Beretta",
      "Blazer",
      "C1500",
      "C2500",
      "C3500",
      "Camaro",
      "Caprice",
      "Cavalier",
      "Celebrity",
      "Corsica",
      "Corvette",
      "G10",
      "G20",
      "G30",
      "Impala",
      "K1500",
      "K2500",
      "K3500",
      "Monte Carlo",
      "Nova",
      "P20",
      "P30",
      "R10 Suburban",
      "R20",
      "R20 Suburban",
      "R30",
      "S10",
      "S10 Blazer",
      "Sprint",
      "V10 Suburban",
      "V20 Suburban",
      "V30"
    ],
    "Chrysler": [
      "Conquest",
      "Daytona",
      "Fifth Avenue",
      "LeBaron",
      "New Yorker",
      "Town & Country"
    ],
    "Dodge": [
      "600",
      "Aries",
      "B150",
      "B250",
      "B350",
      "Caravan",
      "Colt",
      "D100",
      "D150",
      "D250",
      "D350",
      "Dakota",
      "Daytona",
      "Diplomat",
      "Dynasty",
      "Grand Caravan",
      "Lancer",
      "Mini Ram",
      "Omni",
      "Ram 50",
      "Ramcharger",
      "Shadow",
      "W100",
      "W150",
      "W250",
      "W350"
    ],
    "Ferrari": [
      "328 GTB",
      "328 GTS",
      "Mondial 3.2",
      "Testarossa"
    ],
    "Ford": [
      "Aerostar",
      "Bronco",
      "Bronco II",
      "Country Squire",
      "E-150 Econoline",
      "E-150 Econoline Club Wagon",
      "E-250 Econoline",
      "E-250 Econoline Club Wagon",
      "E-350 Econoline",
      "E-350 Econoline Club Wagon",
      "Escort",
      "EXP",
      "F-150",
      "F-250",
      "F-350",
      "Festiva",
      "LTD Crown Victoria",
      "Mustang",
      "Ranger",
      "Taurus",
      "Tempo",
      "Thunderbird"
    ],
    "GMC": [
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "G1500",
      "G2500",
      "G3500",
      "Jimmy",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "P2500",
      "P3500",
      "R1500 Suburban",
      "R2500",
      "R2500 Suburban",
      "R3500",
      "S15",
      "S15 Jimmy",
      "Safari",
      "V1500 Suburban",
      "V2500 Suburban",
      "V3500"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "CRX",
      "Prelude"
    ],
    "Hyundai": [
      "Excel"
    ],
    "Jaguar": [
      "Vanden Plas",
      "XJ6",
      "XJS"
    ],
    "Jeep": [
      "Cherokee",
      "Comanche",
      "Grand Wagoneer",
      "J10",
      "Wagoneer",
      "Wrangler"
    ],
    "Land Rover": [
      "Range Rover"
    ],
    "Lincoln": [
      "Continental",
      "Mark VII",
      "Town Car"
    ],
    "Lotus": [
      "Esprit"
    ],
    "Maserati": [
      "Spyder"
    ],
    "Mazda": [
      "323",
      "626",
      "929",
      "B2200",
      "B2600",
      "MX-6",
      "RX-7"
    ],
    "Mercedes-Benz": [
      "190D",
      "190E",
      "260E",
      "300CE",
      "300D",
      "300E",
      "300SE",
      "300SEL",
      "300TE",
      "420SEL",
      "560SEC",
      "560SEL",
      "560SL"
    ],
    "Mercury": [
      "Colony Park",
      "Cougar",
      "Grand Marquis",
      "Sable",
      "Topaz",
      "Tracer"
    ],
    "Mitsubishi": [
      "Galant",
      "Mirage",
      "Precis",
      "Starion",
      "Van"
    ],
    "Nissan": [
      "200SX",
      "300ZX",
      "D21",
      "Maxima",
      "Micra",
      "Pathfinder",
      "Pulsar NX",
      "Sentra",
      "Stanza",
      "Van"
    ],
    "Oldsmobile": [
      "98",
      "Custom Cruiser",
      "Cutlass Calais",
      "Cutlass Ciera",
      "Cutlass Cruiser",
      "Cutlass Supreme",
      "Delta 88",
      "Firenza",
      "Toronado"
    ],
    "Plymouth": [
      "Caravelle",
      "Colt",
      "Gran Fury",
      "Grand Voyager",
      "Horizon",
      "Reliant",
      "Sundance",
      "Voyager"
    ],
    "Pontiac": [
      "6000",
      "Bonneville",
      "Fiero",
      "Firebird",
      "Firefly",
      "Grand Am",
      "Grand Prix",
      "LeMans",
      "Safari",
      "Sunbird",
      "Tempest"
    ],
    "Porsche": [
      "911",
      "924",
      "928",
      "944"
    ],
    "Rolls-Royce": [
      "Corniche II",
      "Silver Spirit",
      "Silver Spur"
    ],
    "Saab": [
      "900"
    ],
    "Subaru": [
      "XT"
    ],
    "Suzuki": [
      "Samurai"
    ],
    "Toyota": [
      "4Runner",
      "Camry",
      "Celica",
      "Corolla",
      "Cressida",
      "Land Cruiser",
      "MR2",
      "Pickup",
      "Supra",
      "Tercel",
      "Van"
    ],
    "Volkswagen": [
      "Cabriolet",
      "Fox",
      "Golf",
      "Jetta",
      "Scirocco",
      "Vanagon"
    ],
    "Volvo": [
      "244",
      "245",
      "740",
      "760",
      "780"
    ]
  },
  "1989": {
    "Acura": [
      "Legend"
    ],
    "Alfa Romeo": [
      "Milano"
    ],
    "Audi": [
      "100",
      "100 Quattro",
      "200",
      "200 Quattro",
      "80",
      "80 Quattro",
      "90",
      "90 Quattro"
    ],
    "Bentley": [
      "Continental",
      "Eight",
      "Mulsanne",
      "Turbo R"
    ],
    "BMW": [
      "325i",
      "325is",
      "325iX",
      "535i",
      "M3"
    ],
    "Buick": [
      "Century",
      "Electra",
      "LeSabre",
      "Reatta",
      "Regal",
      "Riviera",
      "Skyhawk",
      "Skylark"
    ],
    "Cadillac": [
      "Allante",
      "Brougham",
      "DeVille",
      "Eldorado",
      "Fleetwood",
      "Seville"
    ],
    "Chevrolet": [
      "Astro",
      "Beretta",
      "Blazer",
      "C1500",
      "C2500",
      "C3500",
      "Camaro",
      "Caprice",
      "Cavalier",
      "Celebrity",
      "Corsica",
      "Corvette",
      "G10",
      "G20",
      "G30",
      "Impala",
      "K1500",
      "K2500",
      "K3500",
      "P20",
      "P30",
      "R1500 Suburban",
      "R2500",
      "R2500 Suburban",
      "R3500",
      "S10",
      "S10 Blazer",
      "Sprint",
      "V1500 Suburban",
      "V2500 Suburban",
      "V3500"
    ],
    "Chrysler": [
      "Conquest",
      "Daytona",
      "Fifth Avenue",
      "LeBaron",
      "New Yorker",
      "TC Maserati",
      "Town & Country"
    ],
    "Dodge": [
      "2000 GTX",
      "Aries",
      "B150",
      "B250",
      "B350",
      "Caravan",
      "Colt",
      "D100",
      "D150",
      "D250",
      "D350",
      "Dakota",
      "Daytona",
      "Diplomat",
      "Dynasty",
      "Grand Caravan",
      "Lancer",
      "Omni",
      "Ram 50",
      "Ramcharger",
      "Shadow",
      "Spirit",
      "W100",
      "W150",
      "W250",
      "W350"
    ],
    "Ferrari": [
      "328 GTB",
      "328 GTS",
      "348 TS",
      "Mondial t",
      "Testarossa"
    ],
    "Ford": [
      "Aerostar",
      "Bronco",
      "Bronco II",
      "Country Squire",
      "E-150 Econoline",
      "E-150 Econoline Club Wagon",
      "E-250 Econoline",
      "E-250 Econoline Club Wagon",
      "E-350 Econoline",
      "E-350 Econoline Club Wagon",
      "Escort",
      "F-150",
      "F-250",
      "F-350",
      "Festiva",
      "LTD Crown Victoria",
      "Mustang",
      "Probe",
      "Ranger",
      "Taurus",
      "Tempo",
      "Thunderbird"
    ],
    "Geo": [
      "Metro",
      "Spectrum",
      "Tracker"
    ],
    "GMC": [
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "G1500",
      "G2500",
      "G3500",
      "Jimmy",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "P2500",
      "P3500",
      "R1500 Suburban",
      "R2500",
      "R2500 Suburban",
      "R3500",
      "S15",
      "S15 Jimmy",
      "Safari",
      "V1500 Suburban",
      "V2500 Suburban",
      "V3500"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "CRX",
      "Prelude"
    ],
    "Hyundai": [
      "Sonata"
    ],
    "Jaguar": [
      "Vanden Plas",
      "XJ6",
      "XJS"
    ],
    "Jeep": [
      "Cherokee",
      "Comanche",
      "Grand Wagoneer",
      "Wagoneer",
      "Wrangler"
    ],
    "Land Rover": [
      "Range Rover"
    ],
    "Lincoln": [
      "Continental",
      "Mark VII",
      "Town Car"
    ],
    "Lotus": [
      "Esprit"
    ],
    "Maserati": [
      "228i",
      "430i",
      "Spyder"
    ],
    "Mazda": [
      "323",
      "626",
      "929",
      "B2200",
      "B2600",
      "MPV",
      "MX-6",
      "RX-7"
    ],
    "Mercedes-Benz": [
      "190D",
      "190E",
      "260E",
      "300CE",
      "300D",
      "300E",
      "300SE",
      "300SEL",
      "300TE",
      "420SEL",
      "560SEC",
      "560SEL",
      "560SL"
    ],
    "Mercury": [
      "Colony Park",
      "Cougar",
      "Grand Marquis",
      "Sable",
      "Topaz",
      "Tracer"
    ],
    "Mitsubishi": [
      "Galant",
      "Mirage",
      "Precis",
      "Van"
    ],
    "Nissan": [
      "240SX",
      "300ZX",
      "D21",
      "Maxima",
      "Micra",
      "Pathfinder",
      "Pulsar NX",
      "Sentra",
      "Stanza"
    ],
    "Oldsmobile": [
      "98",
      "Custom Cruiser",
      "Cutlass Calais",
      "Cutlass Ciera",
      "Cutlass Cruiser",
      "Cutlass Supreme",
      "Delta 88",
      "Toronado"
    ],
    "Plymouth": [
      "Acclaim",
      "Colt",
      "Gran Fury",
      "Grand Voyager",
      "Horizon",
      "Reliant",
      "Sundance",
      "Voyager"
    ],
    "Pontiac": [
      "6000",
      "Bonneville",
      "Firebird",
      "Firefly",
      "Grand Am",
      "Grand Prix",
      "LeMans",
      "Safari",
      "Sunbird",
      "Tempest"
    ],
    "Porsche": [
      "911",
      "928",
      "944"
    ],
    "Rolls-Royce": [
      "Corniche II",
      "Silver Spirit",
      "Silver Spur"
    ],
    "Saab": [
      "900"
    ],
    "Subaru": [
      "Justy",
      "XT"
    ],
    "Suzuki": [
      "Samurai",
      "Sidekick",
      "Swift"
    ],
    "Toyota": [
      "4Runner",
      "Camry",
      "Celica",
      "Corolla",
      "Cressida",
      "Land Cruiser",
      "MR2",
      "Pickup",
      "Supra",
      "Tercel",
      "Van"
    ],
    "Volkswagen": [
      "Cabriolet",
      "Fox",
      "Golf",
      "Jetta",
      "Scirocco",
      "Vanagon"
    ],
    "Volvo": [
      "244",
      "245",
      "740",
      "760",
      "780"
    ]
  },
  "1990": {
    "Acura": [
      "Integra",
      "Legend"
    ],
    "Audi": [
      "100",
      "100 Quattro",
      "200",
      "200 Quattro",
      "80",
      "90",
      "90 Quattro",
      "Coupe Quattro",
      "V8 Quattro"
    ],
    "Bentley": [
      "Continental",
      "Eight",
      "Mulsanne",
      "Turbo R"
    ],
    "BMW": [
      "325i",
      "325is",
      "325iX",
      "535i",
      "M3"
    ],
    "Buick": [
      "Century",
      "Electra",
      "LeSabre",
      "Reatta",
      "Regal",
      "Riviera",
      "Skylark"
    ],
    "Cadillac": [
      "Allante",
      "Brougham",
      "DeVille",
      "Eldorado",
      "Fleetwood",
      "Seville"
    ],
    "Chevrolet": [
      "Astro",
      "Beretta",
      "Blazer",
      "C1500",
      "C2500",
      "C3500",
      "Camaro",
      "Caprice",
      "Cavalier",
      "Celebrity",
      "Corsica",
      "Corvette",
      "G10",
      "G20",
      "G30",
      "Impala",
      "K1500",
      "K2500",
      "K3500",
      "Lumina",
      "Lumina APV",
      "P30",
      "R1500 Suburban",
      "R2500 Suburban",
      "R3500",
      "S10",
      "S10 Blazer",
      "Sprint",
      "V1500 Suburban",
      "V2500 Suburban",
      "V3500"
    ],
    "Chrysler": [
      "Daytona",
      "Imperial",
      "LeBaron",
      "New Yorker",
      "TC Maserati",
      "Town & Country"
    ],
    "Dodge": [
      "B150",
      "B250",
      "B350",
      "Caravan",
      "Colt",
      "D150",
      "D250",
      "D350",
      "Dakota",
      "Daytona",
      "Dynasty",
      "Grand Caravan",
      "Omni",
      "Ram 50",
      "Ramcharger",
      "Shadow",
      "Spirit",
      "W150",
      "W250",
      "W350"
    ],
    "Ferrari": [
      "348 TB",
      "348 TS",
      "F40",
      "Mondial t",
      "Testarossa"
    ],
    "Ford": [
      "Aerostar",
      "Bronco",
      "Bronco II",
      "Country Squire",
      "E-150 Econoline",
      "E-150 Econoline Club Wagon",
      "E-250 Econoline",
      "E-250 Econoline Club Wagon",
      "E-350 Econoline",
      "E-350 Econoline Club Wagon",
      "Escort",
      "F-150",
      "F-250",
      "F-350",
      "Festiva",
      "LTD Crown Victoria",
      "Mustang",
      "Probe",
      "Ranger",
      "Taurus",
      "Tempo",
      "Thunderbird"
    ],
    "Geo": [
      "Metro",
      "Prizm",
      "Tracker"
    ],
    "GMC": [
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "G1500",
      "G2500",
      "G3500",
      "Jimmy",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "P3500",
      "R1500 Suburban",
      "R2500 Suburban",
      "R3500",
      "S15",
      "S15 Jimmy",
      "Safari",
      "V1500 Suburban",
      "V2500 Suburban",
      "V3500"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "CRX",
      "Prelude"
    ],
    "Hyundai": [
      "Excel",
      "Sonata"
    ],
    "INFINITI": [
      "Q45"
    ],
    "Jaguar": [
      "Vanden Plas",
      "XJ6",
      "XJS"
    ],
    "Jeep": [
      "Cherokee",
      "Comanche",
      "Grand Wagoneer",
      "Wagoneer",
      "Wrangler"
    ],
    "Land Rover": [
      "Range Rover"
    ],
    "Lexus": [
      "ES250"
    ],
    "Lincoln": [
      "Continental",
      "Mark VII",
      "Town Car"
    ],
    "Lotus": [
      "Esprit"
    ],
    "Maserati": [
      "228i",
      "Spyder"
    ],
    "Mazda": [
      "323",
      "626",
      "929",
      "B2200",
      "B2600",
      "Miata",
      "MPV",
      "MX-6",
      "Protege",
      "RX-7"
    ],
    "Mercedes-Benz": [
      "190E",
      "300CE",
      "300D",
      "300E",
      "300SE",
      "300SEL",
      "300SL",
      "300TE",
      "350SDL",
      "420SEL",
      "500SL",
      "560SEC",
      "560SEL"
    ],
    "Mercury": [
      "Colony Park",
      "Cougar",
      "Grand Marquis",
      "Sable",
      "Topaz",
      "Tracer"
    ],
    "Mitsubishi": [
      "Eclipse",
      "Galant",
      "Mirage",
      "Montero"
    ],
    "Nissan": [
      "240SX",
      "300ZX",
      "Axxess",
      "D21",
      "Maxima",
      "Micra",
      "Pathfinder",
      "Pulsar NX",
      "Sentra",
      "Stanza"
    ],
    "Oldsmobile": [
      "98",
      "Custom Cruiser",
      "Cutlass Calais",
      "Cutlass Ciera",
      "Cutlass Cruiser",
      "Cutlass Supreme",
      "Delta 88",
      "Silhouette",
      "Toronado"
    ],
    "Plymouth": [
      "Acclaim",
      "Colt",
      "Grand Voyager",
      "Horizon",
      "Laser",
      "Sundance",
      "Voyager"
    ],
    "Pontiac": [
      "6000",
      "Bonneville",
      "Firebird",
      "Firefly",
      "Grand Am",
      "Grand Prix",
      "LeMans",
      "Sunbird",
      "Tempest",
      "Trans Sport"
    ],
    "Porsche": [
      "911",
      "928",
      "944"
    ],
    "Rolls-Royce": [
      "Corniche II",
      "Silver Spirit",
      "Silver Spur"
    ],
    "Saab": [
      "900"
    ],
    "Subaru": [
      "Justy",
      "Legacy",
      "XT"
    ],
    "Suzuki": [
      "Samurai",
      "Sidekick",
      "Swift"
    ],
    "Toyota": [
      "4Runner",
      "Camry",
      "Celica",
      "Corolla",
      "Cressida",
      "Land Cruiser",
      "Pickup",
      "Supra",
      "Tercel"
    ],
    "Volkswagen": [
      "Cabriolet",
      "Corrado",
      "Fox",
      "Golf",
      "Jetta",
      "Passat",
      "Vanagon"
    ],
    "Volvo": [
      "240",
      "740",
      "760",
      "780"
    ]
  },
  "1991": {
    "Acura": [
      "Integra",
      "Legend",
      "NSX"
    ],
    "Aston Martin": [
      "Virage"
    ],
    "Audi": [
      "100",
      "100 Quattro",
      "200",
      "200 Quattro",
      "80",
      "90",
      "90 Quattro",
      "Coupe Quattro",
      "V8 Quattro"
    ],
    "Bentley": [
      "Continental",
      "Mulsanne",
      "Turbo R"
    ],
    "BMW": [
      "318i",
      "318is",
      "325i",
      "325is",
      "325iX",
      "525i",
      "535i",
      "850i",
      "M3"
    ],
    "Buick": [
      "Century",
      "Commercial Chassis",
      "LeSabre",
      "Park Avenue",
      "Reatta",
      "Regal",
      "Riviera",
      "Roadmaster",
      "Skylark"
    ],
    "Cadillac": [
      "Allante",
      "Brougham",
      "DeVille",
      "Eldorado",
      "Fleetwood",
      "Seville"
    ],
    "Chevrolet": [
      "Astro",
      "Beretta",
      "Blazer",
      "C1500",
      "C2500",
      "C3500",
      "Camaro",
      "Caprice",
      "Cavalier",
      "Corsica",
      "Corvette",
      "G10",
      "G20",
      "G30",
      "Impala",
      "K1500",
      "K2500",
      "K3500",
      "Lumina",
      "Lumina APV",
      "P30",
      "R1500 Suburban",
      "R2500 Suburban",
      "R3500",
      "S10",
      "S10 Blazer",
      "Sprint",
      "V1500 Suburban",
      "V2500 Suburban",
      "V3500"
    ],
    "Chrysler": [
      "Daytona",
      "Imperial",
      "LeBaron",
      "New Yorker",
      "TC Maserati",
      "Town & Country"
    ],
    "Dodge": [
      "B150",
      "B250",
      "B350",
      "Caravan",
      "Colt",
      "D150",
      "D250",
      "D350",
      "Dakota",
      "Daytona",
      "Dynasty",
      "Grand Caravan",
      "Ram 50",
      "Ramcharger",
      "Shadow",
      "Spirit",
      "Stealth",
      "W150",
      "W250",
      "W350"
    ],
    "Ferrari": [
      "348 TB",
      "348 TS",
      "F40",
      "Mondial t",
      "Testarossa"
    ],
    "Ford": [
      "Aerostar",
      "Bronco",
      "Country Squire",
      "E-150 Econoline",
      "E-150 Econoline Club Wagon",
      "E-250 Econoline",
      "E-250 Econoline Club Wagon",
      "E-350 Econoline",
      "E-350 Econoline Club Wagon",
      "Escort",
      "Explorer",
      "F-150",
      "F-250",
      "F-350",
      "Festiva",
      "LTD Crown Victoria",
      "Mustang",
      "Probe",
      "Ranger",
      "Taurus",
      "Tempo",
      "Thunderbird"
    ],
    "Geo": [
      "Metro",
      "Prizm",
      "Tracker"
    ],
    "GMC": [
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "G1500",
      "G2500",
      "G3500",
      "Jimmy",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "P3500",
      "R1500 Suburban",
      "R2500 Suburban",
      "R3500",
      "S15 Jimmy",
      "Safari",
      "Sonoma",
      "Syclone",
      "V1500 Suburban",
      "V2500 Suburban",
      "V3500"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "CRX",
      "Prelude"
    ],
    "Hyundai": [
      "Excel",
      "Scoupe",
      "Sonata"
    ],
    "INFINITI": [
      "G20",
      "M30",
      "Q45"
    ],
    "Jaguar": [
      "Vanden Plas",
      "XJ6",
      "XJS"
    ],
    "Jeep": [
      "Cherokee",
      "Comanche",
      "Grand Wagoneer",
      "Wrangler"
    ],
    "Land Rover": [
      "Range Rover"
    ],
    "Lexus": [
      "ES250"
    ],
    "Lincoln": [
      "Continental",
      "Mark VII",
      "Town Car"
    ],
    "Lotus": [
      "Elan",
      "Esprit"
    ],
    "Maserati": [
      "Spyder"
    ],
    "Mazda": [
      "323",
      "626",
      "929",
      "B2200",
      "B2600",
      "Miata",
      "MPV",
      "MX-6",
      "Navajo",
      "Protege",
      "RX-7"
    ],
    "Mercedes-Benz": [
      "190E",
      "300CE",
      "300D",
      "300E",
      "300SE",
      "300SEL",
      "300SL",
      "300TE",
      "350SD",
      "350SDL",
      "420SEL",
      "500SL",
      "560SEC",
      "560SEL"
    ],
    "Mercury": [
      "Capri",
      "Colony Park",
      "Cougar",
      "Grand Marquis",
      "Sable",
      "Topaz",
      "Tracer"
    ],
    "Mitsubishi": [
      "3000GT",
      "Eclipse",
      "Galant",
      "Mirage",
      "Montero"
    ],
    "Nissan": [
      "240SX",
      "300ZX",
      "Axxess",
      "D21",
      "Maxima",
      "Micra",
      "NX",
      "Pathfinder",
      "Sentra",
      "Stanza"
    ],
    "Oldsmobile": [
      "98",
      "Bravada",
      "Custom Cruiser",
      "Cutlass Calais",
      "Cutlass Ciera",
      "Cutlass Cruiser",
      "Cutlass Supreme",
      "Delta 88",
      "Silhouette",
      "Toronado"
    ],
    "Plymouth": [
      "Acclaim",
      "Colt",
      "Grand Voyager",
      "Laser",
      "Sundance",
      "Voyager"
    ],
    "Pontiac": [
      "6000",
      "Bonneville",
      "Firebird",
      "Firefly",
      "Grand Am",
      "Grand Prix",
      "LeMans",
      "Sunbird",
      "Trans Sport"
    ],
    "Porsche": [
      "911",
      "928",
      "944"
    ],
    "Rolls-Royce": [
      "Corniche II",
      "Silver Spirit",
      "Silver Spur"
    ],
    "Saab": [
      "900"
    ],
    "Saturn": [
      "SL1",
      "SL2"
    ],
    "Subaru": [
      "Justy",
      "Legacy",
      "XT"
    ],
    "Suzuki": [
      "Samurai",
      "Sidekick",
      "Swift"
    ],
    "Toyota": [
      "4Runner",
      "Camry",
      "Celica",
      "Corolla",
      "Cressida",
      "Land Cruiser",
      "MR2",
      "Pickup",
      "Supra",
      "Tercel"
    ],
    "Volkswagen": [
      "Cabriolet",
      "Corrado",
      "Fox",
      "Golf",
      "Jetta",
      "Passat",
      "Vanagon"
    ],
    "Volvo": [
      "240",
      "780"
    ]
  },
  "1992": {
    "Acura": [
      "Integra",
      "Legend",
      "NSX",
      "Vigor"
    ],
    "Aston Martin": [
      "Virage"
    ],
    "Audi": [
      "100",
      "100 Quattro",
      "80",
      "90",
      "90 Quattro",
      "S4",
      "V8 Quattro"
    ],
    "Bentley": [
      "Continental",
      "Mulsanne",
      "Turbo R"
    ],
    "BMW": [
      "318i",
      "318is",
      "325i",
      "325is",
      "525i",
      "535i",
      "735i",
      "735iL",
      "750iL",
      "850i",
      "M3"
    ],
    "Buick": [
      "Century",
      "Commercial Chassis",
      "LeSabre",
      "Park Avenue",
      "Regal",
      "Riviera",
      "Roadmaster",
      "Skylark"
    ],
    "Cadillac": [
      "Allante",
      "Brougham",
      "DeVille",
      "Eldorado",
      "Fleetwood",
      "Seville"
    ],
    "Chevrolet": [
      "Astro",
      "Beretta",
      "Blazer",
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "Camaro",
      "Caprice",
      "Cavalier",
      "Corsica",
      "Corvette",
      "G10",
      "G20",
      "G30",
      "Impala",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "Lumina",
      "Lumina APV",
      "P30",
      "S10",
      "S10 Blazer"
    ],
    "Chrysler": [
      "Daytona",
      "Imperial",
      "LeBaron",
      "New Yorker",
      "Town & Country"
    ],
    "Dodge": [
      "B150",
      "B250",
      "B350",
      "Caravan",
      "Colt",
      "D150",
      "D250",
      "D350",
      "Dakota",
      "Daytona",
      "Dynasty",
      "Grand Caravan",
      "Ram 50",
      "Ramcharger",
      "Shadow",
      "Spirit",
      "Stealth",
      "W150",
      "W250",
      "W350"
    ],
    "Ferrari": [
      "348 TB",
      "348 TS",
      "512 TR",
      "F40",
      "Mondial t"
    ],
    "Ford": [
      "Aerostar",
      "Bronco",
      "Crown Victoria",
      "E-150 Econoline",
      "E-150 Econoline Club Wagon",
      "E-250 Econoline",
      "E-350 Econoline",
      "E-350 Econoline Club Wagon",
      "Escort",
      "Explorer",
      "F-150",
      "F-250",
      "F-350",
      "Festiva",
      "Mustang",
      "Probe",
      "Ranger",
      "Taurus",
      "Tempo",
      "Thunderbird"
    ],
    "Geo": [
      "Metro",
      "Prizm",
      "Tracker"
    ],
    "GMC": [
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "G1500",
      "G2500",
      "G3500",
      "Jimmy",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "P3500",
      "Safari",
      "Sonoma",
      "Typhoon",
      "Yukon"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "Prelude"
    ],
    "Hyundai": [
      "Elantra",
      "Excel",
      "Scoupe",
      "Sonata"
    ],
    "INFINITI": [
      "G20",
      "M30",
      "Q45"
    ],
    "Jaguar": [
      "Vanden Plas",
      "XJ6",
      "XJS"
    ],
    "Jeep": [
      "Cherokee",
      "Comanche",
      "Grand Wagoneer",
      "Wrangler"
    ],
    "Land Rover": [
      "Range Rover"
    ],
    "Lexus": [
      "ES300",
      "SC300",
      "SC400"
    ],
    "Lincoln": [
      "Continental",
      "Mark VII",
      "Town Car"
    ],
    "Lotus": [
      "Elan",
      "Esprit"
    ],
    "Mazda": [
      "323",
      "626",
      "929",
      "B2200",
      "B2600",
      "Miata",
      "MPV",
      "MX-3",
      "MX-6",
      "Navajo",
      "Protege"
    ],
    "Mercedes-Benz": [
      "190E",
      "300CE",
      "300D",
      "300E",
      "300SL",
      "300TE",
      "400E",
      "400SE",
      "500E",
      "500SEL",
      "500SL",
      "600SEL"
    ],
    "Mercury": [
      "Capri",
      "Cougar",
      "Grand Marquis",
      "Sable",
      "Topaz",
      "Tracer"
    ],
    "Mitsubishi": [
      "3000GT",
      "Diamante",
      "Eclipse",
      "Expo",
      "Galant",
      "Mirage"
    ],
    "Nissan": [
      "240SX",
      "300ZX",
      "Axxess",
      "D21",
      "Maxima",
      "NX",
      "Pathfinder",
      "Sentra",
      "Stanza"
    ],
    "Oldsmobile": [
      "88",
      "98",
      "Achieva",
      "Bravada",
      "Custom Cruiser",
      "Cutlass Ciera",
      "Cutlass Cruiser",
      "Cutlass Supreme",
      "Silhouette",
      "Toronado"
    ],
    "Plymouth": [
      "Acclaim",
      "Colt",
      "Grand Voyager",
      "Laser",
      "Sundance",
      "Voyager"
    ],
    "Pontiac": [
      "Bonneville",
      "Firebird",
      "Firefly",
      "Grand Am",
      "Grand Prix",
      "LeMans",
      "Sunbird",
      "Trans Sport"
    ],
    "Porsche": [
      "911",
      "928",
      "968"
    ],
    "Rolls-Royce": [
      "Silver Spirit",
      "Silver Spur"
    ],
    "Saab": [
      "900"
    ],
    "Saturn": [
      "SC",
      "SL",
      "SL1",
      "SL2"
    ],
    "Subaru": [
      "Justy",
      "Legacy",
      "SVX"
    ],
    "Suzuki": [
      "Samurai",
      "Sidekick",
      "Swift"
    ],
    "Toyota": [
      "4Runner",
      "Camry",
      "Celica",
      "Corolla",
      "Cressida",
      "Land Cruiser",
      "MR2",
      "Paseo",
      "Pickup",
      "Supra",
      "Tercel"
    ],
    "Volkswagen": [
      "Cabriolet",
      "Corrado",
      "Fox",
      "Golf",
      "Jetta",
      "Passat"
    ],
    "Volvo": [
      "240"
    ]
  },
  "1993": {
    "Acura": [
      "Integra",
      "Legend",
      "NSX",
      "Vigor"
    ],
    "Aston Martin": [
      "Virage"
    ],
    "Audi": [
      "100",
      "100 Quattro",
      "90",
      "90 Quattro",
      "S4",
      "V8 Quattro"
    ],
    "Bentley": [
      "Brooklands",
      "Continental",
      "Turbo R"
    ],
    "BMW": [
      "318i",
      "318is",
      "320i",
      "325i",
      "325is",
      "525i",
      "525iT",
      "535i",
      "740i",
      "740iL",
      "750iL",
      "850Ci",
      "M3"
    ],
    "Buick": [
      "Century",
      "Commercial Chassis",
      "LeSabre",
      "Park Avenue",
      "Regal",
      "Riviera",
      "Roadmaster",
      "Skylark"
    ],
    "Cadillac": [
      "60 Special",
      "Allante",
      "Commercial Chassis",
      "DeVille",
      "Eldorado",
      "Fleetwood",
      "Seville"
    ],
    "Chevrolet": [
      "Astro",
      "Beretta",
      "Blazer",
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "Camaro",
      "Caprice",
      "Cavalier",
      "Corsica",
      "Corvette",
      "G10",
      "G20",
      "G30",
      "Impala",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "Lumina",
      "Lumina APV",
      "P30",
      "S10",
      "S10 Blazer"
    ],
    "Chrysler": [
      "Concorde",
      "Imperial",
      "Intrepid",
      "LeBaron",
      "New Yorker",
      "Town & Country"
    ],
    "Dodge": [
      "B150",
      "B250",
      "B350",
      "Caravan",
      "Colt",
      "D150",
      "D250",
      "D350",
      "Dakota",
      "Daytona",
      "Dynasty",
      "Grand Caravan",
      "Intrepid",
      "Ram 50",
      "Ramcharger",
      "Shadow",
      "Spirit",
      "Stealth",
      "W150",
      "W250",
      "W350"
    ],
    "Ferrari": [
      "348 GTB",
      "348 GTS",
      "512 TR"
    ],
    "Ford": [
      "Aerostar",
      "Bronco",
      "Crown Victoria",
      "E-150 Econoline",
      "E-150 Econoline Club Wagon",
      "E-250 Econoline",
      "E-350 Econoline",
      "E-350 Econoline Club Wagon",
      "Escort",
      "Explorer",
      "F-150",
      "F-250",
      "F-350",
      "Festiva",
      "Mustang",
      "Probe",
      "Ranger",
      "Taurus",
      "Tempo",
      "Thunderbird"
    ],
    "Geo": [
      "Metro",
      "Prizm",
      "Tracker"
    ],
    "GMC": [
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "G1500",
      "G2500",
      "G3500",
      "Jimmy",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "P3500",
      "Safari",
      "Sonoma",
      "Typhoon",
      "Yukon"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "Civic del Sol",
      "Prelude"
    ],
    "Hyundai": [
      "Elantra",
      "Excel",
      "Scoupe",
      "Sonata"
    ],
    "INFINITI": [
      "G20",
      "J30",
      "Q45"
    ],
    "Jaguar": [
      "Vanden Plas",
      "XJ6",
      "XJRS",
      "XJS"
    ],
    "Jeep": [
      "Cherokee",
      "Grand Cherokee",
      "Grand Wagoneer",
      "Wrangler"
    ],
    "Land Rover": [
      "Defender 110",
      "Range Rover"
    ],
    "Lexus": [
      "ES300",
      "GS300",
      "LS400",
      "SC300",
      "SC400"
    ],
    "Lincoln": [
      "Continental",
      "Mark VIII",
      "Town Car"
    ],
    "Lotus": [
      "Esprit"
    ],
    "Mazda": [
      "323",
      "626",
      "929",
      "B2200",
      "B2600",
      "Miata",
      "MPV",
      "MX-3",
      "MX-6",
      "Navajo",
      "Protege"
    ],
    "Mercedes-Benz": [
      "190E",
      "300CE",
      "300D",
      "300E",
      "300SL",
      "300TE",
      "400E",
      "400SEL",
      "500E",
      "500SEC",
      "500SEL",
      "500SL",
      "600SEC",
      "600SEL",
      "600SL"
    ],
    "Mercury": [
      "Capri",
      "Cougar",
      "Grand Marquis",
      "Sable",
      "Topaz",
      "Tracer",
      "Villager"
    ],
    "Mitsubishi": [
      "3000GT",
      "Diamante",
      "Eclipse",
      "Expo",
      "Expo LRV",
      "Galant",
      "Mirage"
    ],
    "Nissan": [
      "240SX",
      "300ZX",
      "Altima",
      "Axxess",
      "D21",
      "Maxima",
      "NX",
      "Pathfinder",
      "Quest",
      "Sentra"
    ],
    "Oldsmobile": [
      "88",
      "98",
      "Achieva",
      "Bravada",
      "Cutlass Ciera",
      "Cutlass Cruiser",
      "Cutlass Supreme",
      "Silhouette"
    ],
    "Plymouth": [
      "Acclaim",
      "Colt",
      "Grand Voyager",
      "Laser",
      "Sundance",
      "Voyager"
    ],
    "Pontiac": [
      "Bonneville",
      "Firebird",
      "Firefly",
      "Grand Am",
      "Grand Prix",
      "Sunbird",
      "Trans Sport"
    ],
    "Porsche": [
      "911",
      "928",
      "968"
    ],
    "Rolls-Royce": [
      "Silver Spur"
    ],
    "Saab": [
      "900"
    ],
    "Saturn": [
      "SC1",
      "SC2",
      "SL",
      "SL1",
      "SL2",
      "SW1",
      "SW2"
    ],
    "Subaru": [
      "Impreza",
      "Justy",
      "Legacy",
      "SVX"
    ],
    "Suzuki": [
      "Samurai",
      "Sidekick",
      "Swift"
    ],
    "Toyota": [
      "4Runner",
      "Camry",
      "Celica",
      "Corolla",
      "Land Cruiser",
      "MR2",
      "Paseo",
      "Pickup",
      "Supra",
      "T100",
      "Tercel"
    ],
    "Volkswagen": [
      "Cabriolet",
      "Corrado",
      "Fox",
      "Golf",
      "Jetta",
      "Passat"
    ],
    "Volvo": [
      "240",
      "850",
      "940"
    ]
  },
  "1994": {
    "Acura": [
      "Integra",
      "Legend",
      "NSX",
      "Vigor"
    ],
    "Audi": [
      "100",
      "100 Quattro",
      "90",
      "90 Quattro",
      "Cabriolet",
      "S4"
    ],
    "Bentley": [
      "Brooklands",
      "Continental",
      "Turbo R"
    ],
    "BMW": [
      "318i",
      "318is",
      "320i",
      "325i",
      "325is",
      "525i",
      "530i",
      "540i",
      "740i",
      "740iL",
      "750iL",
      "840Ci",
      "850Ci",
      "850CSi",
      "M3"
    ],
    "Buick": [
      "Century",
      "Commercial Chassis",
      "LeSabre",
      "Park Avenue",
      "Regal",
      "Riviera",
      "Roadmaster",
      "Skylark"
    ],
    "Cadillac": [
      "Commercial Chassis",
      "DeVille",
      "Eldorado",
      "Fleetwood",
      "Seville"
    ],
    "Chevrolet": [
      "Astro",
      "Beretta",
      "Blazer",
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "Camaro",
      "Caprice",
      "Cavalier",
      "Corsica",
      "Corvette",
      "G10",
      "G20",
      "G30",
      "Impala",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "Lumina",
      "Lumina APV",
      "P30",
      "S10",
      "S10 Blazer"
    ],
    "Chrysler": [
      "Concorde",
      "Intrepid",
      "LeBaron",
      "LHS",
      "New Yorker",
      "Town & Country"
    ],
    "Dodge": [
      "B150",
      "B250",
      "B350",
      "Caravan",
      "Colt",
      "Dakota",
      "Grand Caravan",
      "Intrepid",
      "Ram 1500",
      "Ram 2500",
      "Ram 3500",
      "Shadow",
      "Spirit",
      "Stealth"
    ],
    "Ferrari": [
      "348 Spider"
    ],
    "Ford": [
      "Aerostar",
      "Aspire",
      "Bronco",
      "Crown Victoria",
      "E-150 Econoline",
      "E-150 Econoline Club Wagon",
      "E-250 Econoline",
      "E-350 Econoline",
      "E-350 Econoline Club Wagon",
      "Escort",
      "Explorer",
      "F-150",
      "F-250",
      "F-350",
      "Mustang",
      "Probe",
      "Ranger",
      "Taurus",
      "Tempo",
      "Thunderbird"
    ],
    "Geo": [
      "Metro",
      "Prizm",
      "Tracker"
    ],
    "GMC": [
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "G1500",
      "G2500",
      "G3500",
      "Jimmy",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "P3500",
      "Safari",
      "Sonoma",
      "Yukon"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "Civic del Sol",
      "Passport",
      "Prelude"
    ],
    "Hyundai": [
      "Elantra",
      "Excel",
      "Scoupe"
    ],
    "INFINITI": [
      "G20",
      "J30",
      "Q45"
    ],
    "Jaguar": [
      "Vanden Plas",
      "XJ12",
      "XJ6",
      "XJS"
    ],
    "Jeep": [
      "Cherokee",
      "Grand Cherokee",
      "Wrangler"
    ],
    "Kia": [
      "Sephia"
    ],
    "Land Rover": [
      "Defender 90",
      "Discovery",
      "Range Rover"
    ],
    "Lexus": [
      "ES300",
      "GS300",
      "LS400",
      "SC300",
      "SC400"
    ],
    "Lincoln": [
      "Continental",
      "Mark VIII",
      "Town Car"
    ],
    "Lotus": [
      "Esprit"
    ],
    "Mazda": [
      "323",
      "626",
      "929",
      "B2300",
      "B3000",
      "B4000",
      "Miata",
      "MPV",
      "MX-3",
      "MX-6",
      "Navajo",
      "Protege"
    ],
    "Mercedes-Benz": [
      "C220",
      "C280",
      "E320",
      "E420",
      "E500",
      "S320",
      "S350",
      "S420",
      "S500",
      "S600",
      "SL320",
      "SL500",
      "SL600"
    ],
    "Mercury": [
      "Capri",
      "Cougar",
      "Grand Marquis",
      "Sable",
      "Topaz",
      "Tracer",
      "Villager"
    ],
    "Mitsubishi": [
      "3000GT",
      "Diamante",
      "Eclipse",
      "Expo",
      "Expo LRV",
      "Galant",
      "Mirage"
    ],
    "Nissan": [
      "240SX",
      "300ZX",
      "Altima",
      "Axxess",
      "D21",
      "Maxima",
      "Pathfinder",
      "Quest",
      "Sentra"
    ],
    "Oldsmobile": [
      "88",
      "98",
      "Achieva",
      "Bravada",
      "Cutlass Ciera",
      "Cutlass Cruiser",
      "Cutlass Supreme",
      "Silhouette"
    ],
    "Plymouth": [
      "Acclaim",
      "Colt",
      "Grand Voyager",
      "Laser",
      "Sundance",
      "Voyager"
    ],
    "Pontiac": [
      "Bonneville",
      "Firebird",
      "Firefly",
      "Grand Am",
      "Grand Prix",
      "Sunbird",
      "Sunrunner",
      "Trans Sport"
    ],
    "Porsche": [
      "911",
      "928",
      "968"
    ],
    "Rolls-Royce": [
      "Corniche IV",
      "Silver Spur"
    ],
    "Saab": [
      "900"
    ],
    "Saturn": [
      "SC1",
      "SC2",
      "SL",
      "SL1",
      "SL2",
      "SW1",
      "SW2"
    ],
    "Subaru": [
      "Impreza",
      "Justy",
      "Legacy",
      "SVX"
    ],
    "Suzuki": [
      "Samurai",
      "Sidekick",
      "Swift"
    ],
    "Toyota": [
      "4Runner",
      "Camry",
      "Celica",
      "Corolla",
      "Land Cruiser",
      "MR2",
      "Paseo",
      "Pickup",
      "Supra",
      "T100",
      "Tercel"
    ],
    "Volkswagen": [
      "Corrado",
      "Golf",
      "Jetta",
      "Passat"
    ],
    "Volvo": [
      "850",
      "940"
    ]
  },
  "1995": {
    "Acura": [
      "Integra",
      "Legend",
      "NSX"
    ],
    "Audi": [
      "90",
      "90 Quattro",
      "A6",
      "A6 Quattro",
      "Cabriolet",
      "S4",
      "S6"
    ],
    "Bentley": [
      "Brooklands",
      "Continental",
      "Turbo R"
    ],
    "BMW": [
      "318i",
      "318is",
      "318ti",
      "320i",
      "325i",
      "325is",
      "525i",
      "530i",
      "540i",
      "740i",
      "740iL",
      "750iL",
      "840Ci",
      "850Ci",
      "M3"
    ],
    "Buick": [
      "Century",
      "Commercial Chassis",
      "LeSabre",
      "Park Avenue",
      "Regal",
      "Riviera",
      "Roadmaster",
      "Skylark"
    ],
    "Cadillac": [
      "Commercial Chassis",
      "DeVille",
      "Eldorado",
      "Fleetwood",
      "Seville"
    ],
    "Chevrolet": [
      "Astro",
      "Beretta",
      "Blazer",
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "Camaro",
      "Caprice",
      "Cavalier",
      "Corsica",
      "Corvette",
      "G10",
      "G20",
      "G30",
      "Impala",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "Lumina",
      "Lumina APV",
      "Monte Carlo",
      "P30",
      "S10",
      "Tahoe"
    ],
    "Chrysler": [
      "Cirrus",
      "Concorde",
      "Intrepid",
      "LeBaron",
      "LHS",
      "New Yorker",
      "Sebring",
      "Town & Country"
    ],
    "Dodge": [
      "Avenger",
      "B1500",
      "B2500",
      "B3500",
      "Caravan",
      "Colt",
      "Dakota",
      "Grand Caravan",
      "Intrepid",
      "Neon",
      "Ram 1500",
      "Ram 2500",
      "Ram 3500",
      "Spirit",
      "Stealth",
      "Stratus"
    ],
    "Ferrari": [
      "348 Spider",
      "512 M"
    ],
    "Ford": [
      "Aerostar",
      "Aspire",
      "Bronco",
      "Contour",
      "Crown Victoria",
      "E-150 Econoline",
      "E-150 Econoline Club Wagon",
      "E-250 Econoline",
      "E-350 Econoline",
      "E-350 Econoline Club Wagon",
      "Escort",
      "Explorer",
      "F-150",
      "F-250",
      "F-350",
      "Mustang",
      "Probe",
      "Ranger",
      "Taurus",
      "Thunderbird",
      "Windstar"
    ],
    "Geo": [
      "Metro",
      "Prizm",
      "Tracker"
    ],
    "GMC": [
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "G1500",
      "G2500",
      "G3500",
      "Jimmy",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "P3500",
      "Safari",
      "Sonoma",
      "Yukon"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "Civic del Sol",
      "Odyssey",
      "Passport",
      "Prelude"
    ],
    "Hyundai": [
      "Accent",
      "Elantra",
      "Scoupe",
      "Sonata"
    ],
    "INFINITI": [
      "G20",
      "J30",
      "Q45"
    ],
    "Jaguar": [
      "Vanden Plas",
      "XJ12",
      "XJ6",
      "XJR",
      "XJS"
    ],
    "Jeep": [
      "Cherokee",
      "Grand Cherokee",
      "Wrangler"
    ],
    "Kia": [
      "Sephia",
      "Sportage"
    ],
    "Land Rover": [
      "Defender 90",
      "Discovery",
      "Range Rover"
    ],
    "Lexus": [
      "ES300",
      "GS300",
      "SC300",
      "SC400"
    ],
    "Lincoln": [
      "Continental",
      "Mark VIII",
      "Town Car"
    ],
    "Lotus": [
      "Esprit"
    ],
    "Mazda": [
      "323",
      "626",
      "929",
      "B2300",
      "B3000",
      "B4000",
      "Miata",
      "Millenia",
      "MPV",
      "MX-3",
      "MX-6",
      "Protege"
    ],
    "Mercedes-Benz": [
      "C220",
      "C280",
      "C36 AMG",
      "E300",
      "E320",
      "E420",
      "E500",
      "S320",
      "S350",
      "S420",
      "S500",
      "S600",
      "SL320",
      "SL500",
      "SL600"
    ],
    "Mercury": [
      "Cougar",
      "Grand Marquis",
      "Mystique",
      "Sable",
      "Tracer",
      "Villager"
    ],
    "Mitsubishi": [
      "3000GT",
      "Diamante",
      "Eclipse",
      "Expo",
      "Galant",
      "Mirage"
    ],
    "Nissan": [
      "200SX",
      "240SX",
      "300ZX",
      "Altima",
      "Axxess",
      "Maxima",
      "Pathfinder",
      "Pickup",
      "Quest",
      "Sentra"
    ],
    "Oldsmobile": [
      "88",
      "98",
      "Achieva",
      "Aurora",
      "Bravada",
      "Cutlass Ciera",
      "Cutlass Supreme",
      "Silhouette"
    ],
    "Plymouth": [
      "Acclaim",
      "Colt",
      "Grand Voyager",
      "Neon",
      "Voyager"
    ],
    "Pontiac": [
      "Bonneville",
      "Firebird",
      "Firefly",
      "Grand Am",
      "Grand Prix",
      "Sunfire",
      "Sunrunner",
      "Trans Sport"
    ],
    "Porsche": [
      "911",
      "928",
      "968"
    ],
    "Rolls-Royce": [
      "Corniche S",
      "Flying Spur",
      "Silver Dawn",
      "Silver Spur"
    ],
    "Saab": [
      "900"
    ],
    "Saturn": [
      "SC1",
      "SC2",
      "SL",
      "SL1",
      "SL2",
      "SW1",
      "SW2"
    ],
    "Subaru": [
      "Impreza",
      "Justy",
      "Legacy",
      "SVX"
    ],
    "Suzuki": [
      "Esteem",
      "Samurai",
      "Sidekick",
      "Swift"
    ],
    "Toyota": [
      "4Runner",
      "Avalon",
      "Camry",
      "Celica",
      "Corolla",
      "Land Cruiser",
      "MR2",
      "Paseo",
      "Pickup",
      "Supra",
      "T100",
      "Tacoma",
      "Tercel"
    ],
    "Volkswagen": [
      "Cabrio",
      "Corrado",
      "Golf",
      "Jetta",
      "Passat"
    ],
    "Volvo": [
      "850",
      "940",
      "960"
    ]
  },
  "1996": {
    "Acura": [
      "Integra",
      "NSX",
      "RL",
      "TL"
    ],
    "Audi": [
      "A4",
      "A4 Quattro",
      "A6",
      "A6 Quattro",
      "Cabriolet",
      "S4",
      "S6"
    ],
    "Bentley": [
      "Azure",
      "Brooklands",
      "Continental",
      "Turbo R"
    ],
    "BMW": [
      "318i",
      "318is",
      "318ti",
      "320i",
      "325i",
      "328i",
      "328is",
      "540i",
      "740i",
      "740iL",
      "750iL",
      "840Ci",
      "850Ci",
      "M3",
      "Z3"
    ],
    "Buick": [
      "Century",
      "Commercial Chassis",
      "LeSabre",
      "Park Avenue",
      "Regal",
      "Riviera",
      "Roadmaster",
      "Skylark"
    ],
    "Cadillac": [
      "Commercial Chassis",
      "DeVille",
      "Eldorado",
      "Fleetwood",
      "Seville"
    ],
    "Chevrolet": [
      "Astro",
      "Beretta",
      "Blazer",
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "Camaro",
      "Caprice",
      "Cavalier",
      "Corsica",
      "Corvette",
      "Express 1500",
      "Express 2500",
      "G30",
      "Impala",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "Lumina",
      "Lumina APV",
      "Monte Carlo",
      "P30",
      "S10",
      "Tahoe"
    ],
    "Chrysler": [
      "Cirrus",
      "Concorde",
      "Intrepid",
      "LHS",
      "New Yorker",
      "Sebring",
      "Town & Country"
    ],
    "Dodge": [
      "Avenger",
      "B1500",
      "B2500",
      "B3500",
      "Caravan",
      "Dakota",
      "Grand Caravan",
      "Intrepid",
      "Neon",
      "Ram 1500",
      "Ram 2500",
      "Ram 3500",
      "Stealth",
      "Stratus"
    ],
    "Ford": [
      "Aerostar",
      "Aspire",
      "Bronco",
      "Contour",
      "Crown Victoria",
      "E-150 Econoline",
      "E-150 Econoline Club Wagon",
      "E-250 Econoline",
      "E-350 Econoline",
      "E-350 Econoline Club Wagon",
      "Escort",
      "Explorer",
      "F-150",
      "F-250",
      "F-350",
      "F-53 Motorhome Chassis",
      "Mustang",
      "Probe",
      "Ranger",
      "Taurus",
      "Thunderbird",
      "Windstar"
    ],
    "Geo": [
      "Metro",
      "Prizm",
      "Tracker"
    ],
    "GMC": [
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "G3500",
      "Jimmy",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "P3500",
      "Safari",
      "Savana 1500",
      "Savana 2500",
      "Savana 3500",
      "Sonoma",
      "Yukon"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "Civic del Sol",
      "Odyssey",
      "Passport",
      "Prelude"
    ],
    "Hyundai": [
      "Accent",
      "Elantra",
      "Sonata"
    ],
    "INFINITI": [
      "G20",
      "I30",
      "J30",
      "Q45"
    ],
    "Jaguar": [
      "Vanden Plas",
      "XJ12",
      "XJ6",
      "XJR",
      "XJS"
    ],
    "Jeep": [
      "Cherokee",
      "Grand Cherokee",
      "Wrangler"
    ],
    "Kia": [
      "Sephia",
      "Sportage"
    ],
    "Land Rover": [
      "Defender 90",
      "Discovery",
      "Range Rover"
    ],
    "Lexus": [
      "ES300",
      "GS300",
      "SC300",
      "SC400"
    ],
    "Lincoln": [
      "Continental",
      "Mark VIII",
      "Town Car"
    ],
    "Mazda": [
      "626",
      "B2300",
      "B3000",
      "B4000",
      "Miata",
      "Millenia",
      "MPV",
      "MX-3",
      "MX-6",
      "Protege"
    ],
    "Mercedes-Benz": [
      "C220",
      "C280",
      "C36 AMG",
      "E300",
      "E320",
      "E420",
      "E500",
      "S320",
      "S350",
      "S420",
      "S500",
      "S600",
      "SL320",
      "SL500",
      "SL600"
    ],
    "Mercury": [
      "Cougar",
      "Grand Marquis",
      "Mystique",
      "Sable",
      "Tracer",
      "Villager"
    ],
    "Mitsubishi": [
      "3000GT",
      "Diamante",
      "Eclipse",
      "Galant",
      "Mirage"
    ],
    "Nissan": [
      "200SX",
      "240SX",
      "300ZX",
      "Altima",
      "Maxima",
      "Pathfinder",
      "Pickup",
      "Quest",
      "Sentra"
    ],
    "Oldsmobile": [
      "88",
      "98",
      "Achieva",
      "Aurora",
      "Bravada",
      "Cutlass Ciera",
      "Cutlass Supreme",
      "LSS",
      "Silhouette"
    ],
    "Plymouth": [
      "Breeze",
      "Grand Voyager",
      "Neon",
      "Voyager"
    ],
    "Pontiac": [
      "Bonneville",
      "Firebird",
      "Firefly",
      "Grand Am",
      "Grand Prix",
      "Sunfire",
      "Sunrunner",
      "Trans Sport"
    ],
    "Porsche": [
      "911"
    ],
    "Rolls-Royce": [
      "Silver Dawn",
      "Silver Spur"
    ],
    "Saab": [
      "900"
    ],
    "Saturn": [
      "SC1",
      "SC2",
      "SL",
      "SL1",
      "SL2",
      "SW1",
      "SW2"
    ],
    "Subaru": [
      "Impreza",
      "Legacy",
      "SVX"
    ],
    "Suzuki": [
      "Esteem",
      "Sidekick",
      "Swift",
      "X-90"
    ],
    "Toyota": [
      "4Runner",
      "Avalon",
      "Camry",
      "Celica",
      "Corolla",
      "Paseo",
      "RAV4",
      "Supra",
      "T100",
      "Tacoma",
      "Tercel"
    ],
    "Volkswagen": [
      "Cabrio",
      "Golf",
      "Jetta",
      "Passat"
    ],
    "Volvo": [
      "850",
      "960"
    ]
  },
  "1997": {
    "Acura": [
      "CL",
      "EL",
      "Integra",
      "NSX",
      "RL",
      "TL"
    ],
    "Audi": [
      "A4",
      "A4 Quattro",
      "A6",
      "A6 Quattro",
      "A8 Quattro",
      "Cabriolet",
      "S4",
      "S6"
    ],
    "Bentley": [
      "Azure",
      "Brooklands",
      "Continental",
      "Turbo R"
    ],
    "BMW": [
      "318i",
      "318is",
      "318ti",
      "320i",
      "325i",
      "328i",
      "328is",
      "528i",
      "540i",
      "740i",
      "740iL",
      "750iL",
      "840Ci",
      "850Ci",
      "M3",
      "Z3"
    ],
    "Buick": [
      "Century",
      "LeSabre",
      "Park Avenue",
      "Regal",
      "Riviera",
      "Skylark"
    ],
    "Cadillac": [
      "Catera",
      "DeVille",
      "Eldorado",
      "Seville"
    ],
    "Chevrolet": [
      "Astro",
      "Blazer",
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "Camaro",
      "Cavalier",
      "Corvette",
      "Express 1500",
      "Express 2500",
      "Express 3500",
      "Impala",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "Lumina",
      "Malibu",
      "Monte Carlo",
      "P30",
      "S10",
      "Tahoe",
      "Venture"
    ],
    "Chrysler": [
      "Cirrus",
      "Concorde",
      "Intrepid",
      "LHS",
      "Sebring",
      "Town & Country"
    ],
    "Dodge": [
      "Avenger",
      "B1500",
      "B2500",
      "B3500",
      "Caravan",
      "Dakota",
      "Grand Caravan",
      "Intrepid",
      "Neon",
      "Ram 1500",
      "Ram 2500",
      "Ram 3500",
      "Stratus"
    ],
    "Ford": [
      "Aerostar",
      "Aspire",
      "Contour",
      "Crown Victoria",
      "E-150 Econoline",
      "E-150 Econoline Club Wagon",
      "E-250 Econoline",
      "E-350 Econoline",
      "E-350 Econoline Club Wagon",
      "Escort",
      "Expedition",
      "Explorer",
      "F-150",
      "F-250",
      "F-250 HD",
      "F-350",
      "F-53 Motorhome Chassis",
      "Mustang",
      "Probe",
      "Ranger",
      "Taurus",
      "Thunderbird",
      "Windstar"
    ],
    "Geo": [
      "Metro",
      "Prizm",
      "Tracker"
    ],
    "GMC": [
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "Jimmy",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "P3500",
      "Safari",
      "Savana 1500",
      "Savana 2500",
      "Savana 3500",
      "Sonoma",
      "Yukon"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "Civic del Sol",
      "CR-V",
      "Odyssey",
      "Passport",
      "Prelude"
    ],
    "Hyundai": [
      "Accent",
      "Elantra",
      "Sonata",
      "Tiburon"
    ],
    "INFINITI": [
      "G20",
      "I30",
      "J30",
      "Q45",
      "QX4"
    ],
    "Jaguar": [
      "Vanden Plas",
      "XJ6",
      "XJR",
      "XK8"
    ],
    "Jeep": [
      "Cherokee",
      "Grand Cherokee",
      "Wrangler"
    ],
    "Kia": [
      "Sephia",
      "Sportage"
    ],
    "Land Rover": [
      "Defender 90",
      "Discovery",
      "Range Rover"
    ],
    "Lexus": [
      "ES300",
      "GS300",
      "SC300",
      "SC400"
    ],
    "Lincoln": [
      "Continental",
      "Mark VIII",
      "Town Car"
    ],
    "Mazda": [
      "626",
      "B2300",
      "B3000",
      "B4000",
      "Miata",
      "Millenia",
      "MPV",
      "MX-6",
      "Protege"
    ],
    "Mercedes-Benz": [
      "C230",
      "C280",
      "C36 AMG",
      "E300",
      "E320",
      "E420",
      "E500",
      "S320",
      "S350",
      "S420",
      "S500",
      "S600",
      "SL320",
      "SL500",
      "SL600"
    ],
    "Mercury": [
      "Cougar",
      "Grand Marquis",
      "Mountaineer",
      "Mystique",
      "Sable",
      "Tracer",
      "Villager"
    ],
    "Mitsubishi": [
      "3000GT",
      "Diamante",
      "Eclipse",
      "Galant",
      "Mirage"
    ],
    "Nissan": [
      "200SX",
      "240SX",
      "Altima",
      "Maxima",
      "Pathfinder",
      "Pickup",
      "Quest",
      "Sentra"
    ],
    "Oldsmobile": [
      "88",
      "Achieva",
      "Aurora",
      "Bravada",
      "Cutlass",
      "Cutlass Supreme",
      "LSS",
      "Regency",
      "Silhouette"
    ],
    "Plymouth": [
      "Breeze",
      "Grand Voyager",
      "Neon",
      "Prowler",
      "Voyager"
    ],
    "Pontiac": [
      "Bonneville",
      "Firebird",
      "Firefly",
      "Grand Am",
      "Grand Prix",
      "Sunfire",
      "Sunrunner",
      "Trans Sport"
    ],
    "Porsche": [
      "911",
      "Boxster"
    ],
    "Rolls-Royce": [
      "Silver Dawn",
      "Silver Spur"
    ],
    "Saab": [
      "900"
    ],
    "Saturn": [
      "SC1",
      "SC2",
      "SL",
      "SL1",
      "SL2",
      "SW1",
      "SW2"
    ],
    "Subaru": [
      "Impreza",
      "Legacy",
      "SVX"
    ],
    "Suzuki": [
      "Esteem",
      "Sidekick",
      "Swift",
      "X-90"
    ],
    "Toyota": [
      "4Runner",
      "Avalon",
      "Camry",
      "Celica",
      "Corolla",
      "Paseo",
      "RAV4",
      "Supra",
      "T100",
      "Tacoma",
      "Tercel"
    ],
    "Volkswagen": [
      "Cabrio",
      "Golf",
      "Jetta",
      "Passat"
    ],
    "Volvo": [
      "850",
      "960"
    ]
  },
  "1998": {
    "Acura": [
      "CL",
      "EL",
      "Integra",
      "NSX",
      "RL",
      "TL"
    ],
    "Aston Martin": [
      "DB7"
    ],
    "Audi": [
      "A4",
      "A4 Quattro",
      "A6",
      "A6 Quattro",
      "A8 Quattro",
      "Cabriolet",
      "S4"
    ],
    "Bentley": [
      "Azure",
      "Brooklands",
      "Continental",
      "Turbo R"
    ],
    "BMW": [
      "318i",
      "318ti",
      "320i",
      "323i",
      "323is",
      "325i",
      "328i",
      "328is",
      "528i",
      "540i",
      "740i",
      "740iL",
      "750iL",
      "M3",
      "Z3"
    ],
    "Buick": [
      "Century",
      "LeSabre",
      "Park Avenue",
      "Regal",
      "Riviera",
      "Skylark"
    ],
    "Cadillac": [
      "Catera",
      "DeVille",
      "Eldorado",
      "Seville"
    ],
    "Chevrolet": [
      "Astro",
      "Blazer",
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "Camaro",
      "Cavalier",
      "Corvette",
      "Express 1500",
      "Express 2500",
      "Express 3500",
      "Impala",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "Lumina",
      "Malibu",
      "Metro",
      "Monte Carlo",
      "P30",
      "Prizm",
      "S10",
      "Tahoe",
      "Tracker",
      "Venture"
    ],
    "Chrysler": [
      "Cirrus",
      "Concorde",
      "Intrepid",
      "LHS",
      "Sebring",
      "Town & Country"
    ],
    "Dodge": [
      "Avenger",
      "B1500",
      "B2500",
      "B3500",
      "Caravan",
      "Dakota",
      "Durango",
      "Grand Caravan",
      "Intrepid",
      "Neon",
      "Ram 1500",
      "Ram 2500",
      "Ram 3500",
      "Stratus"
    ],
    "Ford": [
      "Contour",
      "Crown Victoria",
      "E-150 Econoline",
      "E-150 Econoline Club Wagon",
      "E-250 Econoline",
      "E-350 Econoline",
      "E-350 Econoline Club Wagon",
      "Econoline Super Duty",
      "Escort",
      "Expedition",
      "Explorer",
      "F-150",
      "F-250",
      "Mustang",
      "Ranger",
      "Taurus",
      "Windstar"
    ],
    "GMC": [
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "Jimmy",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "P3500",
      "Safari",
      "Savana 1500",
      "Savana 2500",
      "Savana 3500",
      "Sonoma",
      "Yukon"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "CR-V",
      "Odyssey",
      "Passport",
      "Prelude"
    ],
    "Hyundai": [
      "Accent",
      "Elantra",
      "Sonata",
      "Tiburon"
    ],
    "INFINITI": [
      "G20",
      "I30",
      "Q45",
      "QX4"
    ],
    "Jaguar": [
      "Vanden Plas",
      "XJ8",
      "XJR",
      "XK8"
    ],
    "Jeep": [
      "Cherokee",
      "Grand Cherokee",
      "Wrangler"
    ],
    "Kia": [
      "Sephia",
      "Sportage"
    ],
    "Land Rover": [
      "Discovery",
      "Range Rover"
    ],
    "Lexus": [
      "ES300",
      "GS300",
      "GS400",
      "LX470",
      "SC300",
      "SC400"
    ],
    "Lincoln": [
      "Continental",
      "Mark VIII",
      "Navigator",
      "Town Car"
    ],
    "Mazda": [
      "626",
      "B2300",
      "B2500",
      "B3000",
      "B4000",
      "Miata",
      "Millenia",
      "MPV",
      "Protege"
    ],
    "Mercedes-Benz": [
      "C230",
      "C280",
      "C43 AMG",
      "CL500",
      "CL600",
      "CLK320",
      "E300",
      "E320",
      "E430",
      "E500",
      "ML320",
      "S320",
      "S350",
      "S420",
      "S500",
      "S600",
      "SL500",
      "SL600",
      "SLK230"
    ],
    "Mercury": [
      "Cougar",
      "Grand Marquis",
      "Mountaineer",
      "Mystique",
      "Sable",
      "Tracer",
      "Villager"
    ],
    "Mitsubishi": [
      "3000GT",
      "Diamante",
      "Eclipse",
      "Galant",
      "Mirage"
    ],
    "Nissan": [
      "200SX",
      "240SX",
      "Altima",
      "Frontier",
      "Maxima",
      "Pathfinder",
      "Quest",
      "Sentra"
    ],
    "Oldsmobile": [
      "88",
      "Achieva",
      "Aurora",
      "Bravada",
      "Cutlass",
      "Intrigue",
      "LSS",
      "Regency",
      "Silhouette"
    ],
    "Plymouth": [
      "Breeze",
      "Grand Voyager",
      "Neon",
      "Prowler",
      "Voyager"
    ],
    "Pontiac": [
      "Bonneville",
      "Firebird",
      "Firefly",
      "Grand Am",
      "Grand Prix",
      "Sunfire",
      "Trans Sport"
    ],
    "Porsche": [
      "911",
      "Boxster"
    ],
    "Rolls-Royce": [
      "Silver Spur"
    ],
    "Saab": [
      "900"
    ],
    "Saturn": [
      "SC1",
      "SC2",
      "SL",
      "SL1",
      "SL2",
      "SW1",
      "SW2"
    ],
    "Subaru": [
      "Forester",
      "Impreza",
      "Legacy"
    ],
    "Suzuki": [
      "Esteem",
      "Sidekick",
      "Swift",
      "X-90"
    ],
    "Toyota": [
      "4Runner",
      "Avalon",
      "Camry",
      "Celica",
      "Corolla",
      "Land Cruiser",
      "Paseo",
      "RAV4",
      "Sienna",
      "Supra",
      "T100",
      "Tacoma",
      "Tercel"
    ],
    "Volkswagen": [
      "Beetle",
      "Cabrio",
      "Golf",
      "Jetta",
      "Passat"
    ],
    "Volvo": [
      "C70",
      "S70",
      "S90",
      "V70",
      "V90"
    ]
  },
  "1999": {
    "Acura": [
      "CL",
      "EL",
      "Integra",
      "NSX",
      "RL",
      "TL"
    ],
    "Aston Martin": [
      "DB7"
    ],
    "Audi": [
      "A4",
      "A4 Quattro",
      "A6",
      "A6 Quattro",
      "A8 Quattro",
      "S4"
    ],
    "BMW": [
      "318ti",
      "320i",
      "323i",
      "323is",
      "325i",
      "328i",
      "328is",
      "528i",
      "540i",
      "740i",
      "740iL",
      "750iL",
      "M3",
      "Z3"
    ],
    "Buick": [
      "Century",
      "LeSabre",
      "Park Avenue",
      "Regal",
      "Riviera"
    ],
    "Cadillac": [
      "Catera",
      "DeVille",
      "Eldorado",
      "Escalade",
      "Seville"
    ],
    "Chevrolet": [
      "Astro",
      "Blazer",
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "Camaro",
      "Cavalier",
      "Corvette",
      "Express 1500",
      "Express 2500",
      "Express 3500",
      "Impala",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "Lumina",
      "Malibu",
      "Metro",
      "Monte Carlo",
      "P30",
      "Prizm",
      "S10",
      "Silverado 1500",
      "Silverado 2500",
      "Tahoe",
      "Tracker",
      "Venture"
    ],
    "Chrysler": [
      "300M",
      "Cirrus",
      "Concorde",
      "Intrepid",
      "LHS",
      "Sebring",
      "Town & Country"
    ],
    "Dodge": [
      "Avenger",
      "Caravan",
      "Dakota",
      "Durango",
      "Grand Caravan",
      "Intrepid",
      "Neon",
      "Ram 1500",
      "Ram 1500 Van",
      "Ram 2500",
      "Ram 2500 Van",
      "Ram 3500",
      "Ram 3500 Van",
      "Stratus"
    ],
    "Ford": [
      "Contour",
      "Crown Victoria",
      "E-150 Econoline",
      "E-150 Econoline Club Wagon",
      "E-250 Econoline",
      "E-350 Econoline",
      "E-350 Econoline Club Wagon",
      "E-350 Super Duty",
      "Escort",
      "Expedition",
      "Explorer",
      "F-150",
      "F-250",
      "F-250 Super Duty",
      "F-350 Super Duty",
      "Mustang",
      "Ranger",
      "Taurus",
      "Windstar"
    ],
    "GMC": [
      "C1500",
      "C1500 Suburban",
      "C2500",
      "C2500 Suburban",
      "C3500",
      "C7500 Topkick",
      "Jimmy",
      "K1500",
      "K1500 Suburban",
      "K2500",
      "K2500 Suburban",
      "K3500",
      "P3500",
      "Safari",
      "Savana 1500",
      "Savana 2500",
      "Savana 3500",
      "Sierra 1500",
      "Sierra 2500",
      "Sonoma",
      "W3500 Forward",
      "Yukon"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "CR-V",
      "Odyssey",
      "Passport",
      "Prelude"
    ],
    "Hyundai": [
      "Accent",
      "Elantra",
      "Sonata",
      "Tiburon"
    ],
    "INFINITI": [
      "G20",
      "I30",
      "Q45",
      "QX4"
    ],
    "Jaguar": [
      "Vanden Plas",
      "XJ8",
      "XJR",
      "XK8"
    ],
    "Jeep": [
      "Cherokee",
      "Grand Cherokee",
      "Wrangler"
    ],
    "Kia": [
      "Sephia",
      "Sportage"
    ],
    "Land Rover": [
      "Discovery",
      "Range Rover"
    ],
    "Lexus": [
      "ES300",
      "GS300",
      "GS400",
      "LX470",
      "RX300",
      "SC300",
      "SC400"
    ],
    "Lincoln": [
      "Continental",
      "Navigator",
      "Town Car"
    ],
    "Mazda": [
      "626",
      "B2300",
      "B2500",
      "B3000",
      "B4000",
      "Miata",
      "Millenia",
      "MPV",
      "Protege"
    ],
    "Mercedes-Benz": [
      "C230",
      "C280",
      "C43 AMG",
      "CL500",
      "CL600",
      "CLK320",
      "CLK430",
      "E300",
      "E320",
      "E430",
      "E500",
      "E55 AMG",
      "ML320",
      "ML430",
      "S320",
      "S350",
      "S420",
      "S500",
      "S600",
      "SL500",
      "SL600",
      "SLK230"
    ],
    "Mercury": [
      "Cougar",
      "Grand Marquis",
      "Mountaineer",
      "Mystique",
      "Sable",
      "Tracer",
      "Villager"
    ],
    "Mitsubishi": [
      "3000GT",
      "Diamante",
      "Eclipse",
      "Galant",
      "Mirage"
    ],
    "Nissan": [
      "Altima",
      "Frontier",
      "Maxima",
      "Pathfinder",
      "Quest",
      "Sentra"
    ],
    "Oldsmobile": [
      "88",
      "Alero",
      "Aurora",
      "Bravada",
      "Cutlass",
      "Intrigue",
      "LSS",
      "Silhouette"
    ],
    "Plymouth": [
      "Breeze",
      "Grand Voyager",
      "Neon",
      "Prowler",
      "Voyager"
    ],
    "Pontiac": [
      "Bonneville",
      "Firebird",
      "Firefly",
      "Grand Am",
      "Grand Prix",
      "Montana",
      "Sunfire"
    ],
    "Porsche": [
      "911",
      "Boxster"
    ],
    "Saab": [
      "9-3",
      "9-5"
    ],
    "Saturn": [
      "SC1",
      "SC2",
      "SL",
      "SL1",
      "SL2",
      "SW1",
      "SW2"
    ],
    "Subaru": [
      "Forester",
      "Impreza",
      "Legacy"
    ],
    "Suzuki": [
      "Esteem",
      "Grand Vitara",
      "Swift",
      "Vitara"
    ],
    "Toyota": [
      "4Runner",
      "Avalon",
      "Camry",
      "Celica",
      "Corolla",
      "Land Cruiser",
      "Paseo",
      "RAV4",
      "Sienna",
      "Solara",
      "Tacoma",
      "Tercel"
    ],
    "Volkswagen": [
      "Beetle",
      "Cabrio",
      "Golf",
      "Jetta",
      "Passat"
    ],
    "Volvo": [
      "C70",
      "S70",
      "S80",
      "V70"
    ]
  },
  "2000": {
    "Acura": [
      "CL",
      "EL",
      "Integra",
      "NSX",
      "RL",
      "TL"
    ],
    "Aston Martin": [
      "DB7"
    ],
    "Audi": [
      "A4",
      "A4 Quattro",
      "A6",
      "A6 Quattro",
      "A8 Quattro",
      "S4",
      "TT",
      "TT Quattro"
    ],
    "BMW": [
      "320i",
      "323Ci",
      "323i",
      "325i",
      "328Ci",
      "328i",
      "528i",
      "540i",
      "740i",
      "740iL",
      "750iL",
      "M3",
      "M5",
      "X5",
      "Z3",
      "Z8"
    ],
    "Buick": [
      "Century",
      "LeSabre",
      "Park Avenue",
      "Regal"
    ],
    "Cadillac": [
      "Catera",
      "DeVille",
      "Eldorado",
      "Escalade",
      "Seville"
    ],
    "Chevrolet": [
      "Astro",
      "Blazer",
      "C2500",
      "C3500",
      "Camaro",
      "Cavalier",
      "Corvette",
      "Express 1500",
      "Express 2500",
      "Express 3500",
      "Impala",
      "K2500",
      "K3500",
      "Lumina",
      "Malibu",
      "Metro",
      "Monte Carlo",
      "Prizm",
      "S10",
      "Silverado 1500",
      "Silverado 2500",
      "Suburban 1500",
      "Suburban 2500",
      "Tahoe",
      "Tracker",
      "Venture"
    ],
    "Chrysler": [
      "300M",
      "Cirrus",
      "Concorde",
      "Grand Voyager",
      "Intrepid",
      "LHS",
      "Neon",
      "Sebring",
      "Town & Country",
      "Voyager"
    ],
    "Dodge": [
      "Avenger",
      "Caravan",
      "Dakota",
      "Durango",
      "Grand Caravan",
      "Intrepid",
      "Neon",
      "Ram 1500",
      "Ram 1500 Van",
      "Ram 2500",
      "Ram 2500 Van",
      "Ram 3500",
      "Ram 3500 Van",
      "Stratus"
    ],
    "Ford": [
      "Contour",
      "Crown Victoria",
      "E-150 Econoline",
      "E-150 Econoline Club Wagon",
      "E-250 Econoline",
      "E-350 Econoline",
      "E-350 Econoline Club Wagon",
      "E-350 Super Duty",
      "E-450 Econoline Super Duty",
      "Escort",
      "Excursion",
      "Expedition",
      "Explorer",
      "F-150",
      "F-250 Super Duty",
      "F-350 Super Duty",
      "Focus",
      "Mustang",
      "Ranger",
      "Taurus",
      "Windstar"
    ],
    "GMC": [
      "C2500",
      "C3500",
      "Jimmy",
      "K2500",
      "K3500",
      "Safari",
      "Savana 1500",
      "Savana 2500",
      "Savana 3500",
      "Sierra 1500",
      "Sierra 2500",
      "Sonoma",
      "W3500 Forward",
      "Yukon",
      "Yukon XL 1500",
      "Yukon XL 2500"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "CR-V",
      "Insight",
      "Odyssey",
      "Passport",
      "Prelude",
      "S2000"
    ],
    "Hyundai": [
      "Accent",
      "Elantra",
      "Sonata",
      "Tiburon"
    ],
    "INFINITI": [
      "G20",
      "I30",
      "Q45",
      "QX4"
    ],
    "Jaguar": [
      "S-Type",
      "Vanden Plas",
      "XJ8",
      "XJR",
      "XK8",
      "XKR"
    ],
    "Jeep": [
      "Cherokee",
      "Grand Cherokee",
      "Wrangler"
    ],
    "Kia": [
      "Sephia",
      "Spectra",
      "Sportage"
    ],
    "Land Rover": [
      "Discovery",
      "Range Rover"
    ],
    "Lexus": [
      "ES300",
      "GS300",
      "GS400",
      "LS400",
      "LX470",
      "RX300",
      "SC300",
      "SC400"
    ],
    "Lincoln": [
      "Continental",
      "LS",
      "Navigator",
      "Town Car"
    ],
    "Mazda": [
      "626",
      "B2300",
      "B2500",
      "B3000",
      "B4000",
      "Miata",
      "Millenia",
      "MPV",
      "Protege"
    ],
    "Mercedes-Benz": [
      "C230",
      "C280",
      "C43 AMG",
      "CL500",
      "CL600",
      "CLK320",
      "CLK430",
      "E320",
      "E430",
      "E500",
      "E55 AMG",
      "ML320",
      "ML430",
      "ML55 AMG",
      "S350",
      "S430",
      "S500",
      "S600",
      "SL500",
      "SL600",
      "SLK230"
    ],
    "Mercury": [
      "Cougar",
      "Grand Marquis",
      "Mountaineer",
      "Mystique",
      "Sable",
      "Villager"
    ],
    "Mitsubishi": [
      "Diamante",
      "Eclipse",
      "Galant",
      "Mirage",
      "Montero",
      "Montero Sport"
    ],
    "Nissan": [
      "Altima",
      "Frontier",
      "Maxima",
      "Pathfinder",
      "Quest",
      "Sentra",
      "Xterra"
    ],
    "Oldsmobile": [
      "Alero",
      "Aurora",
      "Bravada",
      "Intrigue",
      "Silhouette"
    ],
    "Plymouth": [
      "Breeze",
      "Grand Voyager",
      "Neon",
      "Prowler",
      "Voyager"
    ],
    "Pontiac": [
      "Bonneville",
      "Firebird",
      "Firefly",
      "Grand Am",
      "Grand Prix",
      "Montana",
      "Sunfire"
    ],
    "Porsche": [
      "911",
      "Boxster"
    ],
    "Saab": [
      "9-3",
      "9-5"
    ],
    "Saturn": [
      "LS",
      "LS1",
      "LS2",
      "LW1",
      "LW2",
      "SC1",
      "SC2",
      "SL",
      "SL1",
      "SL2",
      "SW2"
    ],
    "Subaru": [
      "Forester",
      "Impreza",
      "Legacy",
      "Outback"
    ],
    "Suzuki": [
      "Esteem",
      "Grand Vitara",
      "Swift",
      "Vitara"
    ],
    "Toyota": [
      "4Runner",
      "Avalon",
      "Camry",
      "Celica",
      "Corolla",
      "Echo",
      "Land Cruiser",
      "MR2 Spyder",
      "RAV4",
      "Sienna",
      "Solara",
      "Tacoma",
      "Tundra"
    ],
    "Volkswagen": [
      "Beetle",
      "Cabrio",
      "Golf",
      "Jetta",
      "Passat"
    ],
    "Volvo": [
      "C70",
      "S40",
      "S70",
      "S80",
      "V40",
      "V70"
    ]
  },
  "2001": {
    "Acura": [
      "CL",
      "EL",
      "Integra",
      "MDX",
      "NSX",
      "RL",
      "TL"
    ],
    "Aston Martin": [
      "DB7"
    ],
    "Audi": [
      "A4",
      "A4 Quattro",
      "A6",
      "A6 Quattro",
      "A8 Quattro",
      "Allroad Quattro",
      "S4",
      "S8",
      "TT",
      "TT Quattro"
    ],
    "BMW": [
      "320i",
      "323i",
      "325Ci",
      "325i",
      "328i",
      "330Ci",
      "330i",
      "525i",
      "528i",
      "530i",
      "540i",
      "740i",
      "740iL",
      "750iL",
      "M3",
      "M5",
      "X5",
      "Z3",
      "Z8"
    ],
    "Buick": [
      "Century",
      "LeSabre",
      "Park Avenue",
      "Regal"
    ],
    "Cadillac": [
      "Catera",
      "DeVille",
      "Eldorado",
      "Escalade",
      "Seville"
    ],
    "Chevrolet": [
      "Astro",
      "Blazer",
      "Camaro",
      "Cavalier",
      "Corvette",
      "Express 1500",
      "Express 2500",
      "Express 3500",
      "Impala",
      "Lumina",
      "Malibu",
      "Metro",
      "Monte Carlo",
      "Prizm",
      "S10",
      "Silverado 1500",
      "Silverado 1500 HD",
      "Silverado 2500",
      "Silverado 2500 HD",
      "Silverado 3500",
      "Suburban 1500",
      "Suburban 2500",
      "Tahoe",
      "Tracker",
      "Venture"
    ],
    "Chrysler": [
      "300M",
      "Concorde",
      "Intrepid",
      "LHS",
      "Neon",
      "Prowler",
      "PT Cruiser",
      "Sebring",
      "Town & Country",
      "Voyager"
    ],
    "Dodge": [
      "Avenger",
      "Caravan",
      "Dakota",
      "Durango",
      "Grand Caravan",
      "Intrepid",
      "Neon",
      "Ram 1500",
      "Ram 1500 Van",
      "Ram 2500",
      "Ram 2500 Van",
      "Ram 3500",
      "Ram 3500 Van",
      "Stratus"
    ],
    "Ford": [
      "Crown Victoria",
      "E-150 Econoline",
      "E-150 Econoline Club Wagon",
      "E-250 Econoline",
      "E-350 Econoline Club Wagon",
      "E-350 Super Duty",
      "E-450 Econoline Super Duty",
      "Escape",
      "Escort",
      "Excursion",
      "Expedition",
      "Explorer",
      "Explorer Sport",
      "Explorer Sport Trac",
      "F-150",
      "F-250 Super Duty",
      "F-350 Super Duty",
      "Focus",
      "Mustang",
      "Ranger",
      "Taurus",
      "Windstar"
    ],
    "GMC": [
      "Jimmy",
      "Safari",
      "Savana 1500",
      "Savana 2500",
      "Savana 3500",
      "Sierra 1500",
      "Sierra 1500 HD",
      "Sierra 2500",
      "Sierra 2500 HD",
      "Sierra 3500",
      "Sonoma",
      "W3500 Forward",
      "Yukon",
      "Yukon XL 1500",
      "Yukon XL 2500"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "CR-V",
      "Insight",
      "Odyssey",
      "Passport",
      "Prelude",
      "S2000"
    ],
    "Hyundai": [
      "Accent",
      "Elantra",
      "Santa Fe",
      "Sonata",
      "Tiburon",
      "XG300"
    ],
    "INFINITI": [
      "G20",
      "I30",
      "Q45",
      "QX4"
    ],
    "Jaguar": [
      "S-Type",
      "Vanden Plas",
      "XJ8",
      "XJR",
      "XK8",
      "XKR"
    ],
    "Jeep": [
      "Cherokee",
      "Grand Cherokee",
      "Wrangler"
    ],
    "Kia": [
      "Optima",
      "Rio",
      "Sephia",
      "Spectra",
      "Sportage"
    ],
    "Land Rover": [
      "Discovery",
      "Range Rover"
    ],
    "Lexus": [
      "ES300",
      "GS300",
      "GS430",
      "IS300",
      "LS430",
      "LX470",
      "RX300"
    ],
    "Lincoln": [
      "Continental",
      "LS",
      "Navigator",
      "Town Car"
    ],
    "Mazda": [
      "626",
      "B2300",
      "B2500",
      "B3000",
      "B4000",
      "Miata",
      "Millenia",
      "MPV",
      "Protege",
      "Tribute"
    ],
    "Mercedes-Benz": [
      "C230",
      "C240",
      "C280",
      "C320",
      "CL500",
      "CL55 AMG",
      "CL600",
      "CLK320",
      "CLK430",
      "CLK55 AMG",
      "E320",
      "E430",
      "E500",
      "E55 AMG",
      "ML320",
      "ML430",
      "ML55 AMG",
      "S350",
      "S430",
      "S500",
      "S55 AMG",
      "S600",
      "SL500",
      "SL600",
      "SLK230",
      "SLK320"
    ],
    "Mercury": [
      "Cougar",
      "Grand Marquis",
      "Mountaineer",
      "Sable",
      "Villager"
    ],
    "Mitsubishi": [
      "Diamante",
      "Eclipse",
      "Galant",
      "Mirage",
      "Montero",
      "Montero Sport"
    ],
    "Nissan": [
      "Altima",
      "Frontier",
      "Maxima",
      "Pathfinder",
      "Quest",
      "Sentra",
      "Xterra"
    ],
    "Oldsmobile": [
      "Alero",
      "Aurora",
      "Bravada",
      "Intrigue",
      "Silhouette"
    ],
    "Plymouth": [
      "Neon",
      "Prowler"
    ],
    "Pontiac": [
      "Aztek",
      "Bonneville",
      "Firebird",
      "Grand Am",
      "Grand Prix",
      "Montana",
      "Sunfire"
    ],
    "Porsche": [
      "911",
      "Boxster"
    ],
    "Saab": [
      "9-3",
      "9-5"
    ],
    "Saturn": [
      "L100",
      "L200",
      "L300",
      "LW200",
      "LW300",
      "SC1",
      "SC2",
      "SL",
      "SL1",
      "SL2",
      "SW2"
    ],
    "Subaru": [
      "Forester",
      "Impreza",
      "Legacy",
      "Outback"
    ],
    "Suzuki": [
      "Esteem",
      "Grand Vitara",
      "Swift",
      "Vitara"
    ],
    "Toyota": [
      "4Runner",
      "Avalon",
      "Camry",
      "Celica",
      "Corolla",
      "Echo",
      "Highlander",
      "Land Cruiser",
      "MR2 Spyder",
      "Prius",
      "RAV4",
      "Sequoia",
      "Sienna",
      "Solara",
      "Tacoma",
      "Tundra"
    ],
    "Volkswagen": [
      "Beetle",
      "Cabrio",
      "EuroVan",
      "Golf",
      "Jetta",
      "Passat"
    ],
    "Volvo": [
      "C70",
      "S40",
      "S60",
      "S80",
      "V40",
      "V70"
    ]
  },
  "2002": {
    "Acura": [
      "CL",
      "EL",
      "MDX",
      "NSX",
      "RL",
      "RSX",
      "TL"
    ],
    "Aston Martin": [
      "DB7"
    ],
    "Audi": [
      "A4",
      "A4 Quattro",
      "A6",
      "A6 Quattro",
      "A8 Quattro",
      "Allroad Quattro",
      "S4",
      "S6",
      "S8",
      "TT",
      "TT Quattro"
    ],
    "BMW": [
      "320i",
      "323i",
      "325Ci",
      "325i",
      "325xi",
      "328i",
      "330Ci",
      "330i",
      "330xi",
      "525i",
      "528i",
      "530i",
      "540i",
      "745i",
      "745Li",
      "M3",
      "M5",
      "X5",
      "Z3",
      "Z8"
    ],
    "Buick": [
      "Century",
      "LeSabre",
      "Park Avenue",
      "Regal",
      "Rendezvous"
    ],
    "Cadillac": [
      "DeVille",
      "Eldorado",
      "Escalade",
      "Escalade EXT",
      "Seville"
    ],
    "Chevrolet": [
      "Astro",
      "Avalanche 1500",
      "Avalanche 2500",
      "Blazer",
      "Camaro",
      "Cavalier",
      "Corvette",
      "Express 1500",
      "Express 2500",
      "Express 3500",
      "Impala",
      "Malibu",
      "Monte Carlo",
      "Prizm",
      "S10",
      "Silverado 1500",
      "Silverado 1500 HD",
      "Silverado 2500",
      "Silverado 2500 HD",
      "Silverado 3500",
      "Suburban 1500",
      "Suburban 2500",
      "Tahoe",
      "Tracker",
      "Trailblazer",
      "Trailblazer EXT",
      "Venture"
    ],
    "Chrysler": [
      "300M",
      "Concorde",
      "Intrepid",
      "Neon",
      "Prowler",
      "PT Cruiser",
      "Sebring",
      "Town & Country",
      "Voyager"
    ],
    "Dodge": [
      "Avenger",
      "Caravan",
      "Dakota",
      "Durango",
      "Grand Caravan",
      "Intrepid",
      "Neon",
      "Ram 1500",
      "Ram 1500 Van",
      "Ram 2500",
      "Ram 2500 Van",
      "Ram 3500",
      "Ram 3500 Van",
      "Stratus"
    ],
    "Ford": [
      "Crown Victoria",
      "E-150 Econoline",
      "E-150 Econoline Club Wagon",
      "E-250 Econoline",
      "E-350 Econoline Club Wagon",
      "E-350 Super Duty",
      "E-450 Econoline Super Duty",
      "Escape",
      "Escort",
      "Excursion",
      "Expedition",
      "Explorer",
      "Explorer Sport",
      "Explorer Sport Trac",
      "F-150",
      "F-250 Super Duty",
      "F-350 Super Duty",
      "Focus",
      "Mustang",
      "Ranger",
      "Taurus",
      "Thunderbird",
      "Windstar"
    ],
    "GMC": [
      "Envoy",
      "Envoy XL",
      "Jimmy",
      "Safari",
      "Savana 1500",
      "Savana 2500",
      "Savana 3500",
      "Sierra 1500",
      "Sierra 1500 HD",
      "Sierra 2500",
      "Sierra 2500 HD",
      "Sierra 3500",
      "Sonoma",
      "W3500 Forward",
      "Yukon",
      "Yukon XL 1500",
      "Yukon XL 2500"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "CR-V",
      "Insight",
      "Odyssey",
      "Passport",
      "S2000"
    ],
    "Hummer": [
      "H1"
    ],
    "Hyundai": [
      "Accent",
      "Elantra",
      "Santa Fe",
      "Sonata",
      "Tiburon",
      "XG350"
    ],
    "INFINITI": [
      "G20",
      "I35",
      "Q45",
      "QX4"
    ],
    "Jaguar": [
      "S-Type",
      "Vanden Plas",
      "X-Type",
      "XJ8",
      "XJR",
      "XK8",
      "XKR"
    ],
    "Jeep": [
      "Grand Cherokee",
      "Liberty",
      "Wrangler"
    ],
    "Kia": [
      "Optima",
      "Rio",
      "Sedona",
      "Spectra",
      "Sportage"
    ],
    "Land Rover": [
      "Discovery",
      "Freelander",
      "Range Rover"
    ],
    "Lexus": [
      "ES300",
      "GS300",
      "GS430",
      "IS300",
      "LS430",
      "LX470",
      "RX300",
      "SC430"
    ],
    "Lincoln": [
      "Blackwood",
      "Continental",
      "LS",
      "Navigator",
      "Town Car"
    ],
    "Mazda": [
      "626",
      "B2300",
      "B3000",
      "B4000",
      "Miata",
      "Millenia",
      "MPV",
      "Protege",
      "Protege5",
      "Tribute"
    ],
    "Mercedes-Benz": [
      "C230",
      "C240",
      "C280",
      "C32 AMG",
      "C320",
      "CL500",
      "CL55 AMG",
      "CL600",
      "CLK320",
      "CLK430",
      "CLK55 AMG",
      "E320",
      "E430",
      "E500",
      "E55 AMG",
      "G500",
      "ML320",
      "ML500",
      "ML55 AMG",
      "S350",
      "S430",
      "S500",
      "S55 AMG",
      "S600",
      "SL500",
      "SL600",
      "SLK230",
      "SLK32 AMG",
      "SLK320"
    ],
    "Mercury": [
      "Cougar",
      "Grand Marquis",
      "Mountaineer",
      "Sable",
      "Villager"
    ],
    "Mini": [
      "Cooper"
    ],
    "Mitsubishi": [
      "Diamante",
      "Eclipse",
      "Galant",
      "Lancer",
      "Mirage",
      "Montero",
      "Montero Sport"
    ],
    "Nissan": [
      "Altima",
      "Frontier",
      "Maxima",
      "Pathfinder",
      "Quest",
      "Sentra",
      "Xterra"
    ],
    "Oldsmobile": [
      "Alero",
      "Aurora",
      "Bravada",
      "Intrigue",
      "Silhouette"
    ],
    "Pontiac": [
      "Aztek",
      "Bonneville",
      "Firebird",
      "Grand Am",
      "Grand Prix",
      "Montana",
      "Sunfire"
    ],
    "Porsche": [
      "911",
      "Boxster"
    ],
    "Saab": [
      "9-3",
      "9-5"
    ],
    "Saturn": [
      "L100",
      "L200",
      "L300",
      "LW200",
      "LW300",
      "SC1",
      "SC2",
      "SL",
      "SL1",
      "SL2",
      "Vue"
    ],
    "Subaru": [
      "Forester",
      "Impreza",
      "Legacy",
      "Outback"
    ],
    "Suzuki": [
      "Aerio",
      "Esteem",
      "Grand Vitara",
      "Vitara",
      "XL-7"
    ],
    "Toyota": [
      "4Runner",
      "Avalon",
      "Camry",
      "Celica",
      "Corolla",
      "Echo",
      "Highlander",
      "Land Cruiser",
      "MR2 Spyder",
      "Prius",
      "RAV4",
      "Sequoia",
      "Sienna",
      "Solara",
      "Tacoma",
      "Tundra"
    ],
    "Volkswagen": [
      "Beetle",
      "Cabrio",
      "EuroVan",
      "Golf",
      "Jetta",
      "Passat"
    ],
    "Volvo": [
      "C70",
      "S40",
      "S60",
      "S80",
      "V40",
      "V70"
    ]
  },
  "2003": {
    "Acura": [
      "CL",
      "EL",
      "MDX",
      "NSX",
      "RL",
      "RSX",
      "TL"
    ],
    "Aston Martin": [
      "DB7"
    ],
    "Audi": [
      "A4",
      "A4 Quattro",
      "A6",
      "A6 Quattro",
      "A8 Quattro",
      "Allroad Quattro",
      "RS6",
      "S4",
      "S6",
      "S8",
      "TT",
      "TT Quattro"
    ],
    "BMW": [
      "320i",
      "323i",
      "325Ci",
      "325i",
      "325xi",
      "328i",
      "330Ci",
      "330i",
      "330xi",
      "525i",
      "528i",
      "530i",
      "540i",
      "745i",
      "745Li",
      "760Li",
      "M3",
      "M5",
      "X5",
      "Z4",
      "Z8"
    ],
    "Buick": [
      "Century",
      "LeSabre",
      "Park Avenue",
      "Regal",
      "Rendezvous"
    ],
    "Cadillac": [
      "CTS",
      "DeVille",
      "Escalade",
      "Escalade ESV",
      "Escalade EXT",
      "Seville"
    ],
    "Chevrolet": [
      "Astro",
      "Avalanche 1500",
      "Avalanche 2500",
      "Blazer",
      "Cavalier",
      "Corvette",
      "Express 1500",
      "Express 2500",
      "Express 3500",
      "Impala",
      "Malibu",
      "Monte Carlo",
      "S10",
      "Silverado 1500",
      "Silverado 1500 HD",
      "Silverado 2500",
      "Silverado 2500 HD",
      "Silverado 3500",
      "SSR",
      "Suburban 1500",
      "Suburban 2500",
      "Tahoe",
      "Tracker",
      "Trailblazer",
      "Trailblazer EXT",
      "Venture"
    ],
    "Chrysler": [
      "300M",
      "Concorde",
      "PT Cruiser",
      "Sebring",
      "Town & Country",
      "Voyager"
    ],
    "Dodge": [
      "Avenger",
      "Caravan",
      "Dakota",
      "Durango",
      "Grand Caravan",
      "Intrepid",
      "Neon",
      "Ram 1500",
      "Ram 1500 Van",
      "Ram 2500",
      "Ram 2500 Van",
      "Ram 3500",
      "Ram 3500 Van",
      "Stratus",
      "SX-20"
    ],
    "Ford": [
      "Crown Victoria",
      "E-150",
      "E-150 Club Wagon",
      "E-250",
      "E-350 Club Wagon",
      "E-350 Super Duty",
      "E-450 Super Duty",
      "Escape",
      "Escort",
      "Excursion",
      "Expedition",
      "Explorer",
      "Explorer Sport",
      "Explorer Sport Trac",
      "F-150",
      "F-250 Super Duty",
      "F-350 Super Duty",
      "Focus",
      "Mustang",
      "Ranger",
      "Taurus",
      "Thunderbird",
      "Windstar"
    ],
    "GMC": [
      "Envoy",
      "Envoy XL",
      "Jimmy",
      "Safari",
      "Savana 1500",
      "Savana 2500",
      "Savana 3500",
      "Sierra 1500",
      "Sierra 1500 HD",
      "Sierra 2500",
      "Sierra 2500 HD",
      "Sierra 3500",
      "Sonoma",
      "W3500 Forward",
      "Yukon",
      "Yukon XL 1500",
      "Yukon XL 2500"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "CR-V",
      "Element",
      "Insight",
      "Odyssey",
      "Pilot",
      "S2000"
    ],
    "Hummer": [
      "H1",
      "H2"
    ],
    "Hyundai": [
      "Accent",
      "Elantra",
      "Santa Fe",
      "Sonata",
      "Tiburon",
      "XG350"
    ],
    "INFINITI": [
      "FX35",
      "FX45",
      "G35",
      "I35",
      "M45",
      "Q45",
      "QX4"
    ],
    "Jaguar": [
      "S-Type",
      "Vanden Plas",
      "X-Type",
      "XJ8",
      "XJR",
      "XK8",
      "XKR"
    ],
    "Jeep": [
      "Grand Cherokee",
      "Liberty",
      "Wrangler"
    ],
    "Kia": [
      "Optima",
      "Rio",
      "Sedona",
      "Sorento",
      "Spectra"
    ],
    "Land Rover": [
      "Discovery",
      "Freelander",
      "Range Rover"
    ],
    "Lexus": [
      "ES300",
      "GS300",
      "GS430",
      "GX470",
      "IS300",
      "LS430",
      "LX470",
      "RX300",
      "SC430"
    ],
    "Lincoln": [
      "Aviator",
      "LS",
      "Navigator",
      "Town Car"
    ],
    "Mazda": [
      "6",
      "B2300",
      "B3000",
      "B4000",
      "Miata",
      "MPV",
      "Protege",
      "Protege5",
      "Tribute"
    ],
    "Mercedes-Benz": [
      "C230",
      "C240",
      "C280",
      "C32 AMG",
      "C320",
      "CL500",
      "CL55 AMG",
      "CL600",
      "CLK320",
      "CLK430",
      "CLK500",
      "CLK55 AMG",
      "E320",
      "E500",
      "E55 AMG",
      "G500",
      "G55 AMG",
      "ML320",
      "ML350",
      "ML500",
      "ML55 AMG",
      "S350",
      "S430",
      "S500",
      "S55 AMG",
      "S600",
      "SL500",
      "SL55 AMG",
      "SL600",
      "SLK230",
      "SLK32 AMG",
      "SLK320"
    ],
    "Mercury": [
      "Grand Marquis",
      "Marauder",
      "Mountaineer",
      "Sable"
    ],
    "Mini": [
      "Cooper"
    ],
    "Mitsubishi": [
      "Diamante",
      "Eclipse",
      "Galant",
      "Lancer",
      "Mirage",
      "Montero",
      "Outlander"
    ],
    "Nissan": [
      "350Z",
      "Altima",
      "Frontier",
      "Maxima",
      "Murano",
      "Pathfinder",
      "Sentra",
      "Xterra"
    ],
    "Oldsmobile": [
      "Alero",
      "Aurora",
      "Bravada",
      "Silhouette"
    ],
    "Pontiac": [
      "Aztek",
      "Bonneville",
      "Grand Am",
      "Grand Prix",
      "Montana",
      "Sunfire",
      "Vibe"
    ],
    "Porsche": [
      "911",
      "Boxster",
      "Cayenne"
    ],
    "Saab": [
      "9-3",
      "9-5"
    ],
    "Saturn": [
      "Ion",
      "L200",
      "L300",
      "LW200",
      "LW300",
      "Vue"
    ],
    "Subaru": [
      "Baja",
      "Forester",
      "Impreza",
      "Legacy",
      "Outback"
    ],
    "Suzuki": [
      "Aerio",
      "Grand Vitara",
      "Vitara",
      "XL-7"
    ],
    "Toyota": [
      "4Runner",
      "Avalon",
      "Camry",
      "Celica",
      "Corolla",
      "Echo",
      "Highlander",
      "Land Cruiser",
      "Matrix",
      "MR2 Spyder",
      "Prius",
      "RAV4",
      "Sequoia",
      "Sienna",
      "Solara",
      "Tacoma",
      "Tundra"
    ],
    "Volkswagen": [
      "Beetle",
      "EuroVan",
      "Golf",
      "Jetta",
      "Passat"
    ],
    "Volvo": [
      "C70",
      "S40",
      "S60",
      "S80",
      "V40",
      "V70",
      "XC70",
      "XC90"
    ]
  },
  "2004": {
    "Acura": [
      "EL",
      "MDX",
      "NSX",
      "RL",
      "RSX",
      "TL",
      "TSX"
    ],
    "Audi": [
      "A4",
      "A4 Quattro",
      "A6",
      "A6 Quattro",
      "A8 Quattro",
      "Allroad Quattro",
      "RS6",
      "S4",
      "TT",
      "TT Quattro"
    ],
    "BMW": [
      "320i",
      "323i",
      "325Ci",
      "325i",
      "325xi",
      "328i",
      "330Ci",
      "330i",
      "330xi",
      "525i",
      "528i",
      "530i",
      "545i",
      "645Ci",
      "745i",
      "745Li",
      "760Li",
      "M3",
      "M5",
      "X3",
      "X5",
      "Z4"
    ],
    "Buick": [
      "Century",
      "LeSabre",
      "Park Avenue",
      "Rainier",
      "Regal",
      "Rendezvous"
    ],
    "Cadillac": [
      "CTS",
      "DeVille",
      "Escalade",
      "Escalade ESV",
      "Escalade EXT",
      "Seville",
      "SRX",
      "XLR"
    ],
    "Chevrolet": [
      "Astro",
      "Avalanche 1500",
      "Avalanche 2500",
      "Aveo",
      "Blazer",
      "Cavalier",
      "Classic",
      "Colorado",
      "Corvette",
      "Epica",
      "Express 1500",
      "Express 2500",
      "Express 3500",
      "Impala",
      "Malibu",
      "Monte Carlo",
      "Optra",
      "S10",
      "Silverado 1500",
      "Silverado 1500 HD",
      "Silverado 2500",
      "Silverado 2500 HD",
      "Silverado 3500",
      "SSR",
      "Suburban 1500",
      "Suburban 2500",
      "Tahoe",
      "Tracker",
      "Trailblazer",
      "Trailblazer EXT",
      "Venture",
      "W3500 Tiltmaster"
    ],
    "Chrysler": [
      "300M",
      "Concorde",
      "Crossfire",
      "Pacifica",
      "PT Cruiser",
      "Sebring",
      "Town & Country"
    ],
    "Dodge": [
      "Avenger",
      "Caravan",
      "Dakota",
      "Durango",
      "Grand Caravan",
      "Intrepid",
      "Neon",
      "Ram 1500",
      "Ram 2500",
      "Ram 3500",
      "Stratus",
      "SX-20"
    ],
    "Ford": [
      "Crown Victoria",
      "E-150",
      "E-150 Club Wagon",
      "E-250",
      "E-350 Club Wagon",
      "E-350 Super Duty",
      "E-450 Super Duty",
      "Escape",
      "Excursion",
      "Expedition",
      "Explorer",
      "Explorer Sport Trac",
      "F-150",
      "F-150 Heritage",
      "F-250 Super Duty",
      "F-350 Super Duty",
      "Focus",
      "Freestar",
      "Mustang",
      "Ranger",
      "Taurus",
      "Thunderbird"
    ],
    "GMC": [
      "Canyon",
      "Envoy",
      "Envoy XL",
      "Envoy XUV",
      "Jimmy",
      "Safari",
      "Savana 1500",
      "Savana 2500",
      "Savana 3500",
      "Sierra 1500",
      "Sierra 1500 HD",
      "Sierra 2500",
      "Sierra 2500 HD",
      "Sierra 3500",
      "Sonoma",
      "W3500 Forward",
      "W4500 Forward",
      "Yukon",
      "Yukon XL 1500",
      "Yukon XL 2500"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "CR-V",
      "Element",
      "Insight",
      "Odyssey",
      "Pilot",
      "S2000"
    ],
    "Hummer": [
      "H2"
    ],
    "Hyundai": [
      "Accent",
      "Elantra",
      "Santa Fe",
      "Sonata",
      "Tiburon",
      "XG350"
    ],
    "INFINITI": [
      "FX35",
      "FX45",
      "G35",
      "I35",
      "M45",
      "Q45",
      "QX56"
    ],
    "Jaguar": [
      "S-Type",
      "Vanden Plas",
      "X-Type",
      "XJ8",
      "XJR",
      "XK8",
      "XKR"
    ],
    "Jeep": [
      "Grand Cherokee",
      "Liberty",
      "Wrangler"
    ],
    "Kia": [
      "Amanti",
      "Optima",
      "Rio",
      "Sedona",
      "Sorento",
      "Spectra"
    ],
    "Land Rover": [
      "Discovery",
      "Freelander",
      "Range Rover"
    ],
    "Lexus": [
      "ES330",
      "GS300",
      "GS430",
      "GX470",
      "IS300",
      "LS430",
      "LX470",
      "RX330",
      "SC430"
    ],
    "Lincoln": [
      "Aviator",
      "LS",
      "Navigator",
      "Town Car"
    ],
    "Mazda": [
      "3",
      "6",
      "B2300",
      "B3000",
      "B4000",
      "Miata",
      "MPV",
      "RX-8",
      "Tribute"
    ],
    "Mercedes-Benz": [
      "C230",
      "C240",
      "C280",
      "C32 AMG",
      "C320",
      "CL500",
      "CL55 AMG",
      "CL600",
      "CLK320",
      "CLK500",
      "CLK55 AMG",
      "E320",
      "E500",
      "E55 AMG",
      "G500",
      "G55 AMG",
      "ML350",
      "ML500",
      "S350",
      "S430",
      "S500",
      "S55 AMG",
      "S600",
      "SL500",
      "SL55 AMG",
      "SL600",
      "SLK230",
      "SLK32 AMG",
      "SLK320"
    ],
    "Mercury": [
      "Grand Marquis",
      "Marauder",
      "Monterey",
      "Mountaineer",
      "Sable"
    ],
    "Mini": [
      "Cooper"
    ],
    "Mitsubishi": [
      "Diamante",
      "Eclipse",
      "Endeavor",
      "Galant",
      "Lancer",
      "Mirage",
      "Montero",
      "Outlander"
    ],
    "Nissan": [
      "350Z",
      "Altima",
      "Frontier",
      "Maxima",
      "Murano",
      "Pathfinder",
      "Pathfinder Armada",
      "Quest",
      "Sentra",
      "TITAN",
      "Xterra"
    ],
    "Oldsmobile": [
      "Alero",
      "Bravada",
      "Silhouette"
    ],
    "Pontiac": [
      "Aztek",
      "Bonneville",
      "Grand Am",
      "Grand Prix",
      "GTO",
      "Montana",
      "Sunfire",
      "Vibe"
    ],
    "Porsche": [
      "911",
      "Boxster",
      "Carrera GT",
      "Cayenne"
    ],
    "Saab": [
      "9-3",
      "9-5"
    ],
    "Saturn": [
      "Ion",
      "L300",
      "Vue"
    ],
    "Scion": [
      "xA",
      "xB"
    ],
    "Subaru": [
      "Baja",
      "Forester",
      "Impreza",
      "Legacy",
      "Outback"
    ],
    "Suzuki": [
      "Aerio",
      "Forenza",
      "Grand Vitara",
      "Swift+",
      "Verona",
      "Vitara",
      "XL-7"
    ],
    "Toyota": [
      "4Runner",
      "Avalon",
      "Camry",
      "Celica",
      "Corolla",
      "Echo",
      "Highlander",
      "Land Cruiser",
      "Matrix",
      "MR2 Spyder",
      "Prius",
      "RAV4",
      "Sequoia",
      "Sienna",
      "Solara",
      "Tacoma",
      "Tundra"
    ],
    "Volkswagen": [
      "Beetle",
      "Golf",
      "Jetta",
      "Passat",
      "Phaeton",
      "R32",
      "Touareg"
    ],
    "Volvo": [
      "C70",
      "S40",
      "S60",
      "S80",
      "V40",
      "V70",
      "XC70",
      "XC90"
    ]
  },
  "2005": {
    "Acura": [
      "EL",
      "MDX",
      "NSX",
      "RL",
      "RSX",
      "TL",
      "TSX"
    ],
    "Audi": [
      "A4",
      "A4 Quattro",
      "A6",
      "A6 Quattro",
      "A8 Quattro",
      "Allroad Quattro",
      "S4",
      "TT",
      "TT Quattro"
    ],
    "BMW": [
      "320i",
      "323i",
      "325Ci",
      "325i",
      "325xi",
      "328i",
      "330Ci",
      "330i",
      "330xi",
      "525i",
      "528i",
      "530i",
      "545i",
      "645Ci",
      "745i",
      "745Li",
      "760Li",
      "M3",
      "M5",
      "X3",
      "X5",
      "Z4"
    ],
    "Buick": [
      "Allure",
      "Century",
      "LaCrosse",
      "LeSabre",
      "Park Avenue",
      "Rainier",
      "Rendezvous",
      "Terraza"
    ],
    "Cadillac": [
      "CTS",
      "DeVille",
      "Escalade",
      "Escalade ESV",
      "Escalade EXT",
      "SRX",
      "STS",
      "XLR"
    ],
    "Chevrolet": [
      "Astro",
      "Avalanche 1500",
      "Avalanche 2500",
      "Aveo",
      "Blazer",
      "Cavalier",
      "Classic",
      "Cobalt",
      "Colorado",
      "Corvette",
      "Epica",
      "Equinox",
      "Express 1500",
      "Express 2500",
      "Express 3500",
      "Impala",
      "Malibu",
      "Monte Carlo",
      "Optra",
      "Silverado 1500",
      "Silverado 1500 HD",
      "Silverado 2500 HD",
      "Silverado 3500",
      "SSR",
      "Suburban 1500",
      "Suburban 2500",
      "Tahoe",
      "Trailblazer",
      "Trailblazer EXT",
      "Uplander",
      "Venture",
      "W3500 Tiltmaster"
    ],
    "Chrysler": [
      "300",
      "Crossfire",
      "Pacifica",
      "PT Cruiser",
      "Sebring",
      "Town & Country"
    ],
    "Dodge": [
      "Avenger",
      "Caravan",
      "Dakota",
      "Durango",
      "Grand Caravan",
      "Magnum",
      "Neon",
      "Ram 1500",
      "Ram 2500",
      "Ram 3500",
      "Sprinter 2500",
      "Sprinter 3500",
      "Stratus",
      "SX-20"
    ],
    "Ford": [
      "Crown Victoria",
      "E-150",
      "E-150 Club Wagon",
      "E-250",
      "E-350 Club Wagon",
      "E-350 Super Duty",
      "E-450 Super Duty",
      "Escape",
      "Excursion",
      "Expedition",
      "Explorer",
      "Explorer Sport Trac",
      "F-150",
      "F-250 Super Duty",
      "F-350 Super Duty",
      "F-450 Super Duty",
      "F-550 Super Duty",
      "Five Hundred",
      "Focus",
      "Freestar",
      "Freestyle",
      "GT",
      "Mustang",
      "Ranger",
      "Taurus",
      "Thunderbird"
    ],
    "GMC": [
      "Canyon",
      "Envoy",
      "Envoy XL",
      "Envoy XUV",
      "Jimmy",
      "Safari",
      "Savana 1500",
      "Savana 2500",
      "Savana 3500",
      "Sierra 1500",
      "Sierra 1500 HD",
      "Sierra 2500 HD",
      "Sierra 3500",
      "W3500 Forward",
      "Yukon",
      "Yukon XL 1500",
      "Yukon XL 2500"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "CR-V",
      "Element",
      "Insight",
      "Odyssey",
      "Pilot",
      "S2000"
    ],
    "Hummer": [
      "H2"
    ],
    "Hyundai": [
      "Accent",
      "Elantra",
      "Santa Fe",
      "Sonata",
      "Tiburon",
      "Tucson",
      "XG350"
    ],
    "INFINITI": [
      "FX35",
      "FX45",
      "G35",
      "M45",
      "Q45",
      "QX56"
    ],
    "Jaguar": [
      "S-Type",
      "Super V8",
      "Vanden Plas",
      "X-Type",
      "XJ8",
      "XJR",
      "XK8",
      "XKR"
    ],
    "Jeep": [
      "Grand Cherokee",
      "Liberty",
      "Wrangler"
    ],
    "Kia": [
      "Amanti",
      "Optima",
      "Rio",
      "Sedona",
      "Sorento",
      "Spectra",
      "Sportage"
    ],
    "Land Rover": [
      "Freelander",
      "LR3",
      "Range Rover"
    ],
    "Lexus": [
      "ES330",
      "GS300",
      "GS430",
      "GX470",
      "IS300",
      "LS430",
      "LX470",
      "RX330",
      "SC430"
    ],
    "Lincoln": [
      "Aviator",
      "LS",
      "Navigator",
      "Town Car"
    ],
    "Mazda": [
      "3",
      "6",
      "B2300",
      "B3000",
      "B4000",
      "Miata",
      "MPV",
      "RX-8",
      "Tribute"
    ],
    "Mercedes-Benz": [
      "C230",
      "C240",
      "C280",
      "C320",
      "C55",
      "C55 AMG",
      "CL500",
      "CL55 AMG",
      "CL600",
      "CL65 AMG",
      "CLK320",
      "CLK500",
      "CLK55 AMG",
      "E320",
      "E500",
      "E55 AMG",
      "G500",
      "G55 AMG",
      "ML350",
      "ML500",
      "S350",
      "S430",
      "S500",
      "S55 AMG",
      "S600",
      "SL500",
      "SL55 AMG",
      "SL600",
      "SL65 AMG",
      "SLK350",
      "SLK55 AMG",
      "SLR McLaren"
    ],
    "Mercury": [
      "Grand Marquis",
      "Mariner",
      "Montego",
      "Monterey",
      "Mountaineer",
      "Sable"
    ],
    "Mini": [
      "Cooper"
    ],
    "Mitsubishi": [
      "Eclipse",
      "Endeavor",
      "Galant",
      "Lancer",
      "Mirage",
      "Montero",
      "Outlander"
    ],
    "Nissan": [
      "350Z",
      "Altima",
      "Armada",
      "Frontier",
      "Maxima",
      "Murano",
      "Pathfinder",
      "Quest",
      "Sentra",
      "TITAN",
      "X-Trail",
      "Xterra"
    ],
    "Pontiac": [
      "Aztek",
      "Bonneville",
      "G6",
      "Grand Am",
      "Grand Prix",
      "GTO",
      "Montana",
      "Pursuit",
      "Sunfire",
      "Vibe",
      "Wave"
    ],
    "Porsche": [
      "911",
      "Boxster",
      "Carrera GT",
      "Cayenne"
    ],
    "Saab": [
      "9-2X",
      "9-3",
      "9-5",
      "9-7x"
    ],
    "Saturn": [
      "Ion",
      "L300",
      "Relay",
      "Vue"
    ],
    "Scion": [
      "tC",
      "xA",
      "xB"
    ],
    "Smart": [
      "Fortwo"
    ],
    "Subaru": [
      "Baja",
      "Forester",
      "Impreza",
      "Legacy",
      "Outback"
    ],
    "Suzuki": [
      "Aerio",
      "Forenza",
      "Grand Vitara",
      "Swift+",
      "Verona",
      "XL-7"
    ],
    "Toyota": [
      "4Runner",
      "Avalon",
      "Camry",
      "Celica",
      "Corolla",
      "Echo",
      "Highlander",
      "Land Cruiser",
      "Matrix",
      "MR2 Spyder",
      "Prius",
      "RAV4",
      "Sequoia",
      "Sienna",
      "Solara",
      "Tacoma",
      "Tundra"
    ],
    "Volkswagen": [
      "Beetle",
      "Golf",
      "Jetta",
      "Passat",
      "Phaeton",
      "R32",
      "Touareg"
    ],
    "Volvo": [
      "C70",
      "S40",
      "S60",
      "S80",
      "V50",
      "V70",
      "XC70",
      "XC90"
    ]
  },
  "2006": {
    "Acura": [
      "CSX",
      "MDX",
      "RL",
      "RSX",
      "TL",
      "TSX"
    ],
    "Audi": [
      "A3",
      "A3 Quattro",
      "A4",
      "A4 Quattro",
      "A6",
      "A6 Quattro",
      "A8 Quattro",
      "S4",
      "TT",
      "TT Quattro"
    ],
    "BMW": [
      "320i",
      "323i",
      "325Ci",
      "325i",
      "325xi",
      "328i",
      "330Ci",
      "330i",
      "330xi",
      "525i",
      "525xi",
      "528i",
      "530i",
      "530xi",
      "550i",
      "650i",
      "750i",
      "750Li",
      "760i",
      "760Li",
      "M3",
      "M5",
      "M6",
      "X3",
      "X5",
      "Z4"
    ],
    "Buick": [
      "Allure",
      "LaCrosse",
      "Lucerne",
      "Rainier",
      "Rendezvous",
      "Terraza"
    ],
    "Cadillac": [
      "CTS",
      "DTS",
      "Escalade",
      "Escalade ESV",
      "Escalade EXT",
      "SRX",
      "STS",
      "XLR"
    ],
    "Chevrolet": [
      "Avalanche 1500",
      "Avalanche 2500",
      "Aveo",
      "Aveo5",
      "Cobalt",
      "Colorado",
      "Corvette",
      "Epica",
      "Equinox",
      "Express 1500",
      "Express 2500",
      "Express 3500",
      "HHR",
      "Impala",
      "Malibu",
      "Monte Carlo",
      "Optra",
      "Silverado 1500",
      "Silverado 1500 HD",
      "Silverado 2500 HD",
      "Silverado 3500",
      "SSR",
      "Suburban 1500",
      "Suburban 2500",
      "Tahoe",
      "Trailblazer",
      "Trailblazer EXT",
      "Uplander",
      "W3500 Tiltmaster"
    ],
    "Chrysler": [
      "300",
      "Crossfire",
      "Pacifica",
      "PT Cruiser",
      "Sebring",
      "Town & Country"
    ],
    "Dodge": [
      "Avenger",
      "Caravan",
      "Charger",
      "Dakota",
      "Durango",
      "Grand Caravan",
      "Magnum",
      "Ram 1500",
      "Ram 2500",
      "Ram 3500",
      "Sprinter 2500",
      "Sprinter 3500",
      "Stratus"
    ],
    "Ford": [
      "Crown Victoria",
      "E-150",
      "E-250",
      "E-350 Super Duty",
      "E-450 Super Duty",
      "Escape",
      "Expedition",
      "Explorer",
      "Explorer Sport Trac",
      "F-150",
      "F-250 Super Duty",
      "F-350 Super Duty",
      "F-450 Super Duty",
      "F-550 Super Duty",
      "Five Hundred",
      "Focus",
      "Freestar",
      "Freestyle",
      "Fusion",
      "GT",
      "Mustang",
      "Ranger",
      "Taurus"
    ],
    "GMC": [
      "Canyon",
      "Envoy",
      "Envoy XL",
      "Savana 1500",
      "Savana 2500",
      "Savana 3500",
      "Sierra 1500",
      "Sierra 1500 HD",
      "Sierra 2500 HD",
      "Sierra 3500",
      "W3500 Forward",
      "Yukon",
      "Yukon XL 1500",
      "Yukon XL 2500"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "CR-V",
      "Element",
      "Insight",
      "Odyssey",
      "Pilot",
      "Ridgeline",
      "S2000"
    ],
    "Hummer": [
      "H2",
      "H3"
    ],
    "Hyundai": [
      "Accent",
      "Azera",
      "Elantra",
      "Santa Fe",
      "Sonata",
      "Tiburon",
      "Tucson"
    ],
    "INFINITI": [
      "FX35",
      "FX45",
      "G35",
      "M35",
      "M45",
      "QX56"
    ],
    "Jaguar": [
      "S-Type",
      "Super V8",
      "Vanden Plas",
      "X-Type",
      "XJ8",
      "XJR",
      "XK8",
      "XKR"
    ],
    "Jeep": [
      "Commander",
      "Grand Cherokee",
      "Liberty",
      "Wrangler"
    ],
    "Kia": [
      "Amanti",
      "Optima",
      "Rio",
      "Rio5",
      "Sedona",
      "Sorento",
      "Spectra",
      "Spectra5",
      "Sportage"
    ],
    "Land Rover": [
      "LR3",
      "Range Rover",
      "Range Rover Sport"
    ],
    "Lexus": [
      "ES330",
      "GS300",
      "GS430",
      "GX470",
      "IS250",
      "IS350",
      "LS430",
      "LX470",
      "RX330",
      "RX400h",
      "SC430"
    ],
    "Lincoln": [
      "LS",
      "Mark LT",
      "Navigator",
      "Town Car",
      "Zephyr"
    ],
    "Mazda": [
      "3",
      "5",
      "6",
      "B2300",
      "B3000",
      "B4000",
      "MPV",
      "MX-5 Miata",
      "RX-8",
      "Tribute"
    ],
    "Mercedes-Benz": [
      "B200",
      "C230",
      "C280",
      "C350",
      "C55",
      "C55 AMG",
      "CL500",
      "CL55 AMG",
      "CL600",
      "CL65 AMG",
      "CLK350",
      "CLK500",
      "CLK55 AMG",
      "CLS500",
      "CLS55 AMG",
      "E320",
      "E350",
      "E500",
      "E55 AMG",
      "G500",
      "G55 AMG",
      "ML350",
      "ML500",
      "R350",
      "R500",
      "S350",
      "S430",
      "S500",
      "S55 AMG",
      "S600",
      "S65 AMG",
      "SL500",
      "SL55 AMG",
      "SL600",
      "SL65 AMG",
      "SLK280",
      "SLK350",
      "SLK55 AMG",
      "SLR McLaren"
    ],
    "Mercury": [
      "Grand Marquis",
      "Mariner",
      "Milan",
      "Montego",
      "Monterey",
      "Mountaineer"
    ],
    "Mini": [
      "Cooper"
    ],
    "Mitsubishi": [
      "Eclipse",
      "Endeavor",
      "Galant",
      "Lancer",
      "Mirage",
      "Montero",
      "Outlander",
      "Raider"
    ],
    "Nissan": [
      "350Z",
      "Altima",
      "Armada",
      "Frontier",
      "Maxima",
      "Murano",
      "Pathfinder",
      "Quest",
      "Sentra",
      "TITAN",
      "X-Trail",
      "Xterra"
    ],
    "Pontiac": [
      "G6",
      "Grand Prix",
      "GTO",
      "Montana",
      "Pursuit",
      "Solstice",
      "Torrent",
      "Vibe",
      "Wave"
    ],
    "Porsche": [
      "911",
      "Boxster",
      "Cayenne",
      "Cayman"
    ],
    "Saab": [
      "9-2X",
      "9-3",
      "9-5",
      "9-7x"
    ],
    "Saturn": [
      "Ion",
      "Relay",
      "Vue"
    ],
    "Scion": [
      "tC",
      "xA",
      "xB"
    ],
    "Smart": [
      "Fortwo"
    ],
    "Subaru": [
      "B9 Tribeca",
      "Baja",
      "Forester",
      "Impreza",
      "Legacy",
      "Outback"
    ],
    "Suzuki": [
      "Aerio",
      "Forenza",
      "Grand Vitara",
      "Reno",
      "Swift+",
      "Verona",
      "XL-7"
    ],
    "Toyota": [
      "4Runner",
      "Avalon",
      "Camry",
      "Corolla",
      "Highlander",
      "Land Cruiser",
      "Matrix",
      "Prius",
      "RAV4",
      "Sequoia",
      "Sienna",
      "Solara",
      "Tacoma",
      "Tundra",
      "Yaris"
    ],
    "Volkswagen": [
      "Beetle",
      "Golf",
      "GTI",
      "Jetta",
      "Passat",
      "Phaeton",
      "R32",
      "Rabbit",
      "Touareg"
    ],
    "Volvo": [
      "C70",
      "S40",
      "S60",
      "S80",
      "V50",
      "V70",
      "XC70",
      "XC90"
    ]
  },
  "2007": {
    "Acura": [
      "CSX",
      "MDX",
      "RDX",
      "RL",
      "TL",
      "TSX"
    ],
    "Audi": [
      "A3",
      "A3 Quattro",
      "A4",
      "A4 Quattro",
      "A6",
      "A6 Quattro",
      "A8 Quattro",
      "Q7",
      "RS4",
      "S4",
      "S6",
      "S8",
      "TT Quattro"
    ],
    "BMW": [
      "320i",
      "323i",
      "328i",
      "328xi",
      "330i",
      "335i",
      "335xi",
      "525i",
      "525xi",
      "528i",
      "530i",
      "530xi",
      "550i",
      "650i",
      "750i",
      "750Li",
      "760Li",
      "Alpina B7",
      "M3",
      "M5",
      "M6",
      "X3",
      "X5",
      "Z4"
    ],
    "Buick": [
      "Allure",
      "LaCrosse",
      "Lucerne",
      "Rainier",
      "Rendezvous",
      "Terraza"
    ],
    "Cadillac": [
      "CTS",
      "DTS",
      "Escalade",
      "Escalade ESV",
      "Escalade EXT",
      "SRX",
      "STS",
      "XLR"
    ],
    "Chevrolet": [
      "Avalanche",
      "Aveo",
      "Aveo5",
      "Cobalt",
      "Colorado",
      "Corvette",
      "Equinox",
      "Express 1500",
      "Express 2500",
      "Express 3500",
      "HHR",
      "Impala",
      "Malibu",
      "Monte Carlo",
      "Optra",
      "Silverado 1500",
      "Silverado 1500 Classic",
      "Silverado 1500 HD Classic",
      "Silverado 2500 HD",
      "Silverado 2500 HD Classic",
      "Silverado 3500 Classic",
      "Silverado 3500 HD",
      "Suburban 1500",
      "Suburban 2500",
      "Tahoe",
      "Trailblazer",
      "Uplander",
      "W3500 Tiltmaster"
    ],
    "Chrysler": [
      "300",
      "Aspen",
      "Crossfire",
      "Pacifica",
      "PT Cruiser",
      "Sebring",
      "Town & Country"
    ],
    "Dodge": [
      "Avenger",
      "Caliber",
      "Caravan",
      "Charger",
      "Dakota",
      "Durango",
      "Grand Caravan",
      "Magnum",
      "Nitro",
      "Ram 1500",
      "Ram 2500",
      "Ram 3500",
      "Sprinter 2500",
      "Sprinter 3500"
    ],
    "Ford": [
      "Crown Victoria",
      "E-150",
      "E-250",
      "E-350 Super Duty",
      "E-450 Super Duty",
      "Edge",
      "Escape",
      "Expedition",
      "Explorer",
      "Explorer Sport Trac",
      "F-150",
      "F-250 Super Duty",
      "F-350 Super Duty",
      "F-450 Super Duty",
      "F-550 Super Duty",
      "Five Hundred",
      "Focus",
      "Freestar",
      "Freestyle",
      "Fusion",
      "Mustang",
      "Ranger",
      "Taurus"
    ],
    "GMC": [
      "Acadia",
      "Canyon",
      "Envoy",
      "Savana 1500",
      "Savana 2500",
      "Savana 3500",
      "Sierra 1500",
      "Sierra 1500 Classic",
      "Sierra 1500 HD Classic",
      "Sierra 2500 HD",
      "Sierra 2500 HD Classic",
      "Sierra 3500 Classic",
      "Sierra 3500 HD",
      "W3500 Forward",
      "Yukon",
      "Yukon XL 1500",
      "Yukon XL 2500"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "CR-V",
      "Element",
      "Fit",
      "Odyssey",
      "Pilot",
      "Ridgeline",
      "S2000"
    ],
    "Hummer": [
      "H2",
      "H3"
    ],
    "Hyundai": [
      "Accent",
      "Azera",
      "Elantra",
      "Entourage",
      "Santa Fe",
      "Sonata",
      "Tiburon",
      "Tucson",
      "Veracruz"
    ],
    "INFINITI": [
      "FX35",
      "FX45",
      "G35",
      "M35",
      "M45",
      "QX56"
    ],
    "Jaguar": [
      "S-Type",
      "Super V8",
      "Vanden Plas",
      "X-Type",
      "XJ8",
      "XJR",
      "XK",
      "XKR"
    ],
    "Jeep": [
      "Commander",
      "Compass",
      "Grand Cherokee",
      "Liberty",
      "Patriot",
      "Wrangler"
    ],
    "Kia": [
      "Amanti",
      "Optima",
      "Rio",
      "Rio5",
      "Rondo",
      "Sedona",
      "Sorento",
      "Spectra",
      "Spectra5",
      "Sportage"
    ],
    "Land Rover": [
      "LR3",
      "Range Rover",
      "Range Rover Sport"
    ],
    "Lexus": [
      "ES350",
      "GS350",
      "GS430",
      "GS450h",
      "GX470",
      "IS250",
      "IS350",
      "LS460",
      "LX470",
      "RX350",
      "RX400h",
      "SC430"
    ],
    "Lincoln": [
      "Mark LT",
      "MKX",
      "MKZ",
      "Navigator",
      "Town Car"
    ],
    "Mazda": [
      "3",
      "5",
      "6",
      "B2300",
      "B3000",
      "B4000",
      "CX-7",
      "CX-9",
      "MX-5 Miata",
      "RX-8",
      "Tribute"
    ],
    "Mercedes-Benz": [
      "B200",
      "C230",
      "C280",
      "C350",
      "CL550",
      "CL600",
      "CL65 AMG",
      "CLK350",
      "CLK550",
      "CLK63 AMG",
      "CLS550",
      "CLS63 AMG",
      "E280",
      "E320",
      "E350",
      "E550",
      "E63 AMG",
      "G500",
      "G55 AMG",
      "GL320",
      "GL450",
      "ML320",
      "ML350",
      "ML500",
      "ML63 AMG",
      "R320",
      "R350",
      "R500",
      "R63 AMG",
      "S350",
      "S550",
      "S600",
      "S65 AMG",
      "SL55 AMG",
      "SL550",
      "SL600",
      "SL65 AMG",
      "SLK280",
      "SLK350",
      "SLK55 AMG",
      "SLR McLaren"
    ],
    "Mercury": [
      "Grand Marquis",
      "Mariner",
      "Milan",
      "Montego",
      "Monterey",
      "Mountaineer"
    ],
    "Mini": [
      "Cooper"
    ],
    "Mitsubishi": [
      "Eclipse",
      "Endeavor",
      "Galant",
      "Lancer",
      "Mirage",
      "Outlander",
      "Raider"
    ],
    "Nissan": [
      "350Z",
      "Altima",
      "Armada",
      "Frontier",
      "Maxima",
      "Murano",
      "Pathfinder",
      "Quest",
      "Sentra",
      "TITAN",
      "Versa",
      "Xterra"
    ],
    "Pontiac": [
      "G5",
      "G6",
      "Grand Prix",
      "Montana",
      "Solstice",
      "Torrent",
      "Vibe",
      "Wave"
    ],
    "Porsche": [
      "911",
      "Boxster",
      "Cayenne",
      "Cayman"
    ],
    "Saab": [
      "9-3",
      "9-5",
      "9-7x"
    ],
    "Saturn": [
      "Aura",
      "Ion",
      "Outlook",
      "Relay",
      "Sky",
      "Vue"
    ],
    "Scion": [
      "tC"
    ],
    "Smart": [
      "Fortwo"
    ],
    "Subaru": [
      "B9 Tribeca",
      "Forester",
      "Impreza",
      "Legacy",
      "Outback"
    ],
    "Suzuki": [
      "Aerio",
      "Forenza",
      "Grand Vitara",
      "Reno",
      "Swift+",
      "SX4",
      "XL-7"
    ],
    "Toyota": [
      "4Runner",
      "Avalon",
      "Camry",
      "Corolla",
      "FJ Cruiser",
      "Highlander",
      "Land Cruiser",
      "Matrix",
      "Prius",
      "RAV4",
      "Sequoia",
      "Sienna",
      "Solara",
      "Tacoma",
      "Tundra",
      "Yaris"
    ],
    "Volkswagen": [
      "Beetle",
      "Eos",
      "Golf",
      "Golf City",
      "GTI",
      "Jetta",
      "Jetta City",
      "Passat",
      "R32",
      "Rabbit",
      "Touareg"
    ],
    "Volvo": [
      "C30",
      "C70",
      "S40",
      "S60",
      "S80",
      "V50",
      "V70",
      "XC70",
      "XC90"
    ]
  },
  "2008": {
    "Acura": [
      "CSX",
      "MDX",
      "RDX",
      "RL",
      "TL",
      "TSX"
    ],
    "Audi": [
      "A3",
      "A3 Quattro",
      "A4",
      "A4 Quattro",
      "A5 Quattro",
      "A6",
      "A6 Quattro",
      "A8 Quattro",
      "Q7",
      "R8",
      "RS4",
      "S4",
      "S5",
      "S6",
      "S8",
      "TT",
      "TT Quattro"
    ],
    "BMW": [
      "128i",
      "135i",
      "320i",
      "323i",
      "328i",
      "328xi",
      "330i",
      "335i",
      "335xi",
      "528i",
      "528xi",
      "535i",
      "535xi",
      "550i",
      "650i",
      "750i",
      "750Li",
      "760Li",
      "Alpina B7",
      "M3",
      "M5",
      "M6",
      "X3",
      "X5",
      "X6",
      "Z4"
    ],
    "Buick": [
      "Allure",
      "Enclave",
      "LaCrosse",
      "Lucerne"
    ],
    "Cadillac": [
      "CTS",
      "DTS",
      "Escalade",
      "Escalade ESV",
      "Escalade EXT",
      "SRX",
      "STS",
      "XLR"
    ],
    "Chevrolet": [
      "Avalanche",
      "Aveo",
      "Aveo5",
      "Cobalt",
      "Colorado",
      "Corvette",
      "Equinox",
      "Express 1500",
      "Express 2500",
      "Express 3500",
      "HHR",
      "Impala",
      "Malibu",
      "Silverado 1500",
      "Silverado 2500 HD",
      "Silverado 3500 HD",
      "Suburban 1500",
      "Suburban 2500",
      "Tahoe",
      "Trailblazer",
      "Uplander",
      "W3500 Tiltmaster"
    ],
    "Chrysler": [
      "300",
      "Aspen",
      "Crossfire",
      "Pacifica",
      "PT Cruiser",
      "Sebring",
      "Town & Country"
    ],
    "Dodge": [
      "Avenger",
      "Caliber",
      "Challenger",
      "Charger",
      "Dakota",
      "Durango",
      "Grand Caravan",
      "Magnum",
      "Nitro",
      "Ram 1500",
      "Ram 2500",
      "Ram 3500",
      "Sprinter 2500",
      "Sprinter 3500"
    ],
    "Ford": [
      "Crown Victoria",
      "E-150",
      "E-250",
      "E-350 Super Duty",
      "E-450 Super Duty",
      "Edge",
      "Escape",
      "Expedition",
      "Explorer",
      "Explorer Sport Trac",
      "F-150",
      "F-250 Super Duty",
      "F-350 Super Duty",
      "F-450 Super Duty",
      "F-550 Super Duty",
      "Focus",
      "Fusion",
      "Mustang",
      "Ranger",
      "Taurus",
      "Taurus X"
    ],
    "GMC": [
      "Acadia",
      "Canyon",
      "Envoy",
      "Savana 1500",
      "Savana 2500",
      "Savana 3500",
      "Sierra 1500",
      "Sierra 2500 HD",
      "Sierra 3500 HD",
      "Yukon",
      "Yukon XL 1500",
      "Yukon XL 2500"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "CR-V",
      "Element",
      "Fit",
      "Odyssey",
      "Pilot",
      "Ridgeline",
      "S2000"
    ],
    "Hummer": [
      "H2",
      "H3"
    ],
    "Hyundai": [
      "Accent",
      "Azera",
      "Elantra",
      "Entourage",
      "Santa Fe",
      "Sonata",
      "Tiburon",
      "Tucson",
      "Veracruz"
    ],
    "INFINITI": [
      "EX35",
      "FX35",
      "FX45",
      "G35",
      "G37",
      "M35",
      "M45",
      "QX56"
    ],
    "Jaguar": [
      "S-Type",
      "Super V8",
      "Vanden Plas",
      "X-Type",
      "XJ8",
      "XJR",
      "XK",
      "XKR"
    ],
    "Jeep": [
      "Commander",
      "Compass",
      "Grand Cherokee",
      "Liberty",
      "Patriot",
      "Wrangler"
    ],
    "Kia": [
      "Amanti",
      "Optima",
      "Rio",
      "Rio5",
      "Rondo",
      "Sedona",
      "Sorento",
      "Spectra",
      "Spectra5",
      "Sportage"
    ],
    "Land Rover": [
      "LR2",
      "LR3",
      "Range Rover",
      "Range Rover Sport"
    ],
    "Lexus": [
      "ES350",
      "GS350",
      "GS450h",
      "GS460",
      "GX470",
      "IS F",
      "IS250",
      "IS350",
      "LS460",
      "LS600h",
      "LX570",
      "RX350",
      "RX400h",
      "SC430"
    ],
    "Lincoln": [
      "Mark LT",
      "MKX",
      "MKZ",
      "Navigator",
      "Town Car"
    ],
    "Mazda": [
      "3",
      "5",
      "6",
      "B2300",
      "B3000",
      "B4000",
      "CX-7",
      "CX-9",
      "MX-5 Miata",
      "RX-8",
      "Tribute"
    ],
    "Mercedes-Benz": [
      "B200",
      "C230",
      "C300",
      "C350",
      "C63 AMG",
      "CL550",
      "CL600",
      "CL63 AMG",
      "CL65 AMG",
      "CLK350",
      "CLK550",
      "CLK63 AMG",
      "CLS550",
      "CLS63 AMG",
      "E300",
      "E320",
      "E350",
      "E550",
      "E63 AMG",
      "G500",
      "G55 AMG",
      "GL320",
      "GL450",
      "GL550",
      "ML320",
      "ML350",
      "ML550",
      "ML63 AMG",
      "R320",
      "R350",
      "R550",
      "S350",
      "S450",
      "S550",
      "S600",
      "S63 AMG",
      "S65 AMG",
      "SL55 AMG",
      "SL550",
      "SL600",
      "SL65 AMG",
      "SLK280",
      "SLK350",
      "SLK55 AMG",
      "SLR McLaren"
    ],
    "Mercury": [
      "Grand Marquis",
      "Mariner",
      "Milan",
      "Mountaineer",
      "Sable"
    ],
    "Mini": [
      "Cooper"
    ],
    "Mitsubishi": [
      "Eclipse",
      "Endeavor",
      "Galant",
      "Lancer",
      "Mirage",
      "Outlander",
      "Raider"
    ],
    "Nissan": [
      "350Z",
      "Altima",
      "Armada",
      "Frontier",
      "Maxima",
      "Murano",
      "Pathfinder",
      "Quest",
      "Rogue",
      "Sentra",
      "TITAN",
      "Versa",
      "Xterra"
    ],
    "Pontiac": [
      "G5",
      "G6",
      "G8",
      "Grand Prix",
      "Montana",
      "Solstice",
      "Torrent",
      "Vibe",
      "Wave"
    ],
    "Porsche": [
      "911",
      "Boxster",
      "Cayenne",
      "Cayman"
    ],
    "Saab": [
      "9-3",
      "9-5",
      "9-7x"
    ],
    "Saturn": [
      "Astra",
      "Aura",
      "Outlook",
      "Sky",
      "Vue"
    ],
    "Scion": [
      "tC",
      "xB",
      "xD"
    ],
    "Smart": [
      "Fortwo"
    ],
    "Subaru": [
      "Forester",
      "Impreza",
      "Legacy",
      "Outback",
      "Tribeca"
    ],
    "Suzuki": [
      "Forenza",
      "Grand Vitara",
      "Reno",
      "Swift+",
      "SX4",
      "XL-7"
    ],
    "Toyota": [
      "4Runner",
      "Avalon",
      "Camry",
      "Corolla",
      "FJ Cruiser",
      "Highlander",
      "Land Cruiser",
      "Matrix",
      "Prius",
      "RAV4",
      "Sequoia",
      "Sienna",
      "Solara",
      "Tacoma",
      "Tundra",
      "Yaris"
    ],
    "Volkswagen": [
      "Beetle",
      "Eos",
      "Golf",
      "Golf City",
      "GTI",
      "Jetta",
      "Jetta City",
      "Passat",
      "R32",
      "Rabbit",
      "Touareg"
    ],
    "Volvo": [
      "C30",
      "C70",
      "S40",
      "S60",
      "S80",
      "V50",
      "V70",
      "XC70",
      "XC90"
    ]
  },
  "2009": {
    "Acura": [
      "CSX",
      "MDX",
      "RDX",
      "RL",
      "TL",
      "TSX"
    ],
    "Audi": [
      "A3",
      "A3 Quattro",
      "A4",
      "A4 Quattro",
      "A5 Quattro",
      "A6",
      "A6 Quattro",
      "A8 Quattro",
      "Q5",
      "Q7",
      "R8",
      "S4",
      "S5",
      "S6",
      "S8",
      "TT",
      "TT Quattro",
      "TTS Quattro"
    ],
    "BMW": [
      "128i",
      "135i",
      "320i",
      "323i",
      "328i",
      "328i xDrive",
      "330i",
      "335d",
      "335i",
      "335i xDrive",
      "528i",
      "528i xDrive",
      "535i",
      "535i xDrive",
      "550i",
      "650i",
      "750i",
      "750Li",
      "760Li",
      "Alpina B7",
      "M3",
      "M5",
      "M6",
      "X3",
      "X5",
      "X6",
      "Z4"
    ],
    "Buick": [
      "Allure",
      "Enclave",
      "LaCrosse",
      "Lucerne"
    ],
    "Cadillac": [
      "CTS",
      "DTS",
      "Escalade",
      "Escalade ESV",
      "Escalade EXT",
      "SRX",
      "STS",
      "XLR"
    ],
    "Chevrolet": [
      "Avalanche",
      "Aveo",
      "Aveo5",
      "Cobalt",
      "Colorado",
      "Corvette",
      "Equinox",
      "Express 1500",
      "Express 2500",
      "Express 3500",
      "HHR",
      "Impala",
      "Malibu",
      "Silverado 1500",
      "Silverado 2500 HD",
      "Silverado 3500 HD",
      "Suburban 1500",
      "Suburban 2500",
      "Tahoe",
      "Trailblazer",
      "Traverse",
      "Uplander"
    ],
    "Chrysler": [
      "300",
      "Aspen",
      "PT Cruiser",
      "Sebring",
      "Town & Country"
    ],
    "Dodge": [
      "Avenger",
      "Caliber",
      "Challenger",
      "Charger",
      "Dakota",
      "Durango",
      "Grand Caravan",
      "Journey",
      "Nitro",
      "Ram 1500",
      "Ram 2500",
      "Ram 3500",
      "Sprinter 2500",
      "Sprinter 3500"
    ],
    "Ford": [
      "Crown Victoria",
      "E-150",
      "E-250",
      "E-350 Super Duty",
      "E-450 Super Duty",
      "Ecosport",
      "Edge",
      "Escape",
      "Expedition",
      "Explorer",
      "Explorer Sport Trac",
      "F-150",
      "F-250 Super Duty",
      "F-350 Super Duty",
      "F-450 Super Duty",
      "F-550 Super Duty",
      "Flex",
      "Focus",
      "Fusion",
      "Mustang",
      "Ranger",
      "Taurus",
      "Taurus X"
    ],
    "GMC": [
      "Acadia",
      "Canyon",
      "Envoy",
      "Savana 1500",
      "Savana 2500",
      "Savana 3500",
      "Sierra 1500",
      "Sierra 2500 HD",
      "Sierra 3500 HD",
      "Yukon",
      "Yukon XL 1500",
      "Yukon XL 2500"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "CR-V",
      "Element",
      "Fit",
      "Odyssey",
      "Pilot",
      "Ridgeline",
      "S2000"
    ],
    "Hummer": [
      "H2",
      "H3",
      "H3T"
    ],
    "Hyundai": [
      "Accent",
      "Azera",
      "Elantra",
      "Entourage",
      "Genesis",
      "Santa Fe",
      "Sonata",
      "Tucson",
      "Veracruz"
    ],
    "INFINITI": [
      "EX35",
      "FX35",
      "FX50",
      "G37",
      "M35",
      "M45",
      "QX56"
    ],
    "Jaguar": [
      "Vanden Plas",
      "XF",
      "XJ8",
      "XJR",
      "XK",
      "XKR"
    ],
    "Jeep": [
      "Commander",
      "Compass",
      "Grand Cherokee",
      "Liberty",
      "Patriot",
      "Wrangler"
    ],
    "Kia": [
      "Amanti",
      "Borrego",
      "Optima",
      "Rio",
      "Rio5",
      "Rondo",
      "Sedona",
      "Sorento",
      "Spectra",
      "Spectra5",
      "Sportage"
    ],
    "Land Rover": [
      "LR2",
      "LR3",
      "Range Rover",
      "Range Rover Sport"
    ],
    "Lexus": [
      "ES350",
      "GS350",
      "GS450h",
      "GS460",
      "GX470",
      "IS F",
      "IS250",
      "IS350",
      "LS460",
      "LS600h",
      "LX570",
      "RX350",
      "SC430"
    ],
    "Lincoln": [
      "MKS",
      "MKX",
      "MKZ",
      "Navigator",
      "Town Car"
    ],
    "Mazda": [
      "3",
      "5",
      "6",
      "B2300",
      "B4000",
      "CX-7",
      "CX-9",
      "MX-5",
      "MX-5 Miata",
      "RX-8",
      "Tribute"
    ],
    "Mercedes-Benz": [
      "B200",
      "C230",
      "C300",
      "C350",
      "C63 AMG",
      "CL550",
      "CL600",
      "CL63 AMG",
      "CL65 AMG",
      "CLK350",
      "CLK550",
      "CLK63 AMG",
      "CLS550",
      "CLS63 AMG",
      "E300",
      "E320",
      "E350",
      "E550",
      "E63 AMG",
      "G55 AMG",
      "G550",
      "GL320",
      "GL450",
      "GL550",
      "ML320",
      "ML350",
      "ML550",
      "ML63 AMG",
      "R320",
      "R350",
      "S350",
      "S450",
      "S550",
      "S600",
      "S63 AMG",
      "S65 AMG",
      "SL550",
      "SL600",
      "SL63 AMG",
      "SL65 AMG",
      "SLK300",
      "SLK350",
      "SLK55 AMG",
      "SLR McLaren"
    ],
    "Mercury": [
      "Grand Marquis",
      "Mariner",
      "Milan",
      "Mountaineer",
      "Sable"
    ],
    "Mini": [
      "Cooper"
    ],
    "Mitsubishi": [
      "Eclipse",
      "Endeavor",
      "Galant",
      "Lancer",
      "Mirage",
      "Outlander"
    ],
    "Nissan": [
      "350Z",
      "370Z",
      "Altima",
      "Armada",
      "Cube",
      "Frontier",
      "GT-R",
      "Maxima",
      "Murano",
      "Pathfinder",
      "Quest",
      "Rogue",
      "Sentra",
      "TITAN",
      "Versa",
      "Xterra"
    ],
    "Pontiac": [
      "G3",
      "G5",
      "G6",
      "G8",
      "Montana",
      "Solstice",
      "Torrent",
      "Vibe"
    ],
    "Porsche": [
      "911",
      "Boxster",
      "Cayenne",
      "Cayman"
    ],
    "Saab": [
      "9-3",
      "9-5",
      "9-7x"
    ],
    "Saturn": [
      "Astra",
      "Aura",
      "Outlook",
      "Sky",
      "Vue"
    ],
    "Scion": [
      "tC",
      "xB",
      "xD"
    ],
    "Smart": [
      "Fortwo"
    ],
    "Subaru": [
      "Forester",
      "Impreza",
      "Legacy",
      "Outback",
      "Tribeca"
    ],
    "Suzuki": [
      "Equator",
      "Grand Vitara",
      "Swift+",
      "SX4",
      "XL-7"
    ],
    "Toyota": [
      "4Runner",
      "Avalon",
      "Camry",
      "Corolla",
      "FJ Cruiser",
      "Highlander",
      "Land Cruiser",
      "Matrix",
      "Prius",
      "RAV4",
      "Sequoia",
      "Sienna",
      "Tacoma",
      "Tundra",
      "Venza",
      "Yaris"
    ],
    "Volkswagen": [
      "Beetle",
      "CC",
      "Eos",
      "Golf",
      "Golf City",
      "GTI",
      "Jetta",
      "Jetta City",
      "Passat",
      "Rabbit",
      "Routan",
      "Tiguan",
      "Touareg"
    ],
    "Volvo": [
      "C30",
      "C70",
      "S40",
      "S60",
      "S80",
      "V50",
      "V70",
      "VT",
      "XC70",
      "XC90"
    ]
  },
  "2010": {
    "Acura": [
      "CSX",
      "MDX",
      "RDX",
      "RL",
      "TL",
      "TSX",
      "ZDX"
    ],
    "Audi": [
      "A3",
      "A3 Quattro",
      "A4",
      "A4 Quattro",
      "A5 Quattro",
      "A6",
      "A6 Quattro",
      "A8 Quattro",
      "Q5",
      "Q7",
      "R8",
      "S4",
      "S5",
      "S6",
      "TT Quattro",
      "TTS Quattro"
    ],
    "BMW": [
      "128i",
      "135i",
      "320i",
      "323i",
      "328i",
      "328i xDrive",
      "330i",
      "335d",
      "335i",
      "335i xDrive",
      "528i",
      "528i xDrive",
      "535i",
      "535i GT",
      "535i xDrive",
      "550i",
      "550i GT",
      "550i GT xDrive",
      "650i",
      "750i",
      "750i xDrive",
      "750Li",
      "750Li xDrive",
      "760Li",
      "Alpina B7",
      "M3",
      "M5",
      "M6",
      "X3",
      "X5",
      "X6",
      "Z4"
    ],
    "Buick": [
      "Enclave",
      "LaCrosse",
      "Lucerne"
    ],
    "Cadillac": [
      "CTS",
      "DTS",
      "Escalade",
      "Escalade ESV",
      "Escalade EXT",
      "SRX",
      "STS"
    ],
    "Chevrolet": [
      "Avalanche",
      "Aveo",
      "Aveo5",
      "Camaro",
      "Cobalt",
      "Colorado",
      "Corvette",
      "Equinox",
      "Express 1500",
      "Express 2500",
      "Express 3500",
      "HHR",
      "Impala",
      "Malibu",
      "Silverado 1500",
      "Silverado 2500 HD",
      "Silverado 3500",
      "Silverado 3500 HD",
      "Suburban 1500",
      "Suburban 2500",
      "Tahoe",
      "Traverse"
    ],
    "Chrysler": [
      "300",
      "PT Cruiser",
      "Sebring",
      "Town & Country"
    ],
    "Dodge": [
      "Avenger",
      "Caliber",
      "Challenger",
      "Charger",
      "Dakota",
      "Durango",
      "Grand Caravan",
      "Journey",
      "Nitro",
      "Ram 1500",
      "Ram 2500",
      "Ram 3500"
    ],
    "Ford": [
      "Crown Victoria",
      "E-150",
      "E-250",
      "E-350 Super Duty",
      "E-450 Super Duty",
      "Ecosport",
      "Edge",
      "Escape",
      "Expedition",
      "Explorer",
      "Explorer Sport Trac",
      "F-150",
      "F-250 Super Duty",
      "F-350 Super Duty",
      "F-450 Super Duty",
      "F-550 Super Duty",
      "Flex",
      "Focus",
      "Fusion",
      "Mustang",
      "Ranger",
      "Taurus",
      "Transit Connect"
    ],
    "GMC": [
      "Acadia",
      "Canyon",
      "Savana 1500",
      "Savana 2500",
      "Savana 3500",
      "Sierra 1500",
      "Sierra 2500 HD",
      "Sierra 3500 HD",
      "Terrain",
      "Yukon",
      "Yukon XL 1500",
      "Yukon XL 2500"
    ],
    "Honda": [
      "Accord",
      "Accord Crosstour",
      "Civic",
      "CR-V",
      "Element",
      "Fit",
      "Insight",
      "Odyssey",
      "Pilot",
      "Ridgeline"
    ],
    "Hummer": [
      "H3",
      "H3T"
    ],
    "Hyundai": [
      "Accent",
      "Azera",
      "Elantra",
      "Entourage",
      "Genesis",
      "Genesis Coupe",
      "Santa Fe",
      "Sonata",
      "Tucson",
      "Veracruz"
    ],
    "INFINITI": [
      "EX35",
      "FX35",
      "FX50",
      "G37",
      "M35",
      "M45",
      "QX56"
    ],
    "Jaguar": [
      "XF",
      "XFR",
      "XJ",
      "XJR",
      "XK",
      "XKR"
    ],
    "Jeep": [
      "Commander",
      "Compass",
      "Grand Cherokee",
      "Liberty",
      "Patriot",
      "Wrangler"
    ],
    "Kia": [
      "Borrego",
      "Forte",
      "Forte Koup",
      "Optima",
      "Rio",
      "Rio5",
      "Rondo",
      "Sedona",
      "Sorento",
      "Soul",
      "Sportage"
    ],
    "Land Rover": [
      "LR2",
      "LR4",
      "Range Rover",
      "Range Rover Sport"
    ],
    "Lexus": [
      "ES350",
      "GS350",
      "GS450h",
      "GS460",
      "GX460",
      "HS250h",
      "IS F",
      "IS250",
      "IS350",
      "LS460",
      "LS600h",
      "LX570",
      "RX350",
      "RX450h",
      "SC430"
    ],
    "Lincoln": [
      "MKS",
      "MKT",
      "MKX",
      "MKZ",
      "Navigator",
      "Town Car"
    ],
    "Lotus": [
      "Elise",
      "Exige"
    ],
    "Mazda": [
      "3",
      "5",
      "6",
      "B2300",
      "B4000",
      "CX-7",
      "CX-9",
      "MX-5 Miata",
      "RX-8",
      "Tribute"
    ],
    "Mercedes-Benz": [
      "B200",
      "C250",
      "C300",
      "C350",
      "C63 AMG",
      "CL550",
      "CL600",
      "CL63 AMG",
      "CL65 AMG",
      "CLS550",
      "CLS63 AMG",
      "E300",
      "E350",
      "E550",
      "E63 AMG",
      "G55 AMG",
      "G550",
      "GL350",
      "GL450",
      "GL550",
      "GLK350",
      "ML350",
      "ML550",
      "ML63 AMG",
      "R350",
      "S350",
      "S400",
      "S450",
      "S550",
      "S600",
      "S63 AMG",
      "S65 AMG",
      "SL550",
      "SL63 AMG",
      "SL65 AMG",
      "SLK300",
      "SLK350",
      "SLK55 AMG",
      "Sprinter 2500",
      "Sprinter 3500"
    ],
    "Mercury": [
      "Grand Marquis",
      "Mariner",
      "Milan",
      "Mountaineer"
    ],
    "Mini": [
      "Cooper"
    ],
    "Mitsubishi": [
      "Eclipse",
      "Endeavor",
      "Galant",
      "Lancer",
      "Mirage",
      "Outlander"
    ],
    "Nissan": [
      "370Z",
      "Altima",
      "Armada",
      "Cube",
      "Frontier",
      "GT-R",
      "Maxima",
      "Murano",
      "Pathfinder",
      "Quest",
      "Rogue",
      "Sentra",
      "TITAN",
      "Versa",
      "Xterra"
    ],
    "Pontiac": [
      "G3",
      "G5",
      "G6",
      "Vibe"
    ],
    "Porsche": [
      "911",
      "Boxster",
      "Cayenne",
      "Cayman",
      "Panamera"
    ],
    "Saab": [
      "9-3",
      "9-5"
    ],
    "Saturn": [
      "Outlook",
      "Vue"
    ],
    "Scion": [
      "tC",
      "xB",
      "xD"
    ],
    "Smart": [
      "Fortwo"
    ],
    "Subaru": [
      "Forester",
      "Impreza",
      "Legacy",
      "Outback",
      "Tribeca"
    ],
    "Suzuki": [
      "Equator",
      "Grand Vitara",
      "Kizashi",
      "Swift+",
      "SX4"
    ],
    "Toyota": [
      "4Runner",
      "Avalon",
      "Camry",
      "Corolla",
      "FJ Cruiser",
      "Highlander",
      "Land Cruiser",
      "Matrix",
      "Prius",
      "RAV4",
      "Sequoia",
      "Sienna",
      "Tacoma",
      "Tundra",
      "Venza",
      "Yaris"
    ],
    "Volkswagen": [
      "Beetle",
      "CC",
      "Eos",
      "Golf",
      "GTI",
      "Jetta",
      "Passat",
      "Routan",
      "Tiguan",
      "Touareg"
    ],
    "Volvo": [
      "C30",
      "C70",
      "S40",
      "S60",
      "S80",
      "V50",
      "V70",
      "XC60",
      "XC70",
      "XC90"
    ]
  },
  "2011": {
    "Acura": [
      "CSX",
      "MDX",
      "RDX",
      "RL",
      "TL",
      "TSX",
      "ZDX"
    ],
    "Audi": [
      "A3",
      "A3 Quattro",
      "A4",
      "A4 Quattro",
      "A5 Quattro",
      "A6 Quattro",
      "A8 Quattro",
      "Q5",
      "Q7",
      "R8",
      "S4",
      "S5",
      "S6",
      "TT Quattro",
      "TTS Quattro"
    ],
    "BMW": [
      "1 Series M",
      "128i",
      "135i",
      "320i",
      "323i",
      "328i",
      "328i xDrive",
      "330i",
      "335d",
      "335i",
      "335i xDrive",
      "335is",
      "528i",
      "528i xDrive",
      "535i",
      "535i GT",
      "535i GT xDrive",
      "535i xDrive",
      "550i",
      "550i GT",
      "550i GT xDrive",
      "550i xDrive",
      "650i",
      "740i",
      "740Li",
      "750i",
      "750i xDrive",
      "750Li",
      "750Li xDrive",
      "760Li",
      "Alpina B7",
      "Alpina B7 xDrive",
      "Alpina B7L xDrive",
      "M3",
      "X3",
      "X5",
      "X6",
      "Z4"
    ],
    "Buick": [
      "Enclave",
      "LaCrosse",
      "Lucerne",
      "Regal"
    ],
    "Cadillac": [
      "CTS",
      "DTS",
      "Escalade",
      "Escalade ESV",
      "Escalade EXT",
      "SRX",
      "STS"
    ],
    "Chevrolet": [
      "Avalanche",
      "Aveo",
      "Aveo5",
      "Camaro",
      "Caprice",
      "Colorado",
      "Corvette",
      "Cruze",
      "Equinox",
      "Express 1500",
      "Express 2500",
      "Express 3500",
      "Express 4500",
      "HHR",
      "Impala",
      "Malibu",
      "Silverado 1500",
      "Silverado 2500 HD",
      "Silverado 3500",
      "Silverado 3500 HD",
      "Suburban 1500",
      "Suburban 2500",
      "Tahoe",
      "Traverse",
      "Volt"
    ],
    "Chrysler": [
      "200",
      "300",
      "Town & Country"
    ],
    "Dodge": [
      "Avenger",
      "Caliber",
      "Challenger",
      "Charger",
      "Durango",
      "Grand Caravan",
      "Journey",
      "Nitro"
    ],
    "Ford": [
      "Crown Victoria",
      "E-150",
      "E-250",
      "E-350 Super Duty",
      "E-450 Super Duty",
      "Ecosport",
      "Edge",
      "Escape",
      "Expedition",
      "Explorer",
      "F-150",
      "F-250 Super Duty",
      "F-350 Super Duty",
      "F-450 Super Duty",
      "F-550 Super Duty",
      "Fiesta",
      "Flex",
      "Focus",
      "Fusion",
      "Mustang",
      "Ranger",
      "Taurus",
      "Transit Connect"
    ],
    "GMC": [
      "Acadia",
      "Canyon",
      "Savana 1500",
      "Savana 2500",
      "Savana 3500",
      "Sierra 1500",
      "Sierra 2500 HD",
      "Sierra 3500 HD",
      "Terrain",
      "Yukon",
      "Yukon XL 1500",
      "Yukon XL 2500"
    ],
    "Honda": [
      "Accord",
      "Accord Crosstour",
      "Civic",
      "CR-V",
      "CR-Z",
      "Element",
      "Fit",
      "Insight",
      "Odyssey",
      "Pilot",
      "Ridgeline"
    ],
    "Hyundai": [
      "Accent",
      "Azera",
      "Elantra",
      "Equus",
      "Genesis",
      "Genesis Coupe",
      "Santa Fe",
      "Sonata",
      "Tucson",
      "Veracruz"
    ],
    "INFINITI": [
      "EX35",
      "FX35",
      "FX50",
      "G25",
      "G37",
      "M37",
      "M56",
      "QX56"
    ],
    "Jaguar": [
      "XF",
      "XFR",
      "XJ",
      "XJR",
      "XK",
      "XKR"
    ],
    "Jeep": [
      "Compass",
      "Grand Cherokee",
      "Liberty",
      "Patriot",
      "Wrangler"
    ],
    "Kia": [
      "Borrego",
      "Forte",
      "Forte Koup",
      "Optima",
      "Rio",
      "Rio5",
      "Rondo",
      "Sedona",
      "Sorento",
      "Soul",
      "Sportage"
    ],
    "Land Rover": [
      "LR2",
      "LR4",
      "Range Rover",
      "Range Rover Sport"
    ],
    "Lexus": [
      "CT200h",
      "ES350",
      "GS350",
      "GS450h",
      "GX460",
      "HS250h",
      "IS F",
      "IS250",
      "IS350",
      "LS460",
      "LS600h",
      "LX570",
      "RX350",
      "RX450h"
    ],
    "Lincoln": [
      "MKS",
      "MKT",
      "MKX",
      "MKZ",
      "Navigator",
      "Town Car"
    ],
    "Lotus": [
      "Elise"
    ],
    "Mazda": [
      "2",
      "3",
      "5",
      "6",
      "CX-7",
      "CX-9",
      "MX-5 Miata",
      "RX-8",
      "Tribute"
    ],
    "Mercedes-Benz": [
      "B200",
      "C250",
      "C300",
      "C350",
      "C63 AMG",
      "CL550",
      "CL600",
      "CL63 AMG",
      "CL65 AMG",
      "CLS550",
      "CLS63 AMG",
      "E300",
      "E350",
      "E550",
      "E63 AMG",
      "G55 AMG",
      "G550",
      "GL350",
      "GL450",
      "GL550",
      "GLK350",
      "ML350",
      "ML550",
      "ML63 AMG",
      "R350",
      "S350",
      "S400",
      "S450",
      "S550",
      "S600",
      "S63 AMG",
      "S65 AMG",
      "SL550",
      "SL63 AMG",
      "SL65 AMG",
      "SLK300",
      "SLK350",
      "SLK55 AMG",
      "SLS AMG",
      "Sprinter 2500",
      "Sprinter 3500"
    ],
    "Mercury": [
      "Grand Marquis",
      "Mariner",
      "Milan"
    ],
    "Mini": [
      "Cooper",
      "Cooper Countryman"
    ],
    "Mitsubishi": [
      "Eclipse",
      "Endeavor",
      "Galant",
      "Lancer",
      "Mirage",
      "Outlander",
      "Outlander Sport"
    ],
    "Nissan": [
      "370Z",
      "Altima",
      "Armada",
      "Cube",
      "Frontier",
      "GT-R",
      "Juke",
      "LEAF",
      "Maxima",
      "Murano",
      "Pathfinder",
      "Quest",
      "Rogue",
      "Sentra",
      "TITAN",
      "Versa",
      "Xterra"
    ],
    "Porsche": [
      "911",
      "Boxster",
      "Cayenne",
      "Cayman",
      "Panamera"
    ],
    "Ram": [
      "1500",
      "2500",
      "3500",
      "Dakota"
    ],
    "Saab": [
      "9-3",
      "9-3X",
      "9-4X",
      "9-5"
    ],
    "Scion": [
      "tC",
      "xB",
      "xD"
    ],
    "Smart": [
      "Fortwo"
    ],
    "Subaru": [
      "Forester",
      "Impreza",
      "Legacy",
      "Outback",
      "Tribeca"
    ],
    "Suzuki": [
      "Equator",
      "Grand Vitara",
      "Kizashi",
      "SX4"
    ],
    "Toyota": [
      "4Runner",
      "Avalon",
      "Camry",
      "Corolla",
      "FJ Cruiser",
      "Highlander",
      "Land Cruiser",
      "Matrix",
      "Prius",
      "RAV4",
      "Sequoia",
      "Sienna",
      "Tacoma",
      "Tundra",
      "Venza",
      "Yaris"
    ],
    "Volkswagen": [
      "Beetle",
      "CC",
      "Eos",
      "Golf",
      "GTI",
      "Jetta",
      "Passat",
      "Routan",
      "Tiguan",
      "Touareg"
    ],
    "Volvo": [
      "C30",
      "C70",
      "S40",
      "S60",
      "S80",
      "V50",
      "XC60",
      "XC70",
      "XC90"
    ]
  },
  "2012": {
    "Acura": [
      "MDX",
      "RDX",
      "RL",
      "TL",
      "TSX",
      "ZDX"
    ],
    "Audi": [
      "A3",
      "A3 Quattro",
      "A4",
      "A4 Quattro",
      "A5",
      "A5 Quattro",
      "A6 Quattro",
      "A7 Quattro",
      "A8 Quattro",
      "Q5",
      "Q7",
      "R8",
      "S4",
      "S5",
      "TT Quattro",
      "TTS Quattro"
    ],
    "BMW": [
      "128i",
      "135i",
      "320i",
      "328i",
      "328i xDrive",
      "330i",
      "335i",
      "335i xDrive",
      "335is",
      "528i",
      "528i xDrive",
      "535i",
      "535i GT",
      "535i GT xDrive",
      "535i xDrive",
      "550i",
      "550i GT xDrive",
      "550i xDrive",
      "640i",
      "650i",
      "650i xDrive",
      "740i",
      "740Li",
      "750i",
      "750i xDrive",
      "750Li",
      "750Li xDrive",
      "760Li",
      "Alpina B7",
      "M3",
      "M5",
      "M6",
      "X1",
      "X3",
      "X5",
      "X6",
      "Z4"
    ],
    "Buick": [
      "Enclave",
      "LaCrosse",
      "Regal",
      "Verano"
    ],
    "Cadillac": [
      "CTS",
      "Escalade",
      "Escalade ESV",
      "Escalade EXT",
      "SRX"
    ],
    "Chevrolet": [
      "Avalanche",
      "Camaro",
      "Caprice",
      "Captiva Sport",
      "Colorado",
      "Corvette",
      "Cruze",
      "Equinox",
      "Express 1500",
      "Express 2500",
      "Express 3500",
      "Express 4500",
      "Impala",
      "Malibu",
      "Orlando",
      "Silverado 1500",
      "Silverado 2500 HD",
      "Silverado 3500",
      "Silverado 3500 HD",
      "Sonic",
      "Suburban 1500",
      "Suburban 2500",
      "Tahoe",
      "Traverse",
      "Volt"
    ],
    "Chrysler": [
      "200",
      "300",
      "Town & Country"
    ],
    "Dodge": [
      "Avenger",
      "Caliber",
      "Challenger",
      "Charger",
      "Durango",
      "Grand Caravan",
      "Journey"
    ],
    "Fiat": [
      "500"
    ],
    "Ford": [
      "E-150",
      "E-250",
      "E-350 Super Duty",
      "E-450 Super Duty",
      "Ecosport",
      "Edge",
      "Escape",
      "Expedition",
      "Explorer",
      "F-150",
      "F-250 Super Duty",
      "F-350 Super Duty",
      "F-450 Super Duty",
      "F-550 Super Duty",
      "Fiesta",
      "Flex",
      "Focus",
      "Fusion",
      "Mustang",
      "Taurus",
      "Transit Connect"
    ],
    "GMC": [
      "Acadia",
      "Canyon",
      "Savana 1500",
      "Savana 2500",
      "Savana 3500",
      "Sierra 1500",
      "Sierra 2500 HD",
      "Sierra 3500 HD",
      "Terrain",
      "Yukon",
      "Yukon XL 1500",
      "Yukon XL 2500"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "CR-V",
      "CR-Z",
      "Crosstour",
      "Fit",
      "Insight",
      "Odyssey",
      "Pilot",
      "Ridgeline"
    ],
    "Hyundai": [
      "Accent",
      "Azera",
      "Elantra",
      "Equus",
      "Genesis",
      "Genesis Coupe",
      "Santa Fe",
      "Sonata",
      "Tucson",
      "Veloster",
      "Veracruz"
    ],
    "INFINITI": [
      "EX35",
      "FX35",
      "FX50",
      "G25",
      "G37",
      "M35h",
      "M37",
      "M56",
      "QX56"
    ],
    "Jaguar": [
      "XF",
      "XFR",
      "XJ",
      "XJR",
      "XK",
      "XKR",
      "XKR-S"
    ],
    "Jeep": [
      "Compass",
      "Grand Cherokee",
      "Liberty",
      "Patriot",
      "Wrangler"
    ],
    "Kia": [
      "Forte",
      "Forte Koup",
      "Optima",
      "Rio",
      "Rondo",
      "Sedona",
      "Sorento",
      "Soul",
      "Sportage"
    ],
    "Land Rover": [
      "LR2",
      "LR4",
      "Range Rover",
      "Range Rover Evoque",
      "Range Rover Sport"
    ],
    "Lexus": [
      "CT200h",
      "ES350",
      "GS350",
      "GS450h",
      "GX460",
      "IS F",
      "IS250",
      "IS350",
      "LFA",
      "LS460",
      "LS600h",
      "LX570",
      "RX350",
      "RX450h"
    ],
    "Lincoln": [
      "MKS",
      "MKT",
      "MKX",
      "MKZ",
      "Navigator"
    ],
    "Mazda": [
      "2",
      "3",
      "5",
      "6",
      "CX-7",
      "CX-9",
      "MX-5 Miata"
    ],
    "Mercedes-Benz": [
      "C250",
      "C300",
      "C350",
      "C63 AMG",
      "CL550",
      "CL600",
      "CL63 AMG",
      "CLS550",
      "CLS63 AMG",
      "E300",
      "E350",
      "E550",
      "E63 AMG",
      "G550",
      "GL350",
      "GL450",
      "GL550",
      "GLK350",
      "ML350",
      "ML550",
      "ML63 AMG",
      "R350",
      "S350",
      "S400",
      "S450",
      "S550",
      "S600",
      "S63 AMG",
      "S65 AMG",
      "SL550",
      "SL63 AMG",
      "SL65 AMG",
      "SLK250",
      "SLK300",
      "SLK350",
      "SLK55 AMG",
      "SLS AMG",
      "Sprinter 2500",
      "Sprinter 3500"
    ],
    "Mini": [
      "Cooper",
      "Cooper Countryman"
    ],
    "Mitsubishi": [
      "Eclipse",
      "Galant",
      "i-MiEV",
      "Lancer",
      "Mirage",
      "Outlander",
      "Outlander Sport",
      "RVR"
    ],
    "Nissan": [
      "370Z",
      "Altima",
      "Armada",
      "Cube",
      "Frontier",
      "GT-R",
      "Juke",
      "LEAF",
      "Maxima",
      "Murano",
      "NV2500",
      "NV3500",
      "Pathfinder",
      "Quest",
      "Rogue",
      "Sentra",
      "TITAN",
      "Versa",
      "Xterra"
    ],
    "Porsche": [
      "911",
      "Boxster",
      "Cayenne",
      "Cayman",
      "Panamera"
    ],
    "Ram": [
      "1500",
      "2500",
      "3500",
      "C/V"
    ],
    "Rolls Royce": [
      "Ghost"
    ],
    "Scion": [
      "iQ",
      "tC",
      "xB",
      "xD"
    ],
    "Smart": [
      "Fortwo"
    ],
    "Subaru": [
      "Forester",
      "Impreza",
      "Legacy",
      "Outback",
      "Tribeca"
    ],
    "Suzuki": [
      "Equator",
      "Grand Vitara",
      "Kizashi",
      "SX4",
      "SX4 Crossover"
    ],
    "Tesla": [
      "S"
    ],
    "Toyota": [
      "4Runner",
      "Avalon",
      "Camry",
      "Corolla",
      "FJ Cruiser",
      "Highlander",
      "Land Cruiser",
      "Matrix",
      "Prius",
      "Prius C",
      "Prius Plug-In",
      "Prius V",
      "RAV4",
      "Sequoia",
      "Sienna",
      "Tacoma",
      "Tundra",
      "Venza",
      "Yaris"
    ],
    "Volkswagen": [
      "Beetle",
      "CC",
      "Eos",
      "Golf",
      "Golf R",
      "GTI",
      "Jetta",
      "Passat",
      "Routan",
      "Tiguan",
      "Touareg"
    ],
    "Volvo": [
      "C30",
      "C70",
      "S60",
      "S80",
      "XC60",
      "XC70",
      "XC90"
    ]
  },
  "2013": {
    "Acura": [
      "ILX",
      "MDX",
      "RDX",
      "TL",
      "TSX",
      "ZDX"
    ],
    "Audi": [
      "A3",
      "A3 Quattro",
      "A4",
      "A4 Quattro",
      "A5",
      "A5 Quattro",
      "A6",
      "A6 Quattro",
      "A7 Quattro",
      "A8 Quattro",
      "allroad",
      "Q5",
      "Q7",
      "R8",
      "RS5",
      "S4",
      "S5",
      "S6",
      "S7",
      "S8",
      "TT Quattro",
      "TT RS Quattro",
      "TTS Quattro"
    ],
    "BMW": [
      "128i",
      "135i",
      "135is",
      "320i",
      "320i xDrive",
      "328i",
      "328i xDrive",
      "330i",
      "335i",
      "335i xDrive",
      "335is",
      "528i",
      "528i xDrive",
      "535i",
      "535i GT",
      "535i GT xDrive",
      "535i xDrive",
      "550i",
      "550i GT xDrive",
      "550i xDrive",
      "640i",
      "650i",
      "650i xDrive",
      "740i",
      "740Li",
      "740Li xDrive",
      "750i",
      "750i xDrive",
      "750Li",
      "750Li xDrive",
      "760Li",
      "ActiveHybrid 3",
      "ActiveHybrid 5",
      "Alpina B7",
      "M3",
      "M5",
      "M6",
      "X1",
      "X3",
      "X5",
      "X6",
      "Z4"
    ],
    "Buick": [
      "Enclave",
      "Encore",
      "LaCrosse",
      "Regal",
      "Verano"
    ],
    "Cadillac": [
      "ATS",
      "CTS",
      "Escalade",
      "Escalade ESV",
      "Escalade EXT",
      "SRX",
      "XTS"
    ],
    "Chevrolet": [
      "Avalanche",
      "Camaro",
      "Caprice",
      "Captiva Sport",
      "Colorado",
      "Corvette",
      "Cruze",
      "Equinox",
      "Express 1500",
      "Express 2500",
      "Express 3500",
      "Impala",
      "Malibu",
      "Orlando",
      "Silverado 1500",
      "Silverado 2500 HD",
      "Silverado 3500",
      "Silverado 3500 HD",
      "Sonic",
      "Spark",
      "Suburban 1500",
      "Suburban 2500",
      "Tahoe",
      "Traverse",
      "Trax",
      "Volt"
    ],
    "Chrysler": [
      "200",
      "300",
      "Town & Country"
    ],
    "Dodge": [
      "Avenger",
      "Challenger",
      "Charger",
      "Dart",
      "Durango",
      "Grand Caravan",
      "Journey"
    ],
    "Fiat": [
      "500"
    ],
    "Ford": [
      "C-Max",
      "E-150",
      "E-250",
      "E-350 Super Duty",
      "E-450 Super Duty",
      "Ecosport",
      "Edge",
      "Escape",
      "Expedition",
      "Explorer",
      "F-150",
      "F-250 Super Duty",
      "F-350 Super Duty",
      "F-450 Super Duty",
      "F-550 Super Duty",
      "Fiesta",
      "Flex",
      "Focus",
      "Fusion",
      "Mustang",
      "Police Interceptor Sedan",
      "Police Interceptor Utility",
      "Taurus",
      "Transit Connect"
    ],
    "GMC": [
      "Acadia",
      "Canyon",
      "Savana 1500",
      "Savana 2500",
      "Savana 3500",
      "Sierra 1500",
      "Sierra 2500 HD",
      "Sierra 3500 HD",
      "Terrain",
      "Yukon",
      "Yukon XL 1500",
      "Yukon XL 2500"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "CR-V",
      "CR-Z",
      "Crosstour",
      "Fit",
      "Insight",
      "Odyssey",
      "Pilot",
      "Ridgeline"
    ],
    "Hyundai": [
      "Accent",
      "Azera",
      "Elantra",
      "Elantra Coupe",
      "Elantra GT",
      "Equus",
      "Genesis",
      "Genesis Coupe",
      "Santa Fe",
      "Santa Fe XL",
      "Santa Fe Sport",
      "Sonata",
      "Tucson",
      "Veloster"
    ],
    "INFINITI": [
      "EX37",
      "FX37",
      "FX50",
      "G37",
      "JX35",
      "M35h",
      "M37",
      "M56",
      "QX56"
    ],
    "Jaguar": [
      "XF",
      "XFR",
      "XFR-S",
      "XJ",
      "XJR",
      "XK",
      "XKR",
      "XKR-S"
    ],
    "Jeep": [
      "Compass",
      "Grand Cherokee",
      "Patriot",
      "Wrangler"
    ],
    "Kia": [
      "Forte",
      "Forte Koup",
      "Forte5",
      "Optima",
      "Rio",
      "Rondo",
      "Sedona",
      "Sorento",
      "Soul",
      "Sportage"
    ],
    "Land Rover": [
      "LR2",
      "LR4",
      "Range Rover",
      "Range Rover Evoque",
      "Range Rover Sport"
    ],
    "Lexus": [
      "CT200h",
      "ES300h",
      "ES350",
      "GS350",
      "GS450h",
      "GX460",
      "IS F",
      "IS250",
      "IS350",
      "LS460",
      "LS600h",
      "LX570",
      "RX350",
      "RX450h"
    ],
    "Lincoln": [
      "MKS",
      "MKT",
      "MKX",
      "MKZ",
      "Navigator"
    ],
    "Mazda": [
      "2",
      "3",
      "5",
      "6",
      "CX-5",
      "CX-9",
      "MX-5 Miata"
    ],
    "Mercedes-Benz": [
      "B250",
      "C250",
      "C300",
      "C350",
      "C63 AMG",
      "CL550",
      "CL600",
      "CL63 AMG",
      "CLS550",
      "CLS63 AMG",
      "E300",
      "E350",
      "E400",
      "E550",
      "E63 AMG",
      "G550",
      "G63 AMG",
      "GL350",
      "GL450",
      "GL550",
      "GL63 AMG",
      "GLK250",
      "GLK350",
      "ML350",
      "ML550",
      "ML63 AMG",
      "R350",
      "S350",
      "S400",
      "S450",
      "S550",
      "S600",
      "S63 AMG",
      "S65 AMG",
      "SL550",
      "SL63 AMG",
      "SL65 AMG",
      "SLK250",
      "SLK300",
      "SLK350",
      "SLK55 AMG",
      "SLS AMG",
      "Sprinter 2500",
      "Sprinter 3500"
    ],
    "Mini": [
      "Cooper",
      "Cooper Countryman",
      "Cooper Paceman"
    ],
    "Mitsubishi": [
      "i-MiEV",
      "Lancer",
      "Mirage",
      "Outlander",
      "Outlander Sport",
      "RVR"
    ],
    "Nissan": [
      "370Z",
      "Altima",
      "Armada",
      "Cube",
      "Frontier",
      "GT-R",
      "Juke",
      "LEAF",
      "Maxima",
      "Murano",
      "NV1500",
      "NV200",
      "NV2500",
      "NV3500",
      "Pathfinder",
      "Quest",
      "Rogue",
      "Sentra",
      "TITAN",
      "Versa",
      "Xterra"
    ],
    "Porsche": [
      "911",
      "Boxster",
      "Cayenne",
      "Panamera"
    ],
    "Ram": [
      "1500",
      "2500",
      "3500",
      "C/V"
    ],
    "Scion": [
      "FR-S",
      "iQ",
      "tC",
      "xB",
      "xD"
    ],
    "Smart": [
      "Fortwo"
    ],
    "Subaru": [
      "BRZ",
      "Forester",
      "Impreza",
      "Legacy",
      "Outback",
      "Tribeca",
      "XV Crosstrek"
    ],
    "Suzuki": [
      "Grand Vitara",
      "Kizashi",
      "SX4"
    ],
    "Tesla": [
      "S"
    ],
    "Toyota": [
      "4Runner",
      "Avalon",
      "Camry",
      "Corolla",
      "FJ Cruiser",
      "Highlander",
      "Land Cruiser",
      "Matrix",
      "Prius",
      "Prius C",
      "Prius Plug-In",
      "Prius V",
      "RAV4",
      "Sequoia",
      "Sienna",
      "Tacoma",
      "Tundra",
      "Venza",
      "Yaris"
    ],
    "Volkswagen": [
      "Beetle",
      "CC",
      "Eos",
      "Golf",
      "Golf R",
      "GTI",
      "Jetta",
      "Passat",
      "Routan",
      "Tiguan",
      "Touareg"
    ],
    "Volvo": [
      "C30",
      "C70",
      "S60",
      "S80",
      "XC60",
      "XC70",
      "XC90"
    ]
  },
  "2014": {
    "Acura": [
      "ILX",
      "MDX",
      "RDX",
      "RLX",
      "TL",
      "TSX"
    ],
    "Audi": [
      "A3",
      "A3 Quattro",
      "A4",
      "A4 Quattro",
      "A5 Quattro",
      "A6",
      "A6 Quattro",
      "A7 Quattro",
      "A8 Quattro",
      "allroad",
      "Q3 Quattro",
      "Q5",
      "Q7",
      "R8",
      "RS5",
      "RS7",
      "S4",
      "S5",
      "S6",
      "S7",
      "S8",
      "SQ5",
      "TT Quattro",
      "TTS Quattro"
    ],
    "BMW": [
      "228i",
      "320i",
      "320i xDrive",
      "328d",
      "328d xDrive",
      "328i",
      "328i GT xDrive",
      "328i xDrive",
      "330i",
      "335i",
      "335i GT xDrive",
      "335i xDrive",
      "428i",
      "428i xDrive",
      "435i",
      "435i xDrive",
      "528i",
      "528i xDrive",
      "535d",
      "535d xDrive",
      "535i",
      "535i GT",
      "535i GT xDrive",
      "535i xDrive",
      "550i",
      "550i GT xDrive",
      "550i xDrive",
      "640i xDrive",
      "640i xDrive Gran Coupe",
      "650i",
      "650i Gran Coupe",
      "650i xDrive",
      "650i xDrive Gran Coupe",
      "740i",
      "740Li",
      "740Li xDrive",
      "750i",
      "750i xDrive",
      "750Li",
      "750Li xDrive",
      "760Li",
      "ActiveHybrid 3",
      "ActiveHybrid 5",
      "Alpina B7",
      "i3",
      "i8",
      "M235i",
      "M3",
      "M5",
      "M6",
      "M6 Gran Coupe",
      "X1",
      "X3",
      "X5",
      "X6",
      "Z4"
    ],
    "Buick": [
      "Enclave",
      "Encore",
      "LaCrosse",
      "Regal",
      "Verano"
    ],
    "Cadillac": [
      "ATS",
      "CTS",
      "ELR",
      "Escalade",
      "Escalade ESV",
      "SRX",
      "XTS"
    ],
    "Chevrolet": [
      "Camaro",
      "Caprice",
      "Captiva Sport",
      "Colorado",
      "Corvette",
      "Cruze",
      "Equinox",
      "Express 1500",
      "Express 2500",
      "Express 3500",
      "Impala",
      "Impala Limited",
      "Malibu",
      "Orlando",
      "Silverado 1500",
      "Silverado 2500 HD",
      "Silverado 3500 HD",
      "Sonic",
      "Spark",
      "Spark EV",
      "SS",
      "Suburban 1500",
      "Tahoe",
      "Traverse",
      "Trax",
      "Volt"
    ],
    "Chrysler": [
      "200",
      "300",
      "Town & Country"
    ],
    "Dodge": [
      "Avenger",
      "Challenger",
      "Charger",
      "Dart",
      "Durango",
      "Grand Caravan",
      "Journey"
    ],
    "Fiat": [
      "500",
      "500L"
    ],
    "Ford": [
      "C-Max",
      "E-150",
      "E-250",
      "E-350 Super Duty",
      "E-450 Super Duty",
      "Ecosport",
      "Edge",
      "Escape",
      "Expedition",
      "Explorer",
      "F-150",
      "F-250 Super Duty",
      "F-350 Super Duty",
      "F-450 Super Duty",
      "F-550 Super Duty",
      "Fiesta",
      "Flex",
      "Focus",
      "Fusion",
      "Mustang",
      "Police Interceptor Sedan",
      "Police Interceptor Utility",
      "Special Service Police Sedan",
      "Taurus",
      "Transit Connect"
    ],
    "GMC": [
      "Acadia",
      "Canyon",
      "Savana 1500",
      "Savana 2500",
      "Savana 3500",
      "Sierra 1500",
      "Sierra 2500 HD",
      "Sierra 3500 HD",
      "Terrain",
      "Yukon",
      "Yukon XL 1500"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "CR-V",
      "CR-Z",
      "Crosstour",
      "Fit",
      "Insight",
      "Odyssey",
      "Pilot",
      "Ridgeline"
    ],
    "Hyundai": [
      "Accent",
      "Azera",
      "Elantra",
      "Elantra Coupe",
      "Elantra GT",
      "Equus",
      "Genesis",
      "Genesis Coupe",
      "Santa Fe",
      "Santa Fe XL",
      "Santa Fe Sport",
      "Sonata",
      "Tucson",
      "Veloster"
    ],
    "INFINITI": [
      "Q50",
      "Q60",
      "Q70",
      "QX50",
      "QX60",
      "QX70",
      "QX80"
    ],
    "Jaguar": [
      "F-Type",
      "XF",
      "XFR",
      "XFR-S",
      "XJ",
      "XJR",
      "XK",
      "XKR",
      "XKR-S"
    ],
    "Jeep": [
      "Cherokee",
      "Compass",
      "Grand Cherokee",
      "Patriot",
      "Wrangler"
    ],
    "Kia": [
      "Cadenza",
      "Forte",
      "Forte Koup",
      "Forte5",
      "Optima",
      "Rio",
      "Rondo",
      "Sedona",
      "Sorento",
      "Soul",
      "Sportage"
    ],
    "Land Rover": [
      "Discovery",
      "LR2",
      "LR4",
      "Range Rover",
      "Range Rover Evoque",
      "Range Rover Sport"
    ],
    "Lexus": [
      "CT200h",
      "ES300h",
      "ES350",
      "GS350",
      "GS450h",
      "GX460",
      "IS F",
      "IS250",
      "IS350",
      "LS460",
      "LS600h",
      "LX570",
      "RX350",
      "RX450h"
    ],
    "Lincoln": [
      "MKS",
      "MKT",
      "MKX",
      "MKZ",
      "Navigator"
    ],
    "Mazda": [
      "2",
      "3",
      "5",
      "6",
      "CX-5",
      "CX-9",
      "MX-5 Miata"
    ],
    "Mercedes-Benz": [
      "B Electric Drive",
      "B250",
      "C250",
      "C300",
      "C350",
      "C63 AMG",
      "CL550",
      "CLA250",
      "CLA45 AMG",
      "CLS550",
      "CLS63 AMG",
      "CLS63 AMG S",
      "E250",
      "E300",
      "E350",
      "E400",
      "E550",
      "E63 AMG",
      "E63 AMG S",
      "G550",
      "G63 AMG",
      "GL350",
      "GL450",
      "GL550",
      "GL63 AMG",
      "GLK250",
      "GLK350",
      "ML350",
      "ML550",
      "ML63 AMG",
      "S450",
      "S550",
      "S600",
      "S63 AMG",
      "S65 AMG",
      "SL550",
      "SL63 AMG",
      "SL65 AMG",
      "SLK250",
      "SLK300",
      "SLK350",
      "SLK55 AMG",
      "SLS AMG",
      "Sprinter 2500",
      "Sprinter 3500"
    ],
    "Mini": [
      "Cooper",
      "Cooper Countryman",
      "Cooper Paceman"
    ],
    "Mitsubishi": [
      "i-MiEV",
      "Lancer",
      "Mirage",
      "Outlander",
      "Outlander Sport",
      "RVR"
    ],
    "Nissan": [
      "370Z",
      "Altima",
      "Armada",
      "Cube",
      "Frontier",
      "GT-R",
      "Juke",
      "LEAF",
      "Maxima",
      "Murano",
      "NV1500",
      "NV200",
      "NV2500",
      "NV3500",
      "Pathfinder",
      "Quest",
      "Rogue",
      "Rogue Select",
      "Sentra",
      "TITAN",
      "Versa",
      "Versa Note",
      "Xterra"
    ],
    "Porsche": [
      "911",
      "Boxster",
      "Cayenne",
      "Cayman",
      "Panamera"
    ],
    "Ram": [
      "1500",
      "2500",
      "3500",
      "C/V",
      "ProMaster 1500",
      "ProMaster 2500",
      "ProMaster 3500"
    ],
    "Rolls Royce": [
      "Ghost",
      "Wraith"
    ],
    "Scion": [
      "FR-S",
      "iQ",
      "tC",
      "xB",
      "xD"
    ],
    "Smart": [
      "Fortwo"
    ],
    "Subaru": [
      "BRZ",
      "Forester",
      "Impreza",
      "Legacy",
      "Outback",
      "Tribeca",
      "XV Crosstrek"
    ],
    "Tesla": [
      "S"
    ],
    "Toyota": [
      "4Runner",
      "Avalon",
      "Camry",
      "Corolla",
      "FJ Cruiser",
      "Highlander",
      "Land Cruiser",
      "Matrix",
      "Prius",
      "Prius C",
      "Prius Plug-In",
      "Prius V",
      "RAV4",
      "Sequoia",
      "Sienna",
      "Tacoma",
      "Tundra",
      "Venza",
      "Yaris"
    ],
    "Volkswagen": [
      "Beetle",
      "CC",
      "Eos",
      "Golf",
      "Golf R",
      "GTI",
      "Jetta",
      "Passat",
      "Routan",
      "Tiguan",
      "Touareg"
    ],
    "Volvo": [
      "S60",
      "S80",
      "XC60",
      "XC70",
      "XC90"
    ]
  },
  "2015": {
    "Acura": [
      "ILX",
      "MDX",
      "RDX",
      "RLX",
      "TLX"
    ],
    "Audi": [
      "A3",
      "A3 Quattro",
      "A4",
      "A4 Quattro",
      "A5 Quattro",
      "A6",
      "A6 Quattro",
      "A7 Quattro",
      "A8 Quattro",
      "allroad",
      "Q3",
      "Q3 Quattro",
      "Q5",
      "Q7",
      "R8",
      "RS5",
      "RS7",
      "S3",
      "S4",
      "S5",
      "S6",
      "S7",
      "S8",
      "SQ5",
      "TT Quattro",
      "TTS Quattro"
    ],
    "BMW": [
      "228i",
      "228i xDrive",
      "320i",
      "320i xDrive",
      "328d",
      "328d xDrive",
      "328i",
      "328i GT xDrive",
      "328i xDrive",
      "330i",
      "335i",
      "335i GT xDrive",
      "335i xDrive",
      "428i",
      "428i Gran Coupe",
      "428i xDrive",
      "428i xDrive Gran Coupe",
      "435i",
      "435i Gran Coupe",
      "435i xDrive",
      "435i xDrive Gran Coupe",
      "528i",
      "528i xDrive",
      "535d",
      "535d xDrive",
      "535i",
      "535i GT xDrive",
      "535i xDrive",
      "550i",
      "550i GT xDrive",
      "550i xDrive",
      "640i xDrive",
      "640i xDrive Gran Coupe",
      "650i",
      "650i Gran Coupe",
      "650i xDrive",
      "650i xDrive Gran Coupe",
      "740i",
      "740Ld xDrive",
      "740Li",
      "740Li xDrive",
      "750i",
      "750i xDrive",
      "750Li",
      "750Li xDrive",
      "760Li",
      "ActiveHybrid 7",
      "Alpina B6 xDrive Gran Coupe",
      "Alpina B7",
      "i3",
      "i8",
      "M235i",
      "M235i xDrive",
      "M3",
      "M4",
      "M5",
      "M6",
      "M6 Gran Coupe",
      "X1",
      "X3",
      "X4",
      "X5",
      "X6",
      "Z4"
    ],
    "Buick": [
      "Enclave",
      "Encore",
      "LaCrosse",
      "Regal",
      "Verano"
    ],
    "Cadillac": [
      "ATS",
      "CTS",
      "ELR",
      "Escalade",
      "Escalade ESV",
      "SRX",
      "XTS"
    ],
    "Chevrolet": [
      "Camaro",
      "City Express",
      "Colorado",
      "Corvette",
      "Cruze",
      "Equinox",
      "Express 2500",
      "Express 3500",
      "Impala",
      "Impala Limited",
      "Malibu",
      "Silverado 1500",
      "Silverado 2500 HD",
      "Silverado 3500 HD",
      "Sonic",
      "Spark",
      "Spark EV",
      "SS",
      "Suburban",
      "Tahoe",
      "Traverse",
      "Trax",
      "Volt"
    ],
    "Chrysler": [
      "200",
      "300",
      "Town & Country"
    ],
    "Dodge": [
      "Challenger",
      "Charger",
      "Dart",
      "Durango",
      "Grand Caravan",
      "Journey"
    ],
    "Fiat": [
      "500",
      "500L"
    ],
    "Ford": [
      "C-Max",
      "E-350 Super Duty",
      "E-450 Super Duty",
      "Ecosport",
      "Edge",
      "Escape",
      "Expedition",
      "Explorer",
      "F-150",
      "F-250 Super Duty",
      "F-350 Super Duty",
      "F-450 Super Duty",
      "F-550 Super Duty",
      "Fiesta",
      "Flex",
      "Focus",
      "Fusion",
      "Mustang",
      "Police Interceptor Sedan",
      "Police Interceptor Utility",
      "Special Service Police Sedan",
      "Taurus",
      "Transit Connect",
      "Transit-150",
      "Transit-250",
      "Transit-350",
      "Transit-350 HD"
    ],
    "GMC": [
      "Acadia",
      "Canyon",
      "Savana 2500",
      "Savana 3500",
      "Sierra 1500",
      "Sierra 2500 HD",
      "Sierra 3500 HD",
      "Terrain",
      "Yukon",
      "Yukon XL"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "CR-V",
      "CR-Z",
      "Crosstour",
      "Fit",
      "Insight",
      "Odyssey",
      "Pilot",
      "Ridgeline"
    ],
    "Hyundai": [
      "Accent",
      "Azera",
      "Elantra",
      "Elantra GT",
      "Equus",
      "Genesis",
      "Genesis Coupe",
      "Santa Fe",
      "Santa Fe XL",
      "Santa Fe Sport",
      "Sonata",
      "Tucson",
      "Veloster"
    ],
    "INFINITI": [
      "Q40",
      "Q50",
      "Q60",
      "Q70",
      "Q70L",
      "QX50",
      "QX60",
      "QX70",
      "QX80"
    ],
    "Jaguar": [
      "F-Type",
      "XF",
      "XFR",
      "XFR-S",
      "XJ",
      "XJR",
      "XK",
      "XKR",
      "XKR-S"
    ],
    "Jeep": [
      "Cherokee",
      "Compass",
      "Grand Cherokee",
      "Patriot",
      "Renegade",
      "Wrangler"
    ],
    "Kia": [
      "Cadenza",
      "Forte",
      "Forte Koup",
      "Forte5",
      "K900",
      "Optima",
      "Rio",
      "Rondo",
      "Sedona",
      "Sorento",
      "Soul",
      "Soul EV",
      "Sportage"
    ],
    "Land Rover": [
      "Discovery",
      "Discovery Sport",
      "LR2",
      "LR4",
      "Range Rover",
      "Range Rover Evoque",
      "Range Rover Sport"
    ],
    "Lexus": [
      "CT200h",
      "ES300h",
      "ES350",
      "GS350",
      "GS450h",
      "GX460",
      "IS250",
      "IS350",
      "LS460",
      "LS600h",
      "LX570",
      "NX200t",
      "NX300h",
      "RC F",
      "RC350",
      "RX350",
      "RX450h"
    ],
    "Lincoln": [
      "MKC",
      "MKS",
      "MKT",
      "MKX",
      "MKZ",
      "Navigator"
    ],
    "Mazda": [
      "3",
      "3 Sport",
      "5",
      "6",
      "CX-5",
      "CX-9",
      "MX-5 Miata"
    ],
    "Mercedes-Benz": [
      "B Electric Drive",
      "B250",
      "C250",
      "C300",
      "C350",
      "C400",
      "C63 AMG",
      "C63 AMG S",
      "CLA250",
      "CLA45 AMG",
      "CLS400",
      "CLS550",
      "CLS63 AMG S",
      "E250",
      "E300",
      "E350",
      "E400",
      "E550",
      "E63 AMG S",
      "G550",
      "G63 AMG",
      "GL350",
      "GL450",
      "GL550",
      "GL63 AMG",
      "GLA250",
      "GLA45 AMG",
      "GLK250",
      "GLK350",
      "ML250",
      "ML350",
      "ML400",
      "ML550",
      "ML63 AMG",
      "S450",
      "S550",
      "S600",
      "S63 AMG",
      "S65 AMG",
      "SL400",
      "SL550",
      "SL63 AMG",
      "SL65 AMG",
      "SLK250",
      "SLK300",
      "SLK350",
      "SLK55 AMG",
      "SLS AMG",
      "Sprinter 2500",
      "Sprinter 3500"
    ],
    "Mini": [
      "Cooper",
      "Cooper Countryman",
      "Cooper Paceman"
    ],
    "Mitsubishi": [
      "i-MiEV",
      "Lancer",
      "Mirage",
      "Outlander",
      "Outlander Sport",
      "RVR"
    ],
    "Nissan": [
      "370Z",
      "Altima",
      "Armada",
      "Frontier",
      "GT-R",
      "Juke",
      "LEAF",
      "Maxima",
      "Micra",
      "Murano",
      "NV1500",
      "NV200",
      "NV2500",
      "NV3500",
      "Pathfinder",
      "Quest",
      "Rogue",
      "Rogue Select",
      "Sentra",
      "TITAN",
      "Versa",
      "Versa Note",
      "Xterra"
    ],
    "Porsche": [
      "911",
      "918 Spyder",
      "Boxster",
      "Cayenne",
      "Cayman",
      "Macan",
      "Panamera"
    ],
    "Ram": [
      "1500",
      "2500",
      "3500",
      "C/V",
      "ProMaster 1500",
      "ProMaster 2500",
      "ProMaster 3500",
      "ProMaster City"
    ],
    "Rolls Royce": [
      "Ghost",
      "Wraith"
    ],
    "Scion": [
      "FR-S",
      "iQ",
      "tC",
      "xB"
    ],
    "Smart": [
      "Fortwo"
    ],
    "Subaru": [
      "BRZ",
      "Forester",
      "Impreza",
      "Legacy",
      "Outback",
      "WRX",
      "WRX STI",
      "XV Crosstrek"
    ],
    "Tesla": [
      "S"
    ],
    "Toyota": [
      "4Runner",
      "Avalon",
      "Camry",
      "Corolla",
      "Highlander",
      "Land Cruiser",
      "Prius",
      "Prius C",
      "Prius Plug-In",
      "Prius V",
      "RAV4",
      "Sequoia",
      "Sienna",
      "Tacoma",
      "Tundra",
      "Venza",
      "Yaris"
    ],
    "Volkswagen": [
      "Beetle",
      "CC",
      "e-Golf",
      "Eos",
      "Golf",
      "Golf R",
      "Golf SportWagen",
      "GTI",
      "Jetta",
      "Passat",
      "Tiguan",
      "Touareg"
    ],
    "Volvo": [
      "S60",
      "S80",
      "V40",
      "V40 Cross Country",
      "V60",
      "V60 Cross Country",
      "XC60",
      "XC70"
    ]
  },
  "2016": {
    "Acura": [
      "ILX",
      "MDX",
      "RDX",
      "RLX",
      "TLX"
    ],
    "Audi": [
      "A3",
      "A3 Quattro",
      "A3 Sportback e-tron",
      "A4",
      "A4 allroad",
      "A4 Quattro",
      "A5 Quattro",
      "A6",
      "A6 Quattro",
      "A7 Quattro",
      "A8 Quattro",
      "allroad",
      "Q3",
      "Q3 Quattro",
      "Q5",
      "Q7",
      "R8",
      "RS5",
      "RS7",
      "S3",
      "S4",
      "S5",
      "S6",
      "S7",
      "S8",
      "SQ5",
      "TT Quattro",
      "TTS Quattro"
    ],
    "BMW": [
      "228i",
      "228i xDrive",
      "320i",
      "320i xDrive",
      "328d",
      "328d xDrive",
      "328i",
      "328i GT xDrive",
      "328i xDrive",
      "330e",
      "330i",
      "335i GT xDrive",
      "340i",
      "340i xDrive",
      "428i",
      "428i Gran Coupe",
      "428i xDrive",
      "428i xDrive Gran Coupe",
      "435i",
      "435i Gran Coupe",
      "435i xDrive",
      "435i xDrive Gran Coupe",
      "528i xDrive",
      "535d xDrive",
      "535i",
      "535i xDrive",
      "550i xDrive",
      "640i Gran Coupe",
      "640i xDrive",
      "640i xDrive Gran Coupe",
      "650i",
      "650i Gran Coupe",
      "650i xDrive",
      "650i xDrive Gran Coupe",
      "740i",
      "750i",
      "750i xDrive",
      "750Li xDrive",
      "Alpina B6 Gran Coupe",
      "Alpina B6 xDrive Gran Coupe",
      "Alpina B7",
      "i3",
      "i8",
      "M2",
      "M235i",
      "M235i xDrive",
      "M3",
      "M4",
      "M5",
      "M6",
      "M6 Gran Coupe",
      "X1",
      "X3",
      "X4",
      "X5",
      "X6",
      "Z4"
    ],
    "Buick": [
      "Cascada",
      "Enclave",
      "Encore",
      "Envision",
      "LaCrosse",
      "Regal",
      "Verano"
    ],
    "Cadillac": [
      "ATS",
      "CT6",
      "CTS",
      "ELR",
      "Escalade",
      "Escalade ESV",
      "SRX",
      "XTS"
    ],
    "Chevrolet": [
      "Camaro",
      "City Express",
      "Colorado",
      "Corvette",
      "Cruze",
      "Cruze Limited",
      "Equinox",
      "Express 2500",
      "Express 3500",
      "Impala",
      "Impala Limited",
      "Malibu",
      "Malibu Limited",
      "Silverado 1500",
      "Silverado 2500 HD",
      "Silverado 3500 HD",
      "Sonic",
      "Spark",
      "Spark EV",
      "SS",
      "Suburban",
      "Suburban 3500 HD",
      "Tahoe",
      "Traverse",
      "Trax",
      "Volt"
    ],
    "Chrysler": [
      "200",
      "300",
      "Town & Country"
    ],
    "Dodge": [
      "Challenger",
      "Charger",
      "Dart",
      "Durango",
      "Grand Caravan",
      "Journey"
    ],
    "Fiat": [
      "500",
      "500L",
      "500X"
    ],
    "Ford": [
      "C-Max",
      "E-350 Super Duty",
      "E-450 Super Duty",
      "Ecosport",
      "Edge",
      "Escape",
      "Expedition",
      "Explorer",
      "F-150",
      "F-250 Super Duty",
      "F-350 Super Duty",
      "F-450 Super Duty",
      "F-550 Super Duty",
      "Fiesta",
      "Flex",
      "Focus",
      "Fusion",
      "Mustang",
      "Police Interceptor Sedan",
      "Police Interceptor Utility",
      "Special Service Police Sedan",
      "Taurus",
      "Transit Connect",
      "Transit-150",
      "Transit-250",
      "Transit-350",
      "Transit-350 HD"
    ],
    "GMC": [
      "Acadia",
      "Canyon",
      "Savana 2500",
      "Savana 3500",
      "Sierra 1500",
      "Sierra 2500 HD",
      "Sierra 3500 HD",
      "Terrain",
      "Yukon",
      "Yukon XL"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "CR-V",
      "CR-Z",
      "Fit",
      "HR-V",
      "Insight",
      "Odyssey",
      "Pilot",
      "Ridgeline"
    ],
    "Hyundai": [
      "Accent",
      "Azera",
      "Elantra",
      "Elantra GT",
      "Equus",
      "Genesis",
      "Genesis Coupe",
      "Santa Fe",
      "Santa Fe XL",
      "Santa Fe Sport",
      "Sonata",
      "Tucson",
      "Veloster"
    ],
    "INFINITI": [
      "Q50",
      "Q60",
      "Q70",
      "Q70L",
      "QX50",
      "QX60",
      "QX70",
      "QX80"
    ],
    "Jaguar": [
      "F-Type",
      "XF",
      "XJ",
      "XJR"
    ],
    "Jeep": [
      "Cherokee",
      "Compass",
      "Grand Cherokee",
      "Patriot",
      "Renegade",
      "Wrangler"
    ],
    "Kia": [
      "Cadenza",
      "Forte",
      "Forte Koup",
      "Forte5",
      "K900",
      "Optima",
      "Rio",
      "Rondo",
      "Sedona",
      "Sorento",
      "Soul",
      "Soul EV",
      "Sportage"
    ],
    "Land Rover": [
      "Discovery Sport",
      "LR4",
      "Range Rover",
      "Range Rover Evoque",
      "Range Rover Sport"
    ],
    "Lexus": [
      "CT200h",
      "ES300h",
      "ES350",
      "GS F",
      "GS350",
      "GS450h",
      "GX460",
      "IS200t",
      "IS300",
      "IS350",
      "LS460",
      "LS600h",
      "LX570",
      "NX200t",
      "NX300h",
      "RC F",
      "RC300",
      "RC350",
      "RX350",
      "RX450h"
    ],
    "Lincoln": [
      "MKC",
      "MKS",
      "MKT",
      "MKX",
      "MKZ",
      "Navigator"
    ],
    "Mazda": [
      "3",
      "3 Sport",
      "5",
      "6",
      "CX-3",
      "CX-5",
      "CX-9",
      "MX-5 Miata"
    ],
    "Mercedes-Benz": [
      "AMG GT S",
      "B250",
      "B250e",
      "C300",
      "C450 AMG",
      "C63 AMG",
      "C63 AMG S",
      "CLA250",
      "CLA45 AMG",
      "CLS400",
      "CLS550",
      "CLS63 AMG S",
      "E250",
      "E300",
      "E350",
      "E400",
      "E550",
      "E63 AMG S",
      "G550",
      "G63 AMG",
      "G65 AMG",
      "GL350",
      "GL450",
      "GL550",
      "GL63 AMG",
      "GLA250",
      "GLA45 AMG",
      "GLC300",
      "GLE300d",
      "GLE350",
      "GLE400",
      "GLE450 AMG",
      "GLE550",
      "GLE63 AMG",
      "GLE63 AMG S",
      "Maybach S600",
      "Metris",
      "S450",
      "S550",
      "S550e",
      "S600",
      "S63 AMG",
      "S65 AMG",
      "SL400",
      "SL550",
      "SL63 AMG",
      "SL65 AMG",
      "SLK300",
      "SLK350",
      "SLK55 AMG",
      "Sprinter 2500",
      "Sprinter 3500"
    ],
    "Mini": [
      "Cooper",
      "Cooper Clubman",
      "Cooper Countryman",
      "Cooper Paceman"
    ],
    "Mitsubishi": [
      "i-MiEV",
      "Lancer",
      "Mirage",
      "Outlander",
      "Outlander Sport",
      "RVR"
    ],
    "Nissan": [
      "370Z",
      "Altima",
      "Armada",
      "Frontier",
      "GT-R",
      "Juke",
      "LEAF",
      "Maxima",
      "Micra",
      "Murano",
      "NV1500",
      "NV200",
      "NV2500",
      "NV3500",
      "Pathfinder",
      "Quest",
      "Rogue",
      "Sentra",
      "TITAN",
      "TITAN XD",
      "Versa",
      "Versa Note"
    ],
    "Porsche": [
      "911",
      "Boxster",
      "Cayenne",
      "Cayman",
      "Macan",
      "Panamera"
    ],
    "Ram": [
      "1500",
      "2500",
      "3500",
      "ProMaster 1500",
      "ProMaster 2500",
      "ProMaster 3500",
      "ProMaster City"
    ],
    "Rolls Royce": [
      "Dawn",
      "Ghost",
      "Wraith"
    ],
    "Scion": [
      "FR-S",
      "iA",
      "iM",
      "tC"
    ],
    "Smart": [
      "Fortwo"
    ],
    "Subaru": [
      "BRZ",
      "Crosstrek",
      "Forester",
      "Impreza",
      "Legacy",
      "Outback",
      "WRX",
      "WRX STI"
    ],
    "Tesla": [
      "S",
      "X"
    ],
    "Toyota": [
      "4Runner",
      "Avalon",
      "Camry",
      "Corolla",
      "Highlander",
      "Land Cruiser",
      "Mirai",
      "Prius",
      "Prius C",
      "Prius V",
      "RAV4",
      "Sequoia",
      "Sienna",
      "Tacoma",
      "Tundra",
      "Venza",
      "Yaris"
    ],
    "Volkswagen": [
      "Beetle",
      "CC",
      "e-Golf",
      "Eos",
      "Golf",
      "Golf R",
      "Golf SportWagen",
      "GTI",
      "Jetta",
      "Passat",
      "Tiguan",
      "Touareg"
    ],
    "Volvo": [
      "S60",
      "S60 Cross Country",
      "S80",
      "V40",
      "V40 Cross Country",
      "V60",
      "V60 Cross Country",
      "XC60",
      "XC70",
      "XC90"
    ]
  },
  "2017": {
    "Acura": [
      "ILX",
      "MDX",
      "NSX",
      "RDX",
      "RLX",
      "TLX"
    ],
    "Alfa Romeo": [
      "Giulia"
    ],
    "Audi": [
      "A3",
      "A3 Quattro",
      "A3 Sportback e-tron",
      "A4",
      "A4 allroad",
      "A4 Quattro",
      "A5 Quattro",
      "A6",
      "A6 Quattro",
      "A7 Quattro",
      "A8 Quattro",
      "Q3",
      "Q3 Quattro",
      "Q5",
      "Q7",
      "R8",
      "RS3",
      "RS5",
      "RS7",
      "S3",
      "S4",
      "S5",
      "S6",
      "S7",
      "S8",
      "SQ5",
      "TT Quattro",
      "TTS Quattro"
    ],
    "BMW": [
      "230i",
      "230i xDrive",
      "320i",
      "320i xDrive",
      "328d",
      "328d xDrive",
      "330e",
      "330i",
      "330i GT xDrive",
      "330i xDrive",
      "340i",
      "340i GT xDrive",
      "340i xDrive",
      "430i",
      "430i Gran Coupe",
      "430i xDrive",
      "430i xDrive Gran Coupe",
      "440i",
      "440i xDrive",
      "440i xDrive Gran Coupe",
      "530i",
      "530i xDrive",
      "540i",
      "540i xDrive",
      "640i xDrive",
      "640i xDrive Gran Coupe",
      "650i",
      "650i Gran Coupe",
      "650i xDrive",
      "650i xDrive Gran Coupe",
      "740e xDrive",
      "740i",
      "740i xDrive",
      "750i",
      "750i xDrive",
      "750Li xDrive",
      "Alpina B6 xDrive Gran Coupe",
      "Alpina B7",
      "i3",
      "i8",
      "M2",
      "M240i",
      "M240i xDrive",
      "M3",
      "M4",
      "M5",
      "M6",
      "M6 Gran Coupe",
      "X1",
      "X3",
      "X4",
      "X5",
      "X6"
    ],
    "Buick": [
      "Cascada",
      "Enclave",
      "Encore",
      "Envision",
      "LaCrosse",
      "Regal",
      "Verano"
    ],
    "Cadillac": [
      "ATS",
      "CT6",
      "CTS",
      "Escalade",
      "Escalade ESV",
      "XT5",
      "XTS"
    ],
    "Chevrolet": [
      "Bolt EV",
      "Camaro",
      "City Express",
      "Colorado",
      "Corvette",
      "Cruze",
      "Equinox",
      "Express 2500",
      "Express 3500",
      "Impala",
      "Malibu",
      "Silverado 1500",
      "Silverado 2500 HD",
      "Silverado 3500 HD",
      "Sonic",
      "Spark",
      "SS",
      "Suburban",
      "Suburban 3500 HD",
      "Tahoe",
      "Traverse",
      "Trax",
      "Volt"
    ],
    "Chrysler": [
      "200",
      "300",
      "Pacifica"
    ],
    "Dodge": [
      "Challenger",
      "Charger",
      "Durango",
      "Grand Caravan",
      "Journey"
    ],
    "Fiat": [
      "124 Spider",
      "500",
      "500L",
      "500X"
    ],
    "Ford": [
      "C-Max",
      "E-350 Super Duty",
      "E-450 Super Duty",
      "Ecosport",
      "Edge",
      "Escape",
      "Expedition",
      "Explorer",
      "F-150",
      "F-250 Super Duty",
      "F-350 Super Duty",
      "F-450 Super Duty",
      "F-53 Motorhome Chassis",
      "F-550 Super Duty",
      "Fiesta",
      "Flex",
      "Focus",
      "Fusion",
      "GT",
      "Mustang",
      "Police Interceptor Sedan",
      "Police Interceptor Utility",
      "Special Service Police Sedan",
      "Taurus",
      "Transit Connect",
      "Transit-150",
      "Transit-250",
      "Transit-350",
      "Transit-350 HD"
    ],
    "Genesis": [
      "G80",
      "G90"
    ],
    "GMC": [
      "Acadia",
      "Acadia Limited",
      "Canyon",
      "Savana 2500",
      "Savana 3500",
      "Sierra 1500",
      "Sierra 2500 HD",
      "Sierra 3500 HD",
      "Terrain",
      "Yukon",
      "Yukon XL"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "CR-V",
      "Fit",
      "HR-V",
      "Insight",
      "Odyssey",
      "Pilot",
      "Ridgeline"
    ],
    "Hyundai": [
      "Accent",
      "Elantra",
      "Elantra GT",
      "Ioniq",
      "Santa Fe",
      "Santa Fe XL",
      "Santa Fe Sport",
      "Sonata",
      "Tucson",
      "Veloster"
    ],
    "INFINITI": [
      "Q50",
      "Q60",
      "Q70",
      "Q70L",
      "QX30",
      "QX50",
      "QX60",
      "QX70",
      "QX80"
    ],
    "Jaguar": [
      "F-Pace",
      "F-Type",
      "XE",
      "XF",
      "XJ",
      "XJR"
    ],
    "Jeep": [
      "Cherokee",
      "Compass",
      "Grand Cherokee",
      "Patriot",
      "Renegade",
      "Wrangler"
    ],
    "Kia": [
      "Cadenza",
      "Forte",
      "Forte Koup",
      "Forte5",
      "K900",
      "Niro",
      "Optima",
      "Rio",
      "Rondo",
      "Sedona",
      "Sorento",
      "Soul",
      "Soul EV",
      "Sportage"
    ],
    "Land Rover": [
      "Discovery",
      "Discovery Sport",
      "Range Rover",
      "Range Rover Evoque",
      "Range Rover Sport"
    ],
    "Lexus": [
      "CT200h",
      "ES300h",
      "ES350",
      "GS F",
      "GS350",
      "GS450h",
      "GX460",
      "IS200t",
      "IS300",
      "IS350",
      "LS460",
      "LX570",
      "NX200t",
      "NX300h",
      "RC F",
      "RC200t",
      "RC300",
      "RC350",
      "RX350",
      "RX450h"
    ],
    "Lincoln": [
      "Continental",
      "MKC",
      "MKT",
      "MKX",
      "MKZ",
      "Navigator"
    ],
    "Mazda": [
      "3",
      "3 Sport",
      "5",
      "6",
      "CX-3",
      "CX-5",
      "CX-9",
      "MX-5 Miata"
    ],
    "Mercedes-Benz": [
      "AMG GT",
      "AMG GT S",
      "B250",
      "B250e",
      "C300",
      "C43 AMG",
      "C63 AMG",
      "C63 AMG S",
      "CLA250",
      "CLA45 AMG",
      "CLS550",
      "CLS63 AMG S",
      "E300",
      "E400",
      "E43 AMG",
      "E550",
      "E63 AMG S",
      "G550",
      "G550 4x4",
      "G63 AMG",
      "G65 AMG",
      "GLA250",
      "GLA45 AMG",
      "GLC300",
      "GLC43 AMG",
      "GLE350",
      "GLE400",
      "GLE43 AMG",
      "GLE550",
      "GLE550e",
      "GLE63 AMG S",
      "GLS450",
      "GLS550",
      "GLS63 AMG",
      "Maybach S600",
      "Metris",
      "S450",
      "S550",
      "S550e",
      "S600",
      "S63 AMG",
      "S65 AMG",
      "SL450",
      "SL550",
      "SL63 AMG",
      "SL65 AMG",
      "SLC300",
      "SLC43 AMG",
      "Sprinter 2500",
      "Sprinter 3500"
    ],
    "Mini": [
      "Cooper",
      "Cooper Clubman",
      "Cooper Countryman"
    ],
    "Mitsubishi": [
      "i-MiEV",
      "Lancer",
      "Mirage",
      "Mirage G4",
      "Outlander",
      "Outlander Sport",
      "RVR"
    ],
    "Nissan": [
      "370Z",
      "Altima",
      "Armada",
      "Frontier",
      "GT-R",
      "Juke",
      "Kicks",
      "LEAF",
      "Maxima",
      "Micra",
      "Murano",
      "NV1500",
      "NV200",
      "NV2500",
      "NV3500",
      "Pathfinder",
      "Qashqai",
      "Quest",
      "Rogue",
      "Rogue Sport",
      "Sentra",
      "TITAN",
      "TITAN XD",
      "Versa",
      "Versa Note"
    ],
    "Porsche": [
      "718 Boxster",
      "718 Cayman",
      "911",
      "Cayenne",
      "Macan",
      "Panamera"
    ],
    "Ram": [
      "1500",
      "2500",
      "3500",
      "ProMaster 1500",
      "ProMaster 2500",
      "ProMaster 3500",
      "ProMaster City"
    ],
    "Rolls Royce": [
      "Dawn",
      "Ghost",
      "Wraith"
    ],
    "Smart": [
      "Fortwo"
    ],
    "Subaru": [
      "BRZ",
      "Crosstrek",
      "Forester",
      "Impreza",
      "Legacy",
      "Outback",
      "WRX",
      "WRX STI"
    ],
    "Tesla": [
      "3",
      "S",
      "X"
    ],
    "Toyota": [
      "4Runner",
      "86",
      "Avalon",
      "Camry",
      "Corolla",
      "Corolla iM",
      "Highlander",
      "Land Cruiser",
      "Mirai",
      "Prius",
      "Prius C",
      "Prius Prime",
      "Prius V",
      "RAV4",
      "Sequoia",
      "Sienna",
      "Tacoma",
      "Tundra",
      "Yaris",
      "Yaris iA"
    ],
    "Volkswagen": [
      "Beetle",
      "CC",
      "e-Golf",
      "Golf",
      "Golf Alltrack",
      "Golf R",
      "Golf SportWagen",
      "GTI",
      "Jetta",
      "Passat",
      "Tiguan",
      "Touareg"
    ],
    "Volvo": [
      "S60",
      "S60 Cross Country",
      "S90",
      "V40",
      "V40 Cross Country",
      "V60",
      "V60 Cross Country",
      "V90 Cross Country",
      "XC60",
      "XC90"
    ]
  },
  "2018": {
    "Acura": [
      "ILX",
      "MDX",
      "NSX",
      "RDX",
      "RLX",
      "TLX"
    ],
    "Alfa Romeo": [
      "Giulia",
      "Stelvio"
    ],
    "Audi": [
      "A3",
      "A3 Quattro",
      "A3 Sportback e-tron",
      "A4",
      "A4 allroad",
      "A4 Quattro",
      "A5 Quattro",
      "A5 Sportback",
      "A6",
      "A6 Quattro",
      "A7 Quattro",
      "A8 Quattro",
      "Q3",
      "Q3 Quattro",
      "Q5",
      "Q7",
      "R8",
      "RS3",
      "RS5",
      "RS7",
      "S3",
      "S4",
      "S5",
      "S5 Sportback",
      "S6",
      "S7",
      "S8",
      "SQ5",
      "TT Quattro",
      "TT RS Quattro",
      "TTS Quattro"
    ],
    "BMW": [
      "230i",
      "230i xDrive",
      "320i",
      "320i xDrive",
      "328d",
      "328d xDrive",
      "330e",
      "330i",
      "330i GT xDrive",
      "330i xDrive",
      "340i",
      "340i GT xDrive",
      "340i xDrive",
      "430i",
      "430i Gran Coupe",
      "430i xDrive",
      "430i xDrive Gran Coupe",
      "440i",
      "440i xDrive",
      "440i xDrive Gran Coupe",
      "530e",
      "530e xDrive",
      "530i",
      "530i xDrive",
      "540d xDrive",
      "540i",
      "540i xDrive",
      "640i xDrive",
      "640i xDrive Gran Coupe",
      "640i xDrive Gran Turismo",
      "650i Gran Coupe",
      "650i xDrive",
      "650i xDrive Gran Coupe",
      "740e xDrive",
      "740i",
      "740i xDrive",
      "750i xDrive",
      "750Li xDrive",
      "Alpina B6 xDrive Gran Coupe",
      "Alpina B7",
      "i3",
      "i3s",
      "i8",
      "M2",
      "M240i",
      "M240i xDrive",
      "M3",
      "M4",
      "M5",
      "M550i xDrive",
      "M6",
      "M6 Gran Coupe",
      "M760Li xDrive",
      "X1",
      "X2",
      "X3",
      "X4",
      "X5",
      "X6"
    ],
    "Buick": [
      "Cascada",
      "Enclave",
      "Encore",
      "Envision",
      "LaCrosse",
      "Regal Sportback",
      "Regal TourX"
    ],
    "Cadillac": [
      "ATS",
      "CT6",
      "CTS",
      "Escalade",
      "Escalade ESV",
      "XT5",
      "XTS"
    ],
    "Chevrolet": [
      "Bolt EV",
      "Camaro",
      "City Express",
      "Colorado",
      "Corvette",
      "Cruze",
      "Equinox",
      "Express 2500",
      "Express 3500",
      "Impala",
      "Malibu",
      "Silverado 1500",
      "Silverado 2500 HD",
      "Silverado 3500 HD",
      "Sonic",
      "Spark",
      "Suburban",
      "Suburban 3500 HD",
      "Tahoe",
      "Traverse",
      "Trax",
      "Volt"
    ],
    "Chrysler": [
      "300",
      "Pacifica"
    ],
    "Dodge": [
      "Challenger",
      "Charger",
      "Durango",
      "Grand Caravan",
      "Journey"
    ],
    "Fiat": [
      "124 Spider",
      "500",
      "500L",
      "500X"
    ],
    "Ford": [
      "C-Max",
      "E-350 Super Duty",
      "E-450 Super Duty",
      "EcoSport",
      "Edge",
      "Escape",
      "Expedition",
      "Explorer",
      "F-150",
      "F-250 Super Duty",
      "F-350 Super Duty",
      "F-450 Super Duty",
      "Fiesta",
      "Flex",
      "Focus",
      "Fusion",
      "GT",
      "Mustang",
      "Police Interceptor Sedan",
      "Police Interceptor Utility",
      "Special Service Police Sedan",
      "Taurus",
      "Transit Connect",
      "Transit-150",
      "Transit-250",
      "Transit-350",
      "Transit-350 HD"
    ],
    "Genesis": [
      "G80",
      "G90"
    ],
    "GMC": [
      "Acadia",
      "Canyon",
      "Savana 2500",
      "Savana 3500",
      "Sierra 1500",
      "Sierra 2500 HD",
      "Sierra 3500 HD",
      "Terrain",
      "Yukon",
      "Yukon XL"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "Clarity",
      "CR-V",
      "Fit",
      "HR-V",
      "Insight",
      "Odyssey",
      "Pilot",
      "Ridgeline"
    ],
    "Hyundai": [
      "Accent",
      "Elantra",
      "Elantra GT",
      "Ioniq",
      "Kona",
      "Santa Fe",
      "Santa Fe XL",
      "Santa Fe Sport",
      "Sonata",
      "Tucson",
      "Veloster"
    ],
    "INFINITI": [
      "Q50",
      "Q60",
      "Q70",
      "Q70L",
      "QX30",
      "QX60",
      "QX80"
    ],
    "Jaguar": [
      "E-Pace",
      "F-Pace",
      "F-Type",
      "XE",
      "XF",
      "XJ",
      "XJR575"
    ],
    "Jeep": [
      "Cherokee",
      "Compass",
      "Grand Cherokee",
      "Renegade",
      "Wrangler",
      "Wrangler JK"
    ],
    "Kia": [
      "Cadenza",
      "Forte",
      "Forte5",
      "Niro",
      "Optima",
      "Rio",
      "Sedona",
      "Sorento",
      "Soul",
      "Soul EV",
      "Sportage",
      "Stinger"
    ],
    "Land Rover": [
      "Discovery",
      "Discovery Sport",
      "Range Rover",
      "Range Rover Evoque",
      "Range Rover Sport",
      "Range Rover Velar"
    ],
    "Lexus": [
      "ES300h",
      "ES350",
      "GS F",
      "GS350",
      "GS450h",
      "GX460",
      "IS300",
      "IS350",
      "LC500",
      "LC500h",
      "LS500",
      "LS500h",
      "LX570",
      "NX300",
      "NX300h",
      "RC F",
      "RC300",
      "RC350",
      "RX350",
      "RX350L",
      "RX450h",
      "RX450hL"
    ],
    "Lincoln": [
      "Continental",
      "MKC",
      "MKT",
      "MKX",
      "MKZ",
      "Navigator"
    ],
    "Mazda": [
      "3",
      "3 Sport",
      "6",
      "CX-3",
      "CX-5",
      "CX-9",
      "MX-5 Miata"
    ],
    "Mercedes-Benz": [
      "AMG GT",
      "AMG GT C",
      "AMG GT R",
      "B250",
      "C300",
      "C43 AMG",
      "C63 AMG",
      "C63 AMG S",
      "CLA250",
      "CLA45 AMG",
      "CLS63 AMG S",
      "E300",
      "E400",
      "E43 AMG",
      "E63 AMG S",
      "G550",
      "G550 4x4",
      "G63 AMG",
      "G65 AMG",
      "GLA250",
      "GLA45 AMG",
      "GLC300",
      "GLC350e",
      "GLC43 AMG",
      "GLC63 AMG",
      "GLC63 AMG S",
      "GLE350",
      "GLE400",
      "GLE43 AMG",
      "GLE550",
      "GLE550e",
      "GLE63 AMG S",
      "GLS450",
      "GLS550",
      "GLS63 AMG",
      "Maybach S560",
      "Maybach S650",
      "Metris",
      "S450",
      "S560",
      "S63 AMG",
      "S65 AMG",
      "SL450",
      "SL550",
      "SL63 AMG",
      "SL65 AMG",
      "SLC300",
      "SLC43 AMG",
      "Sprinter 2500",
      "Sprinter 3500"
    ],
    "Mini": [
      "Cooper",
      "Cooper Clubman",
      "Cooper Countryman"
    ],
    "Mitsubishi": [
      "Eclipse Cross",
      "Mirage",
      "Mirage G4",
      "Outlander",
      "Outlander PHEV",
      "Outlander Sport",
      "RVR"
    ],
    "Nissan": [
      "370Z",
      "Altima",
      "Armada",
      "Frontier",
      "GT-R",
      "Kicks",
      "LEAF",
      "Maxima",
      "Micra",
      "Murano",
      "NV1500",
      "NV200",
      "NV2500",
      "NV3500",
      "Pathfinder",
      "Qashqai",
      "Rogue",
      "Rogue Sport",
      "Sentra",
      "TITAN",
      "TITAN XD",
      "Versa",
      "Versa Note"
    ],
    "Porsche": [
      "718 Boxster",
      "718 Cayman",
      "911",
      "Cayenne",
      "Macan",
      "Panamera"
    ],
    "Ram": [
      "1500",
      "2500",
      "3500",
      "ProMaster 1500",
      "ProMaster 2500",
      "ProMaster 3500",
      "ProMaster City"
    ],
    "Rolls Royce": [
      "Dawn",
      "Ghost",
      "Wraith"
    ],
    "Smart": [
      "Fortwo"
    ],
    "Subaru": [
      "BRZ",
      "Crosstrek",
      "Forester",
      "Impreza",
      "Legacy",
      "Outback",
      "WRX",
      "WRX STI"
    ],
    "Tesla": [
      "3",
      "S",
      "X"
    ],
    "Toyota": [
      "4Runner",
      "86",
      "Avalon",
      "C-HR",
      "Camry",
      "Corolla",
      "Corolla iM",
      "Highlander",
      "Land Cruiser",
      "Mirai",
      "Prius",
      "Prius C",
      "Prius Prime",
      "Prius V",
      "RAV4",
      "Sequoia",
      "Sienna",
      "Tacoma",
      "Tundra",
      "Yaris",
      "Yaris iA"
    ],
    "Volkswagen": [
      "Atlas",
      "Beetle",
      "e-Golf",
      "Golf",
      "Golf Alltrack",
      "Golf R",
      "Golf SportWagen",
      "GTI",
      "Jetta",
      "Passat",
      "Tiguan",
      "Tiguan Limited"
    ],
    "Volvo": [
      "S60",
      "S90",
      "V40",
      "V40 Cross Country",
      "V60",
      "V60 Cross Country",
      "V90",
      "V90 Cross Country",
      "XC60",
      "XC90"
    ]
  },
  "2019": {
    "Acura": [
      "ILX",
      "MDX",
      "NSX",
      "RDX",
      "RLX",
      "TLX"
    ],
    "Alfa Romeo": [
      "Giulia",
      "Stelvio"
    ],
    "Audi": [
      "A3",
      "A3 Quattro",
      "A4",
      "A4 allroad",
      "A4 Quattro",
      "A5 Quattro",
      "A5 Sportback",
      "A6 Quattro",
      "A7 Sportback",
      "A8 Quattro",
      "e-tron Quattro",
      "Q3",
      "Q5",
      "Q7",
      "Q8",
      "R8",
      "RS3",
      "RS5",
      "S3",
      "S4",
      "S5",
      "S5 Sportback",
      "S6",
      "S7",
      "S8",
      "SQ5",
      "TT Quattro",
      "TT RS Quattro",
      "TTS Quattro"
    ],
    "BMW": [
      "230i",
      "230i xDrive",
      "330e",
      "330i",
      "330i xDrive",
      "430i",
      "430i xDrive",
      "430i xDrive Gran Coupe",
      "440i",
      "440i Gran Coupe",
      "440i xDrive",
      "440i xDrive Gran Coupe",
      "530e",
      "530e xDrive",
      "530i",
      "530i xDrive",
      "540i",
      "540i xDrive",
      "640i xDrive Gran Coupe",
      "640i xDrive Gran Turismo",
      "650i xDrive Gran Coupe",
      "740e xDrive",
      "740i",
      "740i xDrive",
      "750i xDrive",
      "750Li xDrive",
      "Alpina B6 xDrive Gran Coupe",
      "Alpina B7",
      "i3",
      "i3s",
      "i8",
      "M2",
      "M240i",
      "M240i xDrive",
      "M4",
      "M5",
      "M550i xDrive",
      "M6 Gran Coupe",
      "M760i xDrive",
      "M850i xDrive",
      "X1",
      "X2",
      "X3",
      "X4",
      "X5",
      "X6",
      "X7",
      "Z4"
    ],
    "Buick": [
      "Cascada",
      "Enclave",
      "Encore",
      "Envision",
      "LaCrosse",
      "Regal Sportback",
      "Regal TourX"
    ],
    "Cadillac": [
      "ATS",
      "CT6",
      "CTS",
      "Escalade",
      "Escalade ESV",
      "XT4",
      "XT5",
      "XTS"
    ],
    "Chevrolet": [
      "Blazer",
      "Bolt EV",
      "Camaro",
      "Colorado",
      "Corvette",
      "Cruze",
      "Equinox",
      "Express 2500",
      "Express 3500",
      "Impala",
      "Malibu",
      "Silverado 1500",
      "Silverado 1500 LD",
      "Silverado 2500 HD",
      "Silverado 3500 HD",
      "Sonic",
      "Spark",
      "Suburban",
      "Suburban 3500 HD",
      "Tahoe",
      "Traverse",
      "Trax",
      "Volt"
    ],
    "Chrysler": [
      "300",
      "Pacifica"
    ],
    "Dodge": [
      "Challenger",
      "Charger",
      "Durango",
      "Grand Caravan",
      "Journey"
    ],
    "Fiat": [
      "124 Spider",
      "500",
      "500L",
      "500X"
    ],
    "Ford": [
      "E-350 Super Duty",
      "E-450 Super Duty",
      "EcoSport",
      "Edge",
      "Escape",
      "Expedition",
      "Explorer",
      "F-150",
      "F-250 Super Duty",
      "F-350 Super Duty",
      "F-450 Super Duty",
      "Fiesta",
      "Flex",
      "Fusion",
      "GT",
      "Mustang",
      "Police Interceptor Sedan",
      "Police Interceptor Utility",
      "Police Responder Hybrid",
      "Ranger",
      "Taurus",
      "Transit Connect",
      "Transit-150",
      "Transit-250",
      "Transit-350",
      "Transit-350 HD"
    ],
    "Genesis": [
      "G70",
      "G80",
      "G90"
    ],
    "GMC": [
      "Acadia",
      "Canyon",
      "Savana 2500",
      "Savana 3500",
      "Sierra 1500",
      "Sierra 1500 Limited",
      "Sierra 2500 HD",
      "Sierra 3500 HD",
      "Terrain",
      "Yukon",
      "Yukon XL"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "Clarity",
      "CR-V",
      "Fit",
      "HR-V",
      "Insight",
      "Odyssey",
      "Passport",
      "Pilot",
      "Ridgeline"
    ],
    "Hyundai": [
      "Accent",
      "Elantra",
      "Elantra GT",
      "Ioniq",
      "Kona",
      "Kona Electric",
      "Nexo",
      "Santa Fe",
      "Santa Fe XL",
      "Sonata",
      "Tucson",
      "Veloster",
      "Veloster N"
    ],
    "INFINITI": [
      "Q50",
      "Q60",
      "Q70",
      "Q70L",
      "QX50",
      "QX60",
      "QX80"
    ],
    "Jaguar": [
      "E-Pace",
      "F-Pace",
      "F-Type",
      "I-Pace",
      "XE",
      "XF",
      "XJ",
      "XJR575"
    ],
    "Jeep": [
      "Cherokee",
      "Compass",
      "Grand Cherokee",
      "Renegade",
      "Wrangler"
    ],
    "Kia": [
      "Cadenza",
      "Forte",
      "Forte5",
      "K900",
      "Niro",
      "Niro EV",
      "Optima",
      "Rio",
      "Sedona",
      "Sorento",
      "Soul",
      "Soul EV",
      "Sportage",
      "Stinger"
    ],
    "Land Rover": [
      "Discovery",
      "Discovery Sport",
      "Range Rover",
      "Range Rover Evoque",
      "Range Rover Sport",
      "Range Rover Velar"
    ],
    "Lexus": [
      "ES300h",
      "ES350",
      "GS F",
      "GS300",
      "GS350",
      "GX460",
      "IS300",
      "IS350",
      "LC500",
      "LC500h",
      "LS500",
      "LS500h",
      "LX570",
      "NX300",
      "NX300h",
      "RC F",
      "RC300",
      "RC350",
      "RX350",
      "RX350L",
      "RX450h",
      "RX450hL",
      "UX200",
      "UX250h"
    ],
    "Lincoln": [
      "Continental",
      "MKC",
      "MKT",
      "MKZ",
      "Nautilus",
      "Navigator"
    ],
    "Mazda": [
      "3",
      "3 Sport",
      "6",
      "CX-3",
      "CX-5",
      "CX-9",
      "MX-5 Miata"
    ],
    "Mercedes-Benz": [
      "A220",
      "A250",
      "AMG GT",
      "AMG GT 63",
      "AMG GT 63 S",
      "AMG GT C",
      "AMG GT R",
      "B250",
      "C300",
      "C43 AMG",
      "C63 AMG",
      "C63 AMG S",
      "CLA250",
      "CLA45 AMG",
      "CLS450",
      "CLS53 AMG",
      "E300",
      "E450",
      "E53 AMG",
      "E63 AMG S",
      "G550",
      "G63 AMG",
      "GLA250",
      "GLA45 AMG",
      "GLC300",
      "GLC350e",
      "GLC43 AMG",
      "GLC63 AMG",
      "GLC63 AMG S",
      "GLE400",
      "GLE43 AMG",
      "GLE63 AMG S",
      "GLS450",
      "GLS550",
      "GLS63 AMG",
      "Maybach S560",
      "Maybach S650",
      "Metris",
      "S450",
      "S560",
      "S63 AMG",
      "S65 AMG",
      "SL450",
      "SL550",
      "SL63 AMG",
      "SLC300",
      "SLC43 AMG",
      "Sprinter 2500",
      "Sprinter 3500",
      "Sprinter 4500"
    ],
    "Mini": [
      "Cooper",
      "Cooper Clubman",
      "Cooper Countryman"
    ],
    "Mitsubishi": [
      "Eclipse Cross",
      "Mirage",
      "Mirage G4",
      "Outlander",
      "Outlander PHEV",
      "Outlander Sport",
      "RVR"
    ],
    "Nissan": [
      "370Z",
      "Altima",
      "Armada",
      "Frontier",
      "GT-R",
      "Kicks",
      "LEAF",
      "Maxima",
      "Micra",
      "Murano",
      "NV1500",
      "NV200",
      "NV2500",
      "NV3500",
      "Pathfinder",
      "Qashqai",
      "Rogue",
      "Rogue Sport",
      "Sentra",
      "TITAN",
      "TITAN XD",
      "Versa",
      "Versa Note"
    ],
    "Porsche": [
      "718 Boxster",
      "718 Cayman",
      "911",
      "Cayenne",
      "Macan",
      "Panamera"
    ],
    "Ram": [
      "1500",
      "1500 Classic",
      "2500",
      "3500",
      "ProMaster 1500",
      "ProMaster 2500",
      "ProMaster 3500",
      "ProMaster City"
    ],
    "Rolls Royce": [
      "Cullinan",
      "Dawn",
      "Wraith"
    ],
    "Smart": [
      "EQ fortwo"
    ],
    "Subaru": [
      "Ascent",
      "BRZ",
      "Crosstrek",
      "Forester",
      "Impreza",
      "Legacy",
      "Outback",
      "WRX",
      "WRX STI"
    ],
    "Tesla": [
      "3",
      "S",
      "X"
    ],
    "Toyota": [
      "4Runner",
      "86",
      "Avalon",
      "C-HR",
      "Camry",
      "Corolla",
      "Highlander",
      "Land Cruiser",
      "Mirai",
      "Prius",
      "Prius AWD-e",
      "Prius C",
      "Prius Prime",
      "RAV4",
      "Sequoia",
      "Sienna",
      "Tacoma",
      "Tundra",
      "Yaris"
    ],
    "Volkswagen": [
      "Arteon",
      "Atlas",
      "Beetle",
      "e-Golf",
      "Golf",
      "Golf Alltrack",
      "Golf R",
      "Golf SportWagen",
      "GTI",
      "Jetta",
      "Passat",
      "Tiguan"
    ],
    "Volvo": [
      "S60",
      "S90",
      "V40",
      "V60",
      "V60 Cross Country",
      "V90",
      "V90 Cross Country",
      "XC40",
      "XC60",
      "XC90"
    ]
  },
  "2020": {
    "Acura": [
      "ILX",
      "MDX",
      "NSX",
      "RDX",
      "RLX",
      "TLX"
    ],
    "Alfa Romeo": [
      "Giulia",
      "Stelvio"
    ],
    "Audi": [
      "A3",
      "A3 Quattro",
      "A4 allroad",
      "A4 Quattro",
      "A5 Quattro",
      "A5 Sportback",
      "A6 allroad",
      "A6 Quattro",
      "A7 Sportback",
      "A8 Quattro",
      "e-tron Quattro",
      "e-tron Sportback",
      "Q3",
      "Q5",
      "Q5 PHEV",
      "Q7",
      "Q8",
      "R8",
      "RS Q8",
      "RS3",
      "RS5",
      "S3",
      "S4",
      "S5",
      "S5 Sportback",
      "S6",
      "S7",
      "S8",
      "SQ5",
      "SQ7",
      "SQ8",
      "TT Quattro",
      "TT RS Quattro",
      "TTS Quattro"
    ],
    "BMW": [
      "228i xDrive Gran Coupe",
      "230i",
      "230i xDrive",
      "330e",
      "330i",
      "330i xDrive",
      "430i",
      "430i xDrive",
      "430i xDrive Gran Coupe",
      "440i",
      "440i xDrive",
      "440i xDrive Gran Coupe",
      "530e xDrive",
      "530i xDrive",
      "540i xDrive",
      "740i xDrive",
      "745e xDrive",
      "750i xDrive",
      "Alpina B7",
      "i3",
      "i3s",
      "i8",
      "M2",
      "M235i xDrive Gran Coupe",
      "M240i",
      "M240i xDrive",
      "M340i",
      "M340i xDrive",
      "M4",
      "M5",
      "M550i xDrive",
      "M760i xDrive",
      "M8",
      "M8 Gran Coupe",
      "M850i xDrive",
      "M850i xDrive Gran Coupe",
      "X1",
      "X2",
      "X3",
      "X4",
      "X5",
      "X6",
      "X7",
      "Z4"
    ],
    "Buick": [
      "Enclave",
      "Encore",
      "Encore GX",
      "Envision",
      "Regal Sportback"
    ],
    "Cadillac": [
      "CT4",
      "CT5",
      "CT6",
      "Escalade",
      "Escalade ESV",
      "XT4",
      "XT5",
      "XT6"
    ],
    "Chevrolet": [
      "Blazer",
      "Bolt EV",
      "Camaro",
      "Colorado",
      "Corvette",
      "Equinox",
      "Express 2500",
      "Express 3500",
      "Impala",
      "Malibu",
      "Silverado 1500",
      "Silverado 2500 HD",
      "Silverado 3500 HD",
      "Sonic",
      "Spark",
      "Suburban",
      "Tahoe",
      "Traverse",
      "Trax"
    ],
    "Chrysler": [
      "300",
      "Pacifica",
      "Voyager"
    ],
    "Dodge": [
      "Challenger",
      "Charger",
      "Durango",
      "Grand Caravan",
      "Journey"
    ],
    "Fiat": [
      "124 Spider",
      "500L",
      "500X"
    ],
    "Ford": [
      "E-350 Super Duty",
      "E-450 Super Duty",
      "EcoSport",
      "Edge",
      "Escape",
      "Expedition",
      "Explorer",
      "F-150",
      "F-250 Super Duty",
      "F-350 Super Duty",
      "F-450 Super Duty",
      "Fusion",
      "GT",
      "Mustang",
      "Police Interceptor Utility",
      "Police Responder Hybrid",
      "Ranger",
      "Transit Connect",
      "Transit-150",
      "Transit-250",
      "Transit-350",
      "Transit-350 HD"
    ],
    "Genesis": [
      "G70",
      "G80",
      "G90"
    ],
    "GMC": [
      "Acadia",
      "Canyon",
      "Savana 2500",
      "Savana 3500",
      "Sierra 1500",
      "Sierra 1500 Limited",
      "Sierra 2500 HD",
      "Sierra 3500 HD",
      "Terrain",
      "Yukon",
      "Yukon XL"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "Clarity",
      "CR-V",
      "Fit",
      "HR-V",
      "Insight",
      "Odyssey",
      "Passport",
      "Pilot",
      "Ridgeline"
    ],
    "Hyundai": [
      "Accent",
      "Elantra",
      "Elantra GT",
      "Ioniq",
      "Kona",
      "Kona Electric",
      "Nexo",
      "Palisade",
      "Santa Fe",
      "Sonata",
      "Tucson",
      "Veloster",
      "Veloster N",
      "Venue"
    ],
    "INFINITI": [
      "Q50",
      "Q60",
      "QX50",
      "QX60",
      "QX80"
    ],
    "Jaguar": [
      "E-Pace",
      "F-Pace",
      "F-Type",
      "I-Pace",
      "XE",
      "XF"
    ],
    "Jeep": [
      "Cherokee",
      "Compass",
      "Gladiator",
      "Grand Cherokee",
      "Renegade",
      "Wrangler"
    ],
    "Kia": [
      "Forte",
      "Forte5",
      "Niro",
      "Niro EV",
      "Optima",
      "Rio",
      "Sedona",
      "Sorento",
      "Soul",
      "Soul EV",
      "Sportage",
      "Stinger",
      "Telluride"
    ],
    "Land Rover": [
      "Defender 110",
      "Discovery",
      "Discovery Sport",
      "Range Rover",
      "Range Rover Evoque",
      "Range Rover Sport",
      "Range Rover Velar"
    ],
    "Lexus": [
      "ES300h",
      "ES350",
      "GS F",
      "GS350",
      "GX460",
      "IS300",
      "IS350",
      "LC500",
      "LC500h",
      "LS500",
      "LS500h",
      "LX570",
      "NX300",
      "NX300h",
      "RC F",
      "RC300",
      "RC350",
      "RX350",
      "RX350L",
      "RX450h",
      "RX450hL",
      "UX200",
      "UX250h"
    ],
    "Lincoln": [
      "Aviator",
      "Continental",
      "Corsair",
      "MKZ",
      "Nautilus",
      "Navigator"
    ],
    "Mazda": [
      "3",
      "3 Sport",
      "6",
      "CX-3",
      "CX-30",
      "CX-5",
      "CX-9",
      "MX-5 Miata"
    ],
    "Mercedes-Benz": [
      "A220",
      "A250",
      "A35 AMG",
      "AMG GT",
      "AMG GT 53",
      "AMG GT 63",
      "AMG GT 63 S",
      "AMG GT C",
      "AMG GT R",
      "AMG GT S",
      "C300",
      "C43 AMG",
      "C63 AMG",
      "C63 AMG S",
      "CLA250",
      "CLA35 AMG",
      "CLA45 AMG",
      "CLS450",
      "CLS53 AMG",
      "E350",
      "E43 AMG",
      "E450",
      "E53 AMG",
      "E63 AMG S",
      "G500",
      "G550",
      "G63 AMG",
      "GLA250",
      "GLA45 AMG",
      "GLB250",
      "GLC300",
      "GLC350e",
      "GLC43 AMG",
      "GLC63 AMG",
      "GLC63 AMG S",
      "GLE350",
      "GLE450",
      "GLE53 AMG",
      "GLE580",
      "GLE63 AMG S",
      "GLS450",
      "GLS580",
      "GLS63 AMG",
      "Maybach S560",
      "Maybach S650",
      "Metris",
      "S450",
      "S560",
      "S560e",
      "S63 AMG",
      "S65 AMG",
      "SL450",
      "SL550",
      "SLC300",
      "SLC43 AMG",
      "Sprinter 2500",
      "Sprinter 3500",
      "Sprinter 4500"
    ],
    "Mini": [
      "Cooper",
      "Cooper Clubman",
      "Cooper Countryman"
    ],
    "Mitsubishi": [
      "Eclipse Cross",
      "Mirage",
      "Outlander",
      "Outlander PHEV",
      "Outlander Sport",
      "RVR"
    ],
    "Nissan": [
      "370Z",
      "Altima",
      "Armada",
      "Frontier",
      "GT-R",
      "Kicks",
      "LEAF",
      "Maxima",
      "Murano",
      "NV1500",
      "NV200",
      "NV2500",
      "NV3500",
      "Pathfinder",
      "Qashqai",
      "Rogue",
      "Rogue Sport",
      "Sentra",
      "TITAN",
      "TITAN XD",
      "Versa"
    ],
    "Porsche": [
      "718 Boxster",
      "718 Cayman",
      "718 Spyder",
      "911",
      "Cayenne",
      "Macan",
      "Panamera",
      "Taycan"
    ],
    "Ram": [
      "1500",
      "1500 Classic",
      "2500",
      "3500",
      "ProMaster 1500",
      "ProMaster 2500",
      "ProMaster 3500",
      "ProMaster City"
    ],
    "Rolls Royce": [
      "Cullinan",
      "Dawn"
    ],
    "Subaru": [
      "Ascent",
      "BRZ",
      "Crosstrek",
      "Forester",
      "Impreza",
      "Legacy",
      "Outback",
      "WRX",
      "WRX STI"
    ],
    "Tesla": [
      "3",
      "S",
      "X",
      "Y"
    ],
    "Toyota": [
      "4Runner",
      "86",
      "Avalon",
      "C-HR",
      "Camry",
      "Corolla",
      "GR Supra",
      "Highlander",
      "Land Cruiser",
      "Mirai",
      "Prius",
      "Prius AWD-e",
      "Prius Prime",
      "RAV4",
      "Sequoia",
      "Sienna",
      "Tacoma",
      "Tundra",
      "Yaris"
    ],
    "Volkswagen": [
      "Arteon",
      "Atlas",
      "Atlas Cross Sport",
      "e-Golf",
      "Golf",
      "Golf R",
      "GTI",
      "Jetta",
      "Passat",
      "Tiguan"
    ],
    "Volvo": [
      "S60",
      "S90",
      "V60",
      "V60 Cross Country",
      "V90 Cross Country",
      "XC40",
      "XC60",
      "XC90"
    ]
  },
  "2021": {
    "Acura": [
      "ILX",
      "MDX",
      "NSX",
      "RDX",
      "TLX"
    ],
    "Alfa Romeo": [
      "Giulia",
      "Stelvio"
    ],
    "Audi": [
      "A3",
      "A3 Quattro",
      "A4 allroad",
      "A4 Quattro",
      "A5 Quattro",
      "A5 Sportback",
      "A6 allroad",
      "A6 Quattro",
      "A7 Sportback",
      "A8 Quattro",
      "e-tron Quattro",
      "e-tron Sportback",
      "Q3",
      "Q5",
      "Q5 PHEV",
      "Q5 Sportback",
      "Q7",
      "Q8",
      "R8",
      "RS Q8",
      "RS5",
      "RS6 Avant",
      "RS7 Sportback",
      "S3",
      "S4",
      "S5",
      "S6",
      "S7 Sportback",
      "S8",
      "SQ5",
      "SQ5 Sportback",
      "SQ7",
      "SQ8",
      "TT Quattro",
      "TT RS Quattro",
      "TTS Quattro"
    ],
    "BMW": [
      "228i xDrive Gran Coupe",
      "230i xDrive",
      "330e",
      "330e xDrive",
      "330i",
      "330i xDrive",
      "430i",
      "430i xDrive",
      "430i xDrive Gran Coupe",
      "530e xDrive",
      "530i xDrive",
      "540i xDrive",
      "745e xDrive",
      "750i xDrive",
      "Alpina B7",
      "Alpina XB7",
      "i3",
      "i3s",
      "M2",
      "M235i xDrive Gran Coupe",
      "M240i",
      "M240i xDrive",
      "M3",
      "M340i xDrive",
      "M4",
      "M440i",
      "M440i xDrive",
      "M5",
      "M550i xDrive",
      "M760i xDrive",
      "M8",
      "M8 Gran Coupe",
      "M850i xDrive",
      "M850i xDrive Gran Coupe",
      "X1",
      "X2",
      "X3",
      "X4",
      "X5",
      "X6",
      "X7",
      "Z4"
    ],
    "Buick": [
      "Enclave",
      "Encore",
      "Encore GX",
      "Envision"
    ],
    "Cadillac": [
      "CT4",
      "CT5",
      "Escalade",
      "Escalade ESV",
      "XT4",
      "XT5",
      "XT6"
    ],
    "Chevrolet": [
      "Blazer",
      "Bolt EV",
      "Camaro",
      "Colorado",
      "Corvette",
      "Equinox",
      "Express 2500",
      "Express 3500",
      "Malibu",
      "Silverado 1500",
      "Silverado 2500 HD",
      "Silverado 3500 HD",
      "Spark",
      "Suburban",
      "Tahoe",
      "Trailblazer",
      "Traverse",
      "Trax"
    ],
    "Chrysler": [
      "300",
      "Grand Caravan",
      "Pacifica",
      "Voyager"
    ],
    "Dodge": [
      "Challenger",
      "Charger",
      "Durango"
    ],
    "Fiat": [
      "500X"
    ],
    "Ford": [
      "Bronco",
      "Bronco Sport",
      "E-350 Super Duty",
      "E-450 Super Duty",
      "EcoSport",
      "Edge",
      "Escape",
      "Expedition",
      "Explorer",
      "F-150",
      "F-250 Super Duty",
      "F-350 Super Duty",
      "F-450 Super Duty",
      "GT",
      "Mustang",
      "Mustang Mach-E",
      "Police Interceptor Utility",
      "Ranger",
      "Transit Connect",
      "Transit-150",
      "Transit-250",
      "Transit-350",
      "Transit-350 HD"
    ],
    "Genesis": [
      "G70",
      "G80",
      "G90",
      "GV80"
    ],
    "GMC": [
      "Acadia",
      "Canyon",
      "Savana 2500",
      "Savana 3500",
      "Sierra 1500",
      "Sierra 1500 Limited",
      "Sierra 2500 HD",
      "Sierra 3500 HD",
      "Terrain",
      "Yukon",
      "Yukon XL"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "Clarity",
      "CR-V",
      "HR-V",
      "Insight",
      "Odyssey",
      "Passport",
      "Pilot",
      "Ridgeline"
    ],
    "Hyundai": [
      "Elantra",
      "Ioniq",
      "Kona",
      "Kona Electric",
      "Nexo",
      "Palisade",
      "Santa Fe",
      "Sonata",
      "Tucson",
      "Veloster N",
      "Venue"
    ],
    "INFINITI": [
      "Q50",
      "Q60",
      "QX50",
      "QX80"
    ],
    "Jaguar": [
      "E-Pace",
      "F-Pace",
      "F-Type",
      "I-Pace",
      "XF"
    ],
    "Jeep": [
      "Cherokee",
      "Compass",
      "Gladiator",
      "Grand Cherokee",
      "Grand Cherokee L",
      "Renegade",
      "Wrangler"
    ],
    "Kia": [
      "Forte",
      "Forte5",
      "K5",
      "Niro",
      "Niro EV",
      "Rio",
      "Sedona",
      "Seltos",
      "Sorento",
      "Soul",
      "Soul EV",
      "Sportage",
      "Stinger",
      "Telluride"
    ],
    "Land Rover": [
      "Defender 110",
      "Defender 90",
      "Discovery",
      "Discovery Sport",
      "Range Rover",
      "Range Rover Evoque",
      "Range Rover Sport",
      "Range Rover Velar"
    ],
    "Lexus": [
      "ES250",
      "ES300h",
      "ES350",
      "GX460",
      "IS300",
      "IS350",
      "LC500",
      "LC500h",
      "LS500",
      "LS500h",
      "LX570",
      "NX300",
      "NX300h",
      "RC F",
      "RC300",
      "RC350",
      "RX350",
      "RX350L",
      "RX450h",
      "RX450hL",
      "UX200",
      "UX250h"
    ],
    "Lincoln": [
      "Aviator",
      "Corsair",
      "Nautilus",
      "Navigator"
    ],
    "Mazda": [
      "3",
      "6",
      "CX-3",
      "CX-30",
      "CX-5",
      "CX-9",
      "MX-5 Miata"
    ],
    "Mercedes-Benz": [
      "A220",
      "A250",
      "A35 AMG",
      "AMG GT",
      "AMG GT 53",
      "AMG GT 63",
      "AMG GT 63 S",
      "AMG GT Black Series",
      "AMG GT C",
      "Amg GT R",
      "C300",
      "C43 AMG",
      "C63 AMG S",
      "CLA250",
      "CLA35 AMG",
      "CLA45 AMG",
      "CLS450",
      "CLS53 AMG",
      "E350",
      "E450",
      "E53 AMG",
      "E63 AMG S",
      "G500",
      "G550",
      "G63 AMG",
      "GLA250",
      "GLA35 AMG",
      "GLA45 AMG",
      "GLB250",
      "GLB35 AMG",
      "GLC300",
      "GLC43 AMG",
      "GLC63 AMG",
      "GLC63 AMG S",
      "GLE350",
      "GLE450",
      "GLE53 AMG",
      "GLE580",
      "GLE63 AMG S",
      "GLS450",
      "GLS580",
      "GLS63 AMG",
      "Maybach GLS600",
      "Metris",
      "S500",
      "S560",
      "S580",
      "S63 AMG",
      "Sprinter 2500",
      "Sprinter 3500",
      "Sprinter 4500"
    ],
    "Mini": [
      "Cooper",
      "Cooper Clubman",
      "Cooper Countryman"
    ],
    "Mitsubishi": [
      "Eclipse Cross",
      "Mirage",
      "Outlander",
      "Outlander PHEV",
      "RVR"
    ],
    "Nissan": [
      "Altima",
      "Armada",
      "Frontier",
      "GT-R",
      "Kicks",
      "LEAF",
      "Maxima",
      "Murano",
      "NV1500",
      "NV200",
      "NV2500",
      "NV3500",
      "Qashqai",
      "Rogue",
      "Rogue Sport",
      "Sentra",
      "TITAN",
      "TITAN XD",
      "Versa"
    ],
    "Polestar": [
      "Polestar 2"
    ],
    "Porsche": [
      "718 Boxster",
      "718 Cayman",
      "718 Spyder",
      "911",
      "Cayenne",
      "Macan",
      "Panamera",
      "Taycan"
    ],
    "Ram": [
      "1500",
      "1500 Classic",
      "2500",
      "3500",
      "ProMaster 1500",
      "ProMaster 2500",
      "ProMaster 3500",
      "ProMaster City"
    ],
    "Rolls Royce": [
      "Cullinan"
    ],
    "Subaru": [
      "Ascent",
      "BRZ",
      "Crosstrek",
      "Forester",
      "Impreza",
      "Legacy",
      "Outback",
      "WRX",
      "WRX STI"
    ],
    "Tesla": [
      "3",
      "S",
      "X",
      "Y"
    ],
    "Toyota": [
      "4Runner",
      "Avalon",
      "C-HR",
      "Camry",
      "Corolla",
      "GR Supra",
      "Highlander",
      "Land Cruiser",
      "Mirai",
      "Prius",
      "Prius AWD-e",
      "Prius Prime",
      "RAV4",
      "RAV4 Prime",
      "Sequoia",
      "Sienna",
      "Tacoma",
      "Tundra",
      "Venza"
    ],
    "Volkswagen": [
      "Arteon",
      "Atlas",
      "Atlas Cross Sport",
      "Golf",
      "Golf R",
      "GTI",
      "ID.4",
      "Jetta",
      "Passat",
      "Tiguan"
    ],
    "Volvo": [
      "S60",
      "S90",
      "V60",
      "V60 Cross Country",
      "V90 Cross Country",
      "XC40",
      "XC40 Recharge",
      "XC60",
      "XC90"
    ]
  },
  "2022": {
    "Acura": [
      "ILX",
      "MDX",
      "NSX",
      "RDX",
      "TLX"
    ],
    "Alfa Romeo": [
      "Stelvio"
    ],
    "Audi": [
      "A3",
      "A3 Quattro",
      "A4 allroad",
      "A4 Quattro",
      "A5 Quattro",
      "A5 Sportback",
      "A6",
      "A6 allroad",
      "A6 Quattro",
      "A7 Sportback",
      "A8 Quattro",
      "e-tron GT",
      "e-tron Quattro",
      "e-tron S",
      "e-tron S Sportback",
      "e-tron Sportback",
      "Q3",
      "Q4 e-tron",
      "Q4 e-tron Sportback",
      "Q5",
      "Q5 PHEV",
      "Q5 Sportback",
      "Q7",
      "Q8",
      "R8",
      "RS e-tron GT",
      "RS Q8",
      "RS5",
      "RS6 Avant",
      "RS7 Sportback",
      "S3",
      "S4",
      "S5",
      "S6",
      "S7 Sportback",
      "S8",
      "SQ5",
      "SQ5 Sportback",
      "SQ7",
      "SQ8",
      "TT Quattro",
      "TTS Quattro"
    ],
    "BMW": [
      "228i xDrive Gran Coupe",
      "230i xDrive",
      "330e",
      "330e xDrive",
      "330i",
      "330i xDrive",
      "430i",
      "430i xDrive",
      "430i xDrive Gran Coupe",
      "530e xDrive",
      "530i xDrive",
      "540i xDrive",
      "745e xDrive",
      "750i xDrive",
      "Alpina B7",
      "Alpina B8 Gran Coupe",
      "Alpina XB7",
      "i4",
      "iX",
      "M235i xDrive Gran Coupe",
      "M240i xDrive",
      "M3",
      "M340i xDrive",
      "M440i xDrive",
      "M440i xDrive Gran Coupe",
      "M5",
      "M550i xDrive",
      "M760i xDrive",
      "M8",
      "M850i xDrive",
      "M850i xDrive Gran Coupe",
      "X1",
      "X2",
      "X3",
      "X4",
      "X5",
      "X6",
      "X7",
      "Z4"
    ],
    "Buick": [
      "Enclave",
      "Encore",
      "Encore GX",
      "Envision"
    ],
    "Cadillac": [
      "CT4",
      "CT5",
      "Escalade",
      "Escalade ESV",
      "XT4",
      "XT5",
      "XT6"
    ],
    "Chevrolet": [
      "Blazer",
      "Bolt EUV",
      "Bolt EV",
      "Camaro",
      "Colorado",
      "Corvette",
      "Equinox",
      "Express 2500",
      "Express 3500",
      "Malibu",
      "Silverado 1500",
      "Silverado 1500 LTD",
      "Silverado 2500 HD",
      "Silverado 3500 HD",
      "Spark",
      "Suburban",
      "Tahoe",
      "Trailblazer",
      "Traverse",
      "Trax"
    ],
    "Chrysler": [
      "300",
      "Grand Caravan",
      "Pacifica"
    ],
    "Dodge": [
      "Challenger",
      "Charger",
      "Durango"
    ],
    "Fiat": [
      "500X"
    ],
    "Ford": [
      "Bronco",
      "Bronco Sport",
      "E-350 Super Duty",
      "E-450 Super Duty",
      "E-Transit",
      "EcoSport",
      "Edge",
      "Escape",
      "Expedition",
      "Explorer",
      "F-150",
      "F-150 Lightning",
      "F-250 Super Duty",
      "F-350 Super Duty",
      "F-450 Super Duty",
      "GT",
      "Maverick",
      "Mustang",
      "Mustang Mach-E",
      "Police Interceptor Utility",
      "Ranger",
      "Transit Connect",
      "Transit-150",
      "Transit-250",
      "Transit-350",
      "Transit-350 HD"
    ],
    "Genesis": [
      "G70",
      "G80",
      "G90",
      "GV70",
      "GV80"
    ],
    "GMC": [
      "Acadia",
      "Canyon",
      "Savana 2500",
      "Savana 3500",
      "Sierra 1500",
      "Sierra 1500 Limited",
      "Sierra 2500 HD",
      "Sierra 3500 HD",
      "Terrain",
      "Yukon",
      "Yukon XL"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "CR-V",
      "HR-V",
      "Insight",
      "Odyssey",
      "Passport",
      "Pilot",
      "Ridgeline"
    ],
    "Hyundai": [
      "Elantra",
      "Elantra N",
      "Ioniq",
      "Ioniq 5",
      "Kona",
      "Kona Electric",
      "Kona N",
      "Nexo",
      "Palisade",
      "Santa Cruz",
      "Santa Fe",
      "Sonata",
      "Tucson",
      "Veloster N",
      "Venue"
    ],
    "INFINITI": [
      "Q50",
      "Q60",
      "QX50",
      "QX55",
      "QX60",
      "QX80"
    ],
    "Jaguar": [
      "E-Pace",
      "F-Pace",
      "F-Type",
      "I-Pace",
      "XF"
    ],
    "Jeep": [
      "Cherokee",
      "Compass",
      "Gladiator",
      "Grand Cherokee",
      "Grand Cherokee L",
      "Grand Cherokee WK",
      "Grand Wagoneer",
      "Renegade",
      "Wagoneer",
      "Wrangler"
    ],
    "Kia": [
      "Carnival",
      "EV6",
      "Forte",
      "Forte5",
      "K5",
      "Niro",
      "Niro EV",
      "Rio",
      "Seltos",
      "Sorento",
      "Soul",
      "Soul EV",
      "Sportage",
      "Stinger",
      "Telluride"
    ],
    "Land Rover": [
      "Defender 110",
      "Defender 90",
      "Discovery",
      "Discovery Sport",
      "Range Rover",
      "Range Rover Evoque",
      "Range Rover Sport",
      "Range Rover Velar"
    ],
    "Lexus": [
      "ES250",
      "ES300h",
      "ES350",
      "GX460",
      "IS300",
      "IS350",
      "IS500",
      "LC500",
      "LC500h",
      "LS500",
      "LS500h",
      "LX600",
      "NX250",
      "NX350",
      "NX350h",
      "NX450h+",
      "RC F",
      "RC300",
      "RC350",
      "RX350",
      "RX350L",
      "RX450h",
      "RX450hL",
      "UX200",
      "UX250h"
    ],
    "Lincoln": [
      "Aviator",
      "Corsair",
      "Nautilus",
      "Navigator"
    ],
    "Lucid": [
      "Air"
    ],
    "Mazda": [
      "3",
      "CX-30",
      "CX-5",
      "CX-9",
      "MX-30 EV",
      "MX-5 Miata"
    ],
    "Mercedes-Benz": [
      "A220",
      "A250",
      "A35 AMG",
      "AMG GT 53",
      "AMG GT 63",
      "AMG GT 63 S",
      "C300",
      "C43 AMG",
      "CLA250",
      "CLA35 AMG",
      "CLA45 AMG",
      "CLS450",
      "CLS53 AMG",
      "E350",
      "E450",
      "E53 AMG",
      "E63 AMG S",
      "EQB 350",
      "EQS 450+",
      "EQS 580",
      "G500",
      "G550",
      "G63 AMG",
      "GLA250",
      "GLA35 AMG",
      "GLA45 AMG",
      "GLB250",
      "GLB35 AMG",
      "GLC300",
      "GLC43 AMG",
      "GLE350",
      "GLE450",
      "GLE53 AMG",
      "GLE580",
      "GLE63 AMG S",
      "GLS450",
      "GLS580",
      "GLS63 AMG",
      "Maybach GLS600",
      "Metris",
      "S500",
      "S580",
      "SL63 AMG",
      "Sprinter 2500",
      "Sprinter 3500",
      "Sprinter 3500XD",
      "Sprinter 4500"
    ],
    "Mini": [
      "Cooper",
      "Cooper Clubman",
      "Cooper Countryman"
    ],
    "Mitsubishi": [
      "Eclipse Cross",
      "Mirage",
      "Outlander",
      "Outlander PHEV",
      "RVR"
    ],
    "Nissan": [
      "Altima",
      "Armada",
      "Frontier",
      "Kicks",
      "LEAF",
      "Maxima",
      "Murano",
      "Pathfinder",
      "Qashqai",
      "Rogue",
      "Rogue Sport",
      "Sentra",
      "TITAN",
      "TITAN XD",
      "Versa"
    ],
    "Polestar": [
      "Polestar 2"
    ],
    "Porsche": [
      "718 Boxster",
      "718 Cayman",
      "Cayenne",
      "Macan",
      "Panamera",
      "Taycan"
    ],
    "Ram": [
      "1500",
      "1500 Classic",
      "2500",
      "3500",
      "ProMaster 1500",
      "ProMaster 2500",
      "ProMaster 3500",
      "ProMaster City"
    ],
    "Rolls Royce": [
      "Cullinan"
    ],
    "Subaru": [
      "Ascent",
      "BRZ",
      "Crosstrek",
      "Forester",
      "Impreza",
      "Legacy",
      "Outback",
      "WRX"
    ],
    "Tesla": [
      "3",
      "S",
      "X",
      "Y"
    ],
    "Toyota": [
      "4Runner",
      "C-HR",
      "Camry",
      "Corolla",
      "Corolla Cross",
      "GR Supra",
      "GR86",
      "Highlander",
      "Mirai",
      "Prius",
      "Prius AWD-e",
      "Prius Prime",
      "RAV4",
      "RAV4 Prime",
      "Sequoia",
      "Sienna",
      "Tacoma",
      "Tundra",
      "Venza"
    ],
    "Volkswagen": [
      "Atlas",
      "Atlas Cross Sport",
      "Golf R",
      "GTI",
      "ID.4",
      "Jetta",
      "Passat",
      "Taos",
      "Tiguan"
    ],
    "Volvo": [
      "C40 Recharge",
      "S60",
      "S90",
      "V60",
      "V60 Cross Country",
      "V90 Cross Country",
      "XC40",
      "XC40 Recharge",
      "XC60",
      "XC90"
    ]
  },
  "2023": {
    "Acura": [
      "Integra",
      "MDX",
      "RDX",
      "TLX"
    ],
    "Audi": [
      "A3",
      "A3 Quattro",
      "A4 allroad",
      "A4 Quattro",
      "A5 Quattro",
      "A5 Sportback",
      "A6",
      "A6 allroad",
      "A6 Quattro",
      "A7 Sportback",
      "A8 Quattro",
      "e-tron GT",
      "e-tron Quattro",
      "e-tron Sportback",
      "Q3",
      "Q4 e-tron",
      "Q4 e-tron Sportback",
      "Q5",
      "Q5 PHEV",
      "Q5 Sportback",
      "Q7",
      "Q8",
      "R8",
      "RS e-tron GT",
      "RS Q8",
      "RS5",
      "RS6 Avant",
      "RS7 Sportback",
      "S3",
      "S4",
      "S5",
      "S6",
      "S7 Sportback",
      "S8",
      "SQ5",
      "SQ5 Sportback",
      "SQ7",
      "SQ8",
      "TT Quattro",
      "TT RS Quattro",
      "TTS Quattro"
    ],
    "BMW": [
      "228i xDrive Gran Coupe",
      "230i xDrive",
      "330e",
      "330e xDrive",
      "330i",
      "330i xDrive",
      "430i xDrive",
      "430i xDrive Gran Coupe",
      "530e xDrive",
      "530i xDrive",
      "540i xDrive",
      "760i xDrive",
      "Alpina B8 Gran Coupe",
      "Alpina XB7",
      "i4",
      "i7",
      "M235i xDrive Gran Coupe",
      "M240i xDrive",
      "M3",
      "M340i xDrive",
      "M440i xDrive",
      "M440i xDrive Gran Coupe",
      "M5",
      "M550i xDrive",
      "M8",
      "M850i xDrive",
      "M850i xDrive Gran Coupe",
      "X1",
      "X2",
      "X3",
      "X4",
      "X5",
      "X6",
      "X7",
      "XM",
      "Z4"
    ],
    "Buick": [
      "Enclave",
      "Encore GX",
      "Envision"
    ],
    "Cadillac": [
      "CT4",
      "CT5",
      "Escalade",
      "Escalade ESV",
      "LYRIQ",
      "XT4",
      "XT5",
      "XT6"
    ],
    "Chevrolet": [
      "Blazer",
      "Bolt EUV",
      "Bolt EV",
      "Camaro",
      "Colorado",
      "Corvette",
      "Equinox",
      "Express 2500",
      "Express 3500",
      "Malibu",
      "Silverado 1500",
      "Silverado 2500 HD",
      "Silverado 3500 HD",
      "Suburban",
      "Tahoe",
      "Trailblazer",
      "Traverse"
    ],
    "Chrysler": [
      "300",
      "Grand Caravan",
      "Pacifica"
    ],
    "Dodge": [
      "Challenger",
      "Charger",
      "Durango",
      "Hornet"
    ],
    "Fiat": [
      "500X"
    ],
    "Ford": [
      "Bronco",
      "Bronco Sport",
      "E-350 Super Duty",
      "E-450 Super Duty",
      "E-Transit",
      "Edge",
      "Escape",
      "Expedition",
      "Explorer",
      "F-150",
      "F-150 Lightning",
      "F-250 Super Duty",
      "F-350 Super Duty",
      "F-450 Super Duty",
      "Maverick",
      "Mustang",
      "Mustang Mach-E",
      "Police Interceptor Utility",
      "Ranger",
      "Transit Connect",
      "Transit-150",
      "Transit-250",
      "Transit-350",
      "Transit-350 HD"
    ],
    "Genesis": [
      "G70",
      "G80",
      "G90",
      "GV60",
      "GV70",
      "GV80"
    ],
    "GMC": [
      "Acadia",
      "Canyon",
      "Hummer EV Pickup",
      "Savana 2500",
      "Savana 3500",
      "Sierra 1500",
      "Sierra 2500 HD",
      "Sierra 3500 HD",
      "Terrain",
      "Yukon",
      "Yukon XL"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "CR-V",
      "HR-V",
      "Odyssey",
      "Passport",
      "Pilot",
      "Ridgeline"
    ],
    "Hyundai": [
      "Elantra",
      "Elantra N",
      "Ioniq 5",
      "Ioniq 6",
      "Kona",
      "Kona Electric",
      "Kona N",
      "Nexo",
      "Palisade",
      "Santa Cruz",
      "Santa Fe",
      "Sonata",
      "Tucson",
      "Venue"
    ],
    "INFINITI": [
      "Q50",
      "QX50",
      "QX55",
      "QX60",
      "QX80"
    ],
    "Jaguar": [
      "E-Pace",
      "F-Pace",
      "F-Type",
      "I-Pace",
      "XF"
    ],
    "Jeep": [
      "Cherokee",
      "Compass",
      "Gladiator",
      "Grand Cherokee",
      "Grand Cherokee L",
      "Grand Wagoneer",
      "Grand Wagoneer L",
      "Renegade",
      "Wagoneer",
      "Wagoneer L",
      "Wrangler"
    ],
    "Kia": [
      "Carnival",
      "EV6",
      "Forte",
      "Forte5",
      "K5",
      "Niro",
      "Niro EV",
      "Rio",
      "Seltos",
      "Sorento",
      "Soul",
      "Soul EV",
      "Sportage",
      "Stinger",
      "Telluride"
    ],
    "Land Rover": [
      "Defender 110",
      "Defender 130",
      "Defender 90",
      "Discovery",
      "Discovery Sport",
      "Range Rover",
      "Range Rover Evoque",
      "Range Rover Sport",
      "Range Rover Velar"
    ],
    "Lexus": [
      "ES250",
      "ES300h",
      "ES350",
      "GX460",
      "IS300",
      "IS350",
      "IS500",
      "LC500",
      "LC500h",
      "LS500",
      "LS500h",
      "LX600",
      "NX250",
      "NX350",
      "NX350h",
      "NX450h+",
      "RC F",
      "RC300",
      "RC350",
      "RX350",
      "RX350h",
      "RX500h",
      "RZ450e",
      "UX250h"
    ],
    "Lincoln": [
      "Aviator",
      "Corsair",
      "Nautilus",
      "Navigator"
    ],
    "Mazda": [
      "3",
      "CX-30",
      "CX-5",
      "CX-50",
      "CX-9",
      "MX-30 EV",
      "MX-5 Miata"
    ],
    "Mercedes-Benz": [
      "A35 AMG",
      "AMG GT 53",
      "AMG GT 63",
      "AMG GT 63 S",
      "C300",
      "C43 AMG",
      "CLA250",
      "CLA35 AMG",
      "CLA45 AMG",
      "CLS450",
      "CLS53 AMG",
      "E350",
      "E450",
      "E53 AMG",
      "E63 AMG S",
      "EQB 250+",
      "EQB 350",
      "EQE 350",
      "EQE 350 SUV",
      "EQE 500",
      "EQE 500 SUV",
      "EQE AMG",
      "EQS 450SUV",
      "EQS 580",
      "EQS 580SUV",
      "EQS AMG",
      "G500",
      "G550",
      "G63 AMG",
      "GLA250",
      "GLA35 AMG",
      "GLA45 AMG",
      "GLB250",
      "GLB35 AMG",
      "GLC300",
      "GLC43 AMG",
      "GLE350",
      "GLE450",
      "GLE53 AMG",
      "GLE63 AMG S",
      "GLS450",
      "GLS580",
      "GLS63 AMG",
      "Maybach GLS600",
      "Metris",
      "S500",
      "S580e",
      "SL43 AMG",
      "SL63 AMG",
      "Sprinter 2500",
      "Sprinter 3500",
      "Sprinter 4500"
    ],
    "Mini": [
      "Cooper",
      "Cooper Countryman"
    ],
    "Mitsubishi": [
      "Eclipse Cross",
      "Mirage",
      "Outlander",
      "Outlander PHEV",
      "RVR"
    ],
    "Nissan": [
      "Altima",
      "ARIYA",
      "Armada",
      "Frontier",
      "Kicks",
      "LEAF",
      "Maxima",
      "Murano",
      "Pathfinder",
      "Qashqai",
      "Rogue",
      "Sentra",
      "TITAN XD",
      "Versa",
      "Z"
    ],
    "Polestar": [
      "Polestar 2"
    ],
    "Porsche": [
      "718 Boxster",
      "718 Cayman",
      "911",
      "Cayenne",
      "Macan",
      "Panamera"
    ],
    "Ram": [
      "1500",
      "1500 Classic",
      "2500",
      "3500",
      "ProMaster 1500",
      "ProMaster 2500",
      "ProMaster 3500"
    ],
    "Subaru": [
      "Ascent",
      "BRZ",
      "Crosstrek",
      "Forester",
      "Impreza",
      "Legacy",
      "Outback",
      "Solterra",
      "WRX"
    ],
    "Tesla": [
      "3",
      "S",
      "X",
      "Y"
    ],
    "Toyota": [
      "4Runner",
      "bZ4X",
      "Camry",
      "Corolla",
      "Corolla Cross",
      "Crown",
      "GR Corolla",
      "GR Supra",
      "GR86",
      "Highlander",
      "Mirai",
      "Prius AWD-e",
      "Prius Prime",
      "RAV4",
      "RAV4 Prime",
      "Sequoia",
      "Sienna",
      "Tacoma",
      "Tundra",
      "Venza"
    ],
    "Volkswagen": [
      "Atlas",
      "Atlas Cross Sport",
      "Golf R",
      "GTI",
      "ID.4",
      "Jetta",
      "Taos",
      "Tiguan"
    ],
    "Volvo": [
      "C40 Recharge",
      "S60",
      "S90",
      "V60",
      "V60 Cross Country",
      "V90 Cross Country",
      "XC40",
      "XC40 Recharge",
      "XC60",
      "XC90"
    ]
  },
  "2024": {
    "Acura": [
      "Integra",
      "MDX",
      "RDX"
    ],
    "Audi": [
      "A3",
      "A3 Quattro",
      "A4",
      "A4 allroad",
      "A4 Quattro",
      "A5",
      "A5 Quattro",
      "A5 Sportback",
      "A6",
      "A6 allroad",
      "A6 Quattro",
      "A7 Sportback",
      "A8 Quattro",
      "Q3",
      "Q4 e-tron",
      "Q5",
      "Q5 PHEV",
      "Q5 Sportback",
      "Q7",
      "Q8",
      "Q8 e-tron",
      "Q8 e-tron Sportback",
      "RS Q8",
      "RS5",
      "RS6 Avant",
      "RS7 Sportback",
      "S3",
      "S4",
      "S5",
      "S6",
      "S7 Sportback",
      "S8",
      "SQ5",
      "SQ5 Sportback",
      "SQ7",
      "SQ8",
      "SQ8 e-tron",
      "SQ8 e-tron Sportback"
    ],
    "BMW": [
      "228i xDrive Gran Coupe",
      "230i xDrive",
      "330e",
      "330e xDrive",
      "330i xDrive",
      "430i xDrive",
      "530e",
      "530i xDrive",
      "750e xDrive",
      "760i xDrive",
      "Alpina B8 Gran Coupe",
      "Alpina XB7",
      "i4",
      "i5",
      "i7",
      "M240i xDrive",
      "M3",
      "M340i xDrive",
      "M440i xDrive",
      "M440i xDrive Gran Coupe",
      "M8",
      "M850i xDrive",
      "X1",
      "X2",
      "X3",
      "X4",
      "X5",
      "X6",
      "X7",
      "XM",
      "Z4"
    ],
    "Buick": [
      "Enclave",
      "Encore GX",
      "Envision",
      "Envista"
    ],
    "Cadillac": [
      "CT4",
      "CT5",
      "Escalade",
      "Escalade ESV",
      "XT4",
      "XT5",
      "XT6"
    ],
    "Chevrolet": [
      "Blazer",
      "Colorado",
      "Equinox",
      "Express 2500",
      "Express 3500",
      "Malibu",
      "Silverado 1500",
      "Silverado 2500 HD",
      "Silverado 3500 HD",
      "Suburban",
      "Tahoe",
      "Trailblazer",
      "Trax"
    ],
    "Chrysler": [
      "Grand Caravan",
      "Pacifica"
    ],
    "Dodge": [
      "Hornet"
    ],
    "Ford": [
      "Bronco",
      "Bronco Sport",
      "E-350 Super Duty",
      "E-450 Super Duty",
      "Escape",
      "Expedition",
      "Explorer",
      "F-150",
      "F-150 Lightning",
      "F-250 Super Duty",
      "F-350 Super Duty",
      "F-450 Super Duty",
      "Maverick",
      "Mustang",
      "Mustang Mach-E",
      "Police Interceptor Utility",
      "Ranger",
      "Transit-150",
      "Transit-250",
      "Transit-350",
      "Transit-350 HD"
    ],
    "Genesis": [
      "G70",
      "G80",
      "G90",
      "GV60",
      "GV80"
    ],
    "GMC": [
      "Canyon",
      "Hummer EV Pickup",
      "Hummer EV SUV",
      "Savana 2500",
      "Savana 3500",
      "Sierra 1500",
      "Sierra 2500 HD",
      "Sierra 3500 HD",
      "Terrain",
      "Yukon",
      "Yukon XL"
    ],
    "Honda": [
      "Accord",
      "Civic",
      "CR-V",
      "HR-V",
      "Odyssey",
      "Passport",
      "Pilot",
      "Ridgeline"
    ],
    "Hyundai": [
      "Elantra",
      "Elantra N",
      "Ioniq 5",
      "Ioniq 6",
      "Kona",
      "Palisade",
      "Santa Cruz",
      "Santa Fe",
      "Sonata",
      "Tucson",
      "Venue"
    ],
    "INFINITI": [
      "Q50",
      "QX50",
      "QX55",
      "QX60",
      "QX80"
    ],
    "Jaguar": [
      "E-Pace",
      "F-Pace",
      "F-Type",
      "I-Pace",
      "XF"
    ],
    "Jeep": [
      "Gladiator",
      "Grand Cherokee",
      "Grand Wagoneer",
      "Grand Wagoneer L",
      "Wagoneer",
      "Wagoneer L",
      "Wrangler"
    ],
    "Kia": [
      "Carnival",
      "EV6",
      "EV9",
      "Forte",
      "K5",
      "Niro",
      "Seltos",
      "Sorento",
      "Soul",
      "Sportage",
      "Telluride"
    ],
    "Land Rover": [
      "Defender 110",
      "Defender 130",
      "Defender 90",
      "Discovery",
      "Discovery Sport",
      "Range Rover",
      "Range Rover Evoque",
      "Range Rover Sport",
      "Range Rover Velar"
    ],
    "Lexus": [
      "ES250",
      "ES300h",
      "ES350",
      "IS300",
      "IS350",
      "IS500",
      "LC500",
      "LC500h",
      "RC F",
      "RC300",
      "RC350",
      "RX450h",
      "RX500h",
      "RZ300e",
      "RZ450e",
      "TX350",
      "TX500h",
      "TX550h",
      "UX250h"
    ],
    "Lincoln": [
      "Aviator",
      "Corsair",
      "Navigator"
    ],
    "Mazda": [
      "3",
      "CX-30",
      "CX-50",
      "CX-90",
      "MX-5 Miata"
    ],
    "Mercedes-Benz": [
      "AMG GT 63",
      "AMG GT55",
      "C300",
      "C43 AMG",
      "CLA250",
      "CLA35 AMG",
      "CLE300",
      "CLE450",
      "E350",
      "EQB 250+",
      "EQB 300",
      "EQE 350",
      "EQE 350 SUV",
      "EQE 500",
      "EQE 500 SUV",
      "EQE AMG",
      "EQE SUV AMG",
      "EQS 450",
      "EQS 450 SUV",
      "EQS 580",
      "EQS 580 SUV",
      "EQS AMG",
      "G550",
      "G63 AMG",
      "GLA250",
      "GLA35 AMG",
      "GLB250",
      "GLB35 AMG",
      "GLC300",
      "GLC43 AMG",
      "GLE350",
      "GLE450",
      "GLE450e",
      "GLE53 AMG",
      "GLE580",
      "GLE63 AMG S",
      "GLS450",
      "GLS580",
      "GLS63 AMG",
      "Maybach GLS600",
      "S580",
      "S580e",
      "SL43 AMG",
      "SL55 AMG",
      "SL63 AMG",
      "Sprinter 2500",
      "Sprinter 3500",
      "Sprinter 4500"
    ],
    "Mini": [
      "Cooper",
      "Cooper Countryman"
    ],
    "Mitsubishi": [
      "Eclipse Cross",
      "Mirage",
      "Outlander",
      "Outlander PHEV",
      "RVR"
    ],
    "Nissan": [
      "Altima",
      "Armada",
      "Frontier",
      "Kicks",
      "Murano",
      "Pathfinder",
      "Rogue",
      "Sentra",
      "TITAN XD",
      "Versa",
      "Z"
    ],
    "Polestar": [
      "Polestar 2"
    ],
    "Porsche": [
      "718 Boxster",
      "718 Cayman",
      "911",
      "Cayenne",
      "Macan",
      "Panamera",
      "Taycan"
    ],
    "Ram": [
      "1500",
      "1500 Classic",
      "2500",
      "3500",
      "ProMaster 1500",
      "ProMaster 2500",
      "ProMaster 3500",
      "ProMaster EV"
    ],
    "Subaru": [
      "Ascent",
      "Crosstrek",
      "Forester",
      "Legacy",
      "Outback",
      "Solterra",
      "WRX"
    ],
    "Toyota": [
      "4Runner",
      "bZ4X",
      "Camry",
      "Corolla",
      "Corolla Cross",
      "GR Corolla",
      "GR Supra",
      "Highlander",
      "Land Cruiser",
      "Mirai",
      "Prius AWD-e",
      "Prius Prime",
      "RAV4",
      "RAV4 Prime",
      "Sequoia",
      "Sienna",
      "Tacoma",
      "Tundra",
      "Venza"
    ],
    "Volkswagen": [
      "Atlas",
      "Atlas Cross Sport",
      "Cross Sport",
      "Golf R",
      "GTI",
      "Jetta",
      "Taos",
      "Tiguan"
    ],
    "Volvo": [
      "C40 Recharge",
      "S60",
      "S90",
      "V60",
      "V60 Cross Country",
      "V90 Cross Country",
      "XC40",
      "XC40 Recharge",
      "XC60",
      "XC90"
    ]
  },
  "2025": {
    "Audi": [
      "RS3"
    ],
    "Chrysler": [
      "Grand Caravan",
      "Pacifica",
      "Voyager"
    ],
    "Dodge": [
      "Durango"
    ],
    "Ford": [
      "Bronco",
      "Bronco Sport",
      "E-Transit",
      "Escape",
      "Explorer",
      "F-150",
      "F-150 Lightning",
      "F-250 Super Duty",
      "F-350 Super Duty",
      "F-450 Super Duty",
      "F-550 Super Duty",
      "Maverick",
      "Mustang",
      "Mustang Mach-E",
      "Ranger",
      "Transit 150",
      "Transit 250",
      "Transit 350",
      "Transit 350 HD"
    ],
    "Genesis": [
      "G70",
      "G80",
      "G90",
      "GV60",
      "GV70",
      "GV80",
      "GV80 Coupe"
    ],
    "GMC": [
      "Hummer EV Pickup",
      "Hummer EV SUV",
      "Savana 4500"
    ],
    "Hyundai": [
      "Elantra",
      "Elantra N",
      "Ioniq 5",
      "Ioniq 5 N",
      "Ioniq 6",
      "Kona",
      "Kona Electric",
      "Palisade",
      "Santa Cruz",
      "Santa Fe",
      "Sonata",
      "Tucson",
      "Venue"
    ],
    "Infiniti": [
      "QX55",
      "QX60",
      "QX80"
    ],
    "Jaguar": [
      "F-Pace",
      "I-Pace"
    ],
    "Jeep": [
      "Gladiator",
      "Grand Wagoneer",
      "Grand Wagoneer L",
      "Wagoneer",
      "Wagoneer L"
    ],
    "Kia": [
      "Carnival",
      "EV6",
      "EV9",
      "K5",
      "Niro",
      "Niro EV",
      "Seltos",
      "Sorento",
      "Soul",
      "Sportage",
      "Telluride"
    ],
    "Land Rover": [
      "Defender 110",
      "Defender 130",
      "Defender 90",
      "Discovery",
      "Range Rover",
      "Range Rover Evoque",
      "Range Rover Sport",
      "Range Rover Velar"
    ],
    "Lexus": [
      "ES250",
      "ES300h",
      "ES350",
      "NX250",
      "NX350",
      "NX350h",
      "NX450h",
      "RX350",
      "RX350h",
      "RX450h",
      "RX500h",
      "RZ300e",
      "Rz450e",
      "TX350",
      "TX500h",
      "TX550h",
      "UX300h"
    ],
    "Lincoln": [
      "Aviator",
      "Corsair",
      "Nautilus",
      "Navigator"
    ],
    "Mazda": [
      "CX-30",
      "CX-5",
      "CX-50",
      "CX-90",
      "MX-5 Miata"
    ],
    "Mercedes-Benz": [
      "AMG GT 55",
      "AMG GT 63",
      "C300",
      "C43 AMG",
      "CLA250",
      "CLA35 AMG",
      "CLE300",
      "CLE450",
      "E350",
      "E450",
      "E53 AMG",
      "EQB 250",
      "EQB 350",
      "G550",
      "G63 AMG",
      "GLA35 AMG",
      "GLB250",
      "GLB35 AMG",
      "GLE350",
      "GLE63 AMG S",
      "GLS 63 AMG",
      "GLS580",
      "SL43 AMG",
      "SL55 AMG",
      "SL63 AMG",
      "Sprinter 2500",
      "Sprinter 3500",
      "Sprinter 3500XD"
    ],
    "Mitsubishi": [
      "Eclipse Cross",
      "Outlander",
      "Outlander PHEV",
      "RVR"
    ],
    "Nissan": [
      "Altima",
      "Frontier",
      "Kicks",
      "LEAF",
      "Pathfinder",
      "Rogue",
      "Sentra",
      "Versa"
    ],
    "Polestar": [
      "Polestar 2"
    ],
    "Porsche": [
      "718 Boxster",
      "718 Cayman",
      "718 Spyder",
      "911",
      "Cayenne"
    ],
    "Ram": [
      "1500",
      "ProMaster 1500",
      "ProMaster 2500",
      "ProMaster 3500",
      "ProMaster EV"
    ],
    "Subaru": [
      "Ascent",
      "BRZ",
      "Crosstrek",
      "Forester",
      "Impreza",
      "Legacy",
      "Outback",
      "WRX"
    ],
    "Tesla": [
      "3",
      "Y"
    ],
    "Toyota": [
      "Camry",
      "Corolla",
      "Corolla Cross",
      "Crown",
      "Crown Signia",
      "GR Corolla",
      "GR Supra",
      "GR86",
      "Grand Highlander",
      "Highlander",
      "Land Cruiser",
      "Mirai",
      "Prius",
      "RAV4",
      "Sienna",
      "Tacoma"
    ],
    "Volkswagen": [
      "Atlas",
      "Atlas Cross Sport",
      "Golf R",
      "GTI",
      "Jetta",
      "Taos"
    ],
    "Volvo": [
      "S60",
      "S90",
      "V60",
      "V60 Cross Country",
      "V90 Cross Country",
      "XC40",
      "XC60",
      "XC90"
    ]
  }
};